var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/regex.ts
var tzComponent = /\.[-A-Za-z_]|\.\.[-A-Za-z._]{1,12}|\.[-A-Za-z_][-A-Za-z._]{0,12}|[A-Za-z_][-A-Za-z._]{0,13}/;
var offsetNoCapture = /(?:[+\u2212-][0-2][0-9](?::?[0-5][0-9](?::?[0-5][0-9](?:[.,]\d{1,9})?)?)?)/;
var timeZoneID = new RegExp(
  `(?:(?:${tzComponent.source})(?:\\/(?:${tzComponent.source}))*|Etc/GMT[-+]\\d{1,2}|${offsetNoCapture.source})`
);
var yearpart = /(?:[+\u2212-]\d{6}|\d{4})/;
var monthpart = /(?:0[1-9]|1[0-2])/;
var daypart = /(?:0[1-9]|[12]\d|3[01])/;
var datesplit = new RegExp(
  `(${yearpart.source})(?:-(${monthpart.source})-(${daypart.source})|(${monthpart.source})(${daypart.source}))`
);
var timesplit = /(\d{2})(?::(\d{2})(?::(\d{2})(?:[.,](\d{1,9}))?)?|(\d{2})(?:(\d{2})(?:[.,](\d{1,9}))?)?)?/;
var offset = /([+\u2212-])([01][0-9]|2[0-3])(?::?([0-5][0-9])(?::?([0-5][0-9])(?:[.,](\d{1,9}))?)?)?/;
var zonesplit = new RegExp(`(?:([zZ])|(?:${offset.source})?)(?:\\[(${timeZoneID.source})\\])?`);
var instant = new RegExp(`^${datesplit.source}(?:(?:T|\\s+)${timesplit.source})?${zonesplit.source}$`, "i");
var datetime = new RegExp(`^${datesplit.source}(?:(?:T|\\s+)${timesplit.source})?(?:${zonesplit.source})$`, "i");
var time = new RegExp(`^${timesplit.source}(?:${zonesplit.source})?$`, "i");
var yearmonth = new RegExp(`^(${yearpart.source})-?(${monthpart.source})$`);
var monthday = new RegExp(`^(?:--)?(${monthpart.source})-?(${daypart.source})$`);
var fraction = /(\d+)(?:[.,](\d{1,9}))?/;
var durationDate = /(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?/;
var durationTime = new RegExp(`(?:${fraction.source}H)?(?:${fraction.source}M)?(?:${fraction.source}S)?`);
var duration = new RegExp(`^([+\u2212-])?P${durationDate.source}(?:T(?!$)${durationTime.source})?$`, "i");

// src/ecmascript.ts
function buildChain(value) {
  return {
    value() {
      return value;
    }
  };
}
var IntlDateTimeFormat = globalThis.Intl.DateTimeFormat;
var MathMin = Math.min;
var MathMax = Math.max;
var MathAbs = Math.abs;
var MathFloor = Math.floor;
var MathSign = Math.sign;
var MathTrunc = Math.trunc;
var NumberIsNaN = Number.isNaN;
var NumberIsFinite = Number.isFinite;
var NumberCtor = Number;
var NumberMaxSafeInteger = Number.MAX_SAFE_INTEGER;
var ObjectCreate = Object.create;
var ObjectIs = Object.is;
var ObjectKeys = Object.keys;
var DAY_SECONDS = 86400;
var DAY_MILLIS = DAY_SECONDS * 1e3;
var MS_MIN = -DAY_SECONDS * 1e11;
var MS_MAX = DAY_SECONDS * 1e11;
var BEFORE_FIRST_DST = -388152 * 1e7;
var YEAR_MIN = -271821;
var YEAR_MAX = 275760;
function IsInteger(value) {
  if (typeof value !== "number" || !NumberIsFinite(value)) return false;
  const abs = MathAbs(value);
  return MathFloor(abs) === abs;
}
function IsObject(value) {
  return typeof value === "object" && value !== null || typeof value === "function";
}
function ToNumber(value) {
  if (typeof value === "bigint") throw new TypeError("Cannot convert BigInt to number");
  return NumberCtor(value);
}
function ToInteger(value) {
  const num = ToNumber(value);
  if (NumberIsNaN(num)) return 0;
  const integer = MathTrunc(num);
  if (num === 0) return 0;
  return integer;
}
function ToString(value) {
  if (typeof value === "symbol") {
    throw new TypeError("Cannot convert a Symbol value to a String");
  }
  return String(value);
}
function ToIntegerThrowOnInfinity(value) {
  const integer = ToInteger(value);
  if (!NumberIsFinite(integer)) {
    throw new RangeError("infinity is out of range");
  }
  return integer;
}
function ToPositiveInteger(valueParam, property) {
  const value = ToInteger(valueParam);
  if (!NumberIsFinite(value)) {
    throw new RangeError("infinity is out of range");
  }
  if (value < 1) {
    if (property !== void 0) {
      throw new RangeError(`property '${property}' cannot be a a number less than one`);
    }
    throw new RangeError("Cannot convert a number less than one to a positive integer");
  }
  return value;
}
function ToIntegerNoFraction(valueParam) {
  const value = ToNumber(valueParam);
  if (!IsInteger(value)) {
    throw new RangeError(`unsupported fractional value ${value}`);
  }
  return value;
}
var BUILTIN_CASTS = /* @__PURE__ */ new Map([
  ["year", ToIntegerThrowOnInfinity],
  ["month", ToPositiveInteger],
  ["day", ToPositiveInteger],
  ["hour", ToIntegerThrowOnInfinity],
  ["minute", ToIntegerThrowOnInfinity],
  ["second", ToIntegerThrowOnInfinity],
  ["millisecond", ToIntegerThrowOnInfinity],
  ["years", ToIntegerNoFraction],
  ["months", ToIntegerNoFraction],
  ["weeks", ToIntegerNoFraction],
  ["days", ToIntegerNoFraction],
  ["hours", ToIntegerNoFraction],
  ["minutes", ToIntegerNoFraction],
  ["seconds", ToIntegerNoFraction],
  ["milliseconds", ToIntegerNoFraction],
  ["era", ToString],
  ["eraYear", ToInteger],
  ["offset", ToString]
]);
var ALLOWED_UNITS = ["year", "month", "week", "day", "hour", "minute", "second", "millisecond"];
var SINGULAR_PLURAL_UNITS = [
  ["years", "year"],
  ["months", "month"],
  ["weeks", "week"],
  ["days", "day"],
  ["hours", "hour"],
  ["minutes", "minute"],
  ["seconds", "second"],
  ["milliseconds", "millisecond"]
];
var IntlDateTimeFormatEnUsCache = /* @__PURE__ */ new Map();
function getIntlDateTimeFormatEnUsForTimeZone(timeZoneIdentifier) {
  let instance = IntlDateTimeFormatEnUsCache.get(timeZoneIdentifier);
  if (instance === void 0) {
    instance = new IntlDateTimeFormat("en-us", {
      timeZone: String(timeZoneIdentifier),
      hour12: false,
      era: "short",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    });
    IntlDateTimeFormatEnUsCache.set(timeZoneIdentifier, instance);
  }
  return instance;
}
var timeZoneAbbreviationCache = /* @__PURE__ */ new Map();
function GetTimeZoneAbbreviation(timeZone, epochMilliseconds) {
  let instance = timeZoneAbbreviationCache.get(timeZone);
  if (instance === void 0) {
    const fullFormat = new IntlDateTimeFormat("en-us", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "numeric",
      hour12: false,
      weekday: "short",
      timeZoneName: "short",
      timeZone
    }).format(new Date(epochMilliseconds));
    const split = fullFormat.split(" ");
    instance = split[split.length - 1];
    timeZoneAbbreviationCache.set(timeZone, instance);
  }
  return instance;
}
var timeZoneFullNameCache = /* @__PURE__ */ new Map();
function GetTimeZoneName(timeZone, epochMilliseconds) {
  let instance = timeZoneFullNameCache.get(timeZone);
  if (instance === void 0) {
    const fullFormat = new IntlDateTimeFormat("en-us", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "numeric",
      hour12: false,
      weekday: "short",
      timeZoneName: "long",
      timeZone
    }).format(new Date(epochMilliseconds));
    const split = fullFormat.split(" ");
    instance = split.slice(3).join(" ");
    timeZoneFullNameCache.set(timeZone, instance);
  }
  return instance;
}
function IsTemporalInstant(item) {
  try {
    const stringifiedMs1 = new Date(item).toISOString();
    const stringifiedMs10 = stringifiedMs1.replace("0Z", "Z");
    const stringifiedMs100 = stringifiedMs1.replace("00Z", "Z");
    const stringifiedS = stringifiedMs1.replace(".000Z", "Z");
    const stringifiedM = stringifiedMs1.replace(":00.000Z", "Z");
    return [stringifiedMs1, stringifiedMs10, stringifiedMs100, stringifiedS, stringifiedM].includes(item);
  } catch (e) {
    return false;
  }
}
function IsTemporalTimeZone(item) {
  try {
    return GetCanonicalTimeZoneIdentifier(item) === item;
  } catch (e) {
    return false;
  }
}
function IsTemporalDuration(item) {
  try {
    const slots = GetDurationSlots(item);
    const created = CreateTemporalDuration(
      slots.years,
      slots.months,
      slots.weeks,
      slots.days,
      slots.hours,
      slots.minutes,
      slots.seconds,
      slots.milliseconds
    );
    return created === item;
  } catch (e) {
    return false;
  }
}
function AssertIsDuration(item) {
  if (!IsTemporalDuration(item)) throw new TypeError(`Invalid Duration: ${item} is not a duration`);
}
function IsTemporalDate(item) {
  try {
    const slots = GetDateSlots(item);
    return CreateTemporalDate(slots.year, slots.month, slots.day) === item;
  } catch (e) {
    return false;
  }
}
function IsTemporalTime(item) {
  try {
    const slots = GetTimeSlots(item);
    const precision = GetTimePrecision(item);
    const created = CreateTemporalTime(slots.hour, slots.minute, slots.second, slots.millisecond, { precision });
    return created === item;
  } catch (e) {
    return false;
  }
}
function IsTemporalDateTime(item) {
  try {
    const slots = GetDateTimeSlots(item);
    const time2 = item.split("T")[1];
    const precision = GetTimePrecision(time2);
    const created = CreateTemporalDateTime(
      slots.year,
      slots.month,
      slots.day,
      slots.hour,
      slots.minute,
      slots.second,
      slots.millisecond,
      { precision }
    );
    return created === item;
  } catch (e) {
    return false;
  }
}
function IsTemporalYearMonth(item) {
  try {
    const slots = GetYearMonthSlots(item);
    return CreateTemporalYearMonth(slots.year, slots.month) === item;
  } catch (e) {
    return false;
  }
}
function IsTemporalMonthDay(item) {
  try {
    const slots = GetMonthDaySlots(item);
    return CreateTemporalMonthDay(slots.month, slots.day) === item;
  } catch (e) {
    return false;
  }
}
function IsTemporalZonedDateTime(item) {
  try {
    const rawNoDate = item.split("T")[1];
    const rawTime = rawNoDate.includes("+") ? rawNoDate.split("+")[0] : rawNoDate.split("-")[0];
    const precision = GetTimePrecision(rawTime);
    const slots = GetZonedDateTimeSlots(item);
    const time2 = CreateTemporalTime(slots.hour, slots.minute, slots.second, slots.millisecond, { precision });
    const created = CreateTemporalZonedDateTime(slots.epochMilliseconds, slots.timeZone);
    const [dirtyDateTime, dirtyTimeZone] = created.split("[");
    const timeZone = dirtyTimeZone.replace("]", "");
    const offsetStr = dirtyDateTime.substring(dirtyDateTime.length - 6, dirtyDateTime.length);
    const dateTime2 = dirtyDateTime.substring(0, dirtyDateTime.length - 6);
    const [date] = dateTime2.split("T");
    return `${date}T${time2}${offsetStr}[${timeZone}]` === item;
  } catch (e) {
    return false;
  }
}
function TemporalTimeZoneFromString(stringIdent) {
  let { ianaName, offset: offset2, z } = ParseTemporalTimeZoneString(stringIdent);
  let identifier = ianaName;
  if (!identifier && z) identifier = "UTC";
  if (!identifier) identifier = offset2;
  const result = GetCanonicalTimeZoneIdentifier(identifier);
  if (offset2 && identifier !== offset2) {
    const ns = ParseTemporalInstant(stringIdent);
    const offsetMs = GetIANATimeZoneOffsetMilliseconds(ns, result);
    if (FormatTimeZoneOffsetString(offsetMs) !== offset2) {
      throw new RangeError(`invalid offset ${offset2}[${ianaName}]`);
    }
  }
  return result;
}
function ParseISODateTime(isoString, { zoneRequired }) {
  const regex = zoneRequired ? instant : datetime;
  const match = regex.exec(isoString);
  if (!match) throw new RangeError(`invalid ISO 8601 string: ${isoString}`);
  let yearString = match[1];
  if (yearString[0] === "\u2212") yearString = `-${yearString.slice(1)}`;
  const year = ToInteger(yearString);
  const month = ToInteger(match[2] || match[4]);
  const day = ToInteger(match[3] || match[5]);
  const hour = ToInteger(match[6]);
  const minute = ToInteger(match[7] || match[10]);
  let second = ToInteger(match[8] || match[11]);
  if (second === 60) second = 59;
  const fraction2 = (match[9] || match[12]) + "000000000";
  const millisecond = ToInteger(fraction2.slice(0, 3));
  let offset2;
  let z = false;
  if (match[13]) {
    offset2 = void 0;
    z = true;
  } else if (match[14] && match[15]) {
    const offsetSign = match[14] === "-" || match[14] === "\u2212" ? "-" : "+";
    const offsetHours = match[15] || "00";
    const offsetMinutes = match[16] || "00";
    const offsetSeconds = match[17] || "00";
    let offsetFraction = match[18] || "0";
    offset2 = `${offsetSign}${offsetHours}:${offsetMinutes}`;
    if (+offsetFraction) {
      while (offsetFraction.endsWith("0")) offsetFraction = offsetFraction.slice(0, -1);
      offset2 += `:${offsetSeconds}.${offsetFraction}`;
    } else if (+offsetSeconds) {
      offset2 += `:${offsetSeconds}`;
    }
    if (offset2 === "-00:00") offset2 = "+00:00";
  }
  let ianaName = match[19];
  if (ianaName) {
    try {
      ianaName = GetCanonicalTimeZoneIdentifier(ianaName).toString();
    } catch (e) {
    }
  }
  return {
    year,
    month,
    day,
    hour,
    minute,
    second,
    millisecond,
    ianaName,
    offset: offset2,
    z
  };
}
function ParseTemporalInstantString(isoString) {
  return ParseISODateTime(isoString, { zoneRequired: true });
}
function ParseTemporalZonedDateTimeString(isoString) {
  return ParseISODateTime(isoString, { zoneRequired: true });
}
function ParseTemporalDateTimeString(isoString) {
  return ParseISODateTime(isoString, { zoneRequired: false });
}
function ParseTemporalDateString(isoString) {
  return ParseISODateTime(isoString, { zoneRequired: false });
}
function ParseTemporalTimeString(isoString) {
  const match = time.exec(isoString);
  let hour, minute, second, millisecond;
  if (match) {
    hour = ToInteger(match[1]);
    minute = ToInteger(match[2] || match[5]);
    second = ToInteger(match[3] || match[6]);
    if (second === 60) second = 59;
    const fraction2 = (match[4] || match[7]) + "000000000";
    millisecond = ToInteger(fraction2.slice(0, 3));
  } else {
    ;
    ({ hour, minute, second, millisecond } = ParseISODateTime(isoString, {
      zoneRequired: false
    }));
  }
  return { hour, minute, second, millisecond };
}
function ParseTemporalYearMonthString(isoString) {
  const match = yearmonth.exec(isoString);
  let year, month, referenceISODay;
  if (match) {
    let yearString = match[1];
    if (yearString[0] === "\u2212") yearString = `-${yearString.slice(1)}`;
    year = ToInteger(yearString);
    month = ToInteger(match[2]);
  } else {
    ;
    ({ year, month, day: referenceISODay } = ParseISODateTime(isoString, { zoneRequired: false }));
  }
  return { year, month, referenceISODay };
}
function ParseTemporalMonthDayString(isoString) {
  const match = monthday.exec(isoString);
  let month, day, referenceISOYear;
  if (match) {
    month = ToInteger(match[1]);
    day = ToInteger(match[2]);
  } else {
    ;
    ({ month, day, year: referenceISOYear } = ParseISODateTime(isoString, { zoneRequired: false }));
  }
  return { month, day, referenceISOYear };
}
function ParseTemporalTimeZoneString(stringIdent) {
  try {
    let canonicalIdent = GetCanonicalTimeZoneIdentifier(stringIdent);
    if (canonicalIdent) {
      canonicalIdent = canonicalIdent.toString();
      if (ParseOffsetString(canonicalIdent) !== null) return { offset: canonicalIdent };
      return { ianaName: canonicalIdent };
    }
  } catch (e) {
  }
  try {
    return ParseISODateTime(stringIdent, { zoneRequired: true });
  } catch (e) {
    throw new RangeError(`Invalid time zone: ${stringIdent}`);
  }
}
function ParseTemporalDurationString(isoString) {
  const match = duration.exec(isoString);
  if (!match) throw new RangeError(`invalid duration: ${isoString}`);
  if (match.slice(2).every((element) => element === void 0)) {
    throw new RangeError(`invalid duration: ${isoString}`);
  }
  const sign = match[1] === "-" || match[1] === "\u2212" ? -1 : 1;
  const years = ToInteger(match[2]) * sign;
  const months = ToInteger(match[3]) * sign;
  const weeks = ToInteger(match[4]) * sign;
  const days = ToInteger(match[5]) * sign;
  const hours = ToInteger(match[6]) * sign;
  let fHours = match[7];
  let minutes = ToInteger(match[8]) * sign;
  let fMinutes = match[9];
  let seconds = ToInteger(match[10]) * sign;
  const fSeconds = match[11] + "000000000";
  let milliseconds = ToInteger(fSeconds.slice(0, 3)) * sign;
  fHours = fHours ? sign * ToInteger(fHours) / __pow(10, fHours.length) : 0;
  fMinutes = fMinutes ? sign * ToInteger(fMinutes) / __pow(10, fMinutes.length) : 0;
  ({ minutes, seconds, milliseconds } = DurationHandleFractions(fHours, minutes, fMinutes, seconds, milliseconds));
  return { years, months, weeks, days, hours, minutes, seconds, milliseconds };
}
function ParseTemporalInstant(isoString) {
  const { year, month, day, hour, minute, second, millisecond, offset: offset2, z } = ParseTemporalInstantString(isoString);
  const epochMs = GetEpochFromISOParts(year, month, day, hour, minute, second, millisecond);
  if (epochMs === null) throw new RangeError("DateTime outside of supported range");
  if (!z && !offset2) throw new RangeError("Temporal.Instant requires a time zone offset");
  const offsetMs = z ? 0 : ParseOffsetString(offset2);
  return epochMs - offsetMs;
}
function RegulateISODate(year, month, day, overflow) {
  switch (overflow) {
    case "reject":
      RejectISODate(year, month, day);
      break;
    case "constrain":
      ;
      ({ year, month, day } = ConstrainISODate(year, month, day));
      break;
  }
  return { year, month, day };
}
function RegulateTime(hour, minute, second, millisecond, overflow) {
  switch (overflow) {
    case "reject":
      RejectTime(hour, minute, second, millisecond);
      break;
    case "constrain":
      ;
      ({ hour, minute, second, millisecond } = ConstrainTime(hour, minute, second, millisecond));
      break;
  }
  return { hour, minute, second, millisecond };
}
function RegulateISOYearMonth(year, month, overflow) {
  const referenceISODay = 1;
  switch (overflow) {
    case "reject":
      RejectISODate(year, month, referenceISODay);
      break;
    case "constrain":
      ;
      ({ year, month } = ConstrainISODate(year, month));
      break;
  }
  return { year, month };
}
function DurationHandleFractions(fHours, minutes, fMinutes, seconds, milliseconds) {
  if (fHours !== 0) {
    ;
    [minutes, fMinutes, seconds, milliseconds].forEach((val) => {
      if (val !== 0) throw new RangeError("only the smallest unit can be fractional");
    });
    const mins = fHours * 60;
    minutes = MathTrunc(mins);
    fMinutes = mins % 1;
  }
  if (fMinutes !== 0) {
    ;
    [seconds, milliseconds].forEach((val) => {
      if (val !== 0) throw new RangeError("only the smallest unit can be fractional");
    });
    const secs = fMinutes * 60;
    seconds = MathTrunc(secs);
    const fSeconds = secs % 1;
    if (fSeconds !== 0) {
      const mils = fSeconds * 1e3;
      milliseconds = MathTrunc(mils);
      const fMilliseconds = mils % 1;
    }
  }
  return { minutes, seconds, milliseconds };
}
function ToTemporalDurationRecord(item) {
  if (IsTemporalDuration(item)) {
    return GetDurationSlots(item);
  }
  const props = ToPartialRecord(item, ["days", "hours", "milliseconds", "minutes", "months", "seconds", "weeks", "years"]);
  if (!props) throw new TypeError("invalid duration-like");
  const { years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0 } = props;
  return { years, months, weeks, days, hours, minutes, seconds, milliseconds };
}
function ToLimitedTemporalDuration(item, disallowedProperties = []) {
  let record;
  if (IsObject(item)) {
    record = ToTemporalDurationRecord(item);
  } else {
    const str = ToString(item);
    record = ParseTemporalDurationString(str);
  }
  const { years, months, weeks, days, hours, minutes, seconds, milliseconds } = record;
  RejectDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  for (const property of disallowedProperties) {
    if (record[property] !== 0) {
      throw new RangeError(
        `Duration field ${property} not supported by Temporal.Instant. Try Temporal.ZonedDateTime instead.`
      );
    }
  }
  return record;
}
function ToTemporalOverflow(options) {
  return GetOption(options, "overflow", ["constrain", "reject"], "constrain");
}
function ToTemporalDisambiguation(options) {
  return GetOption(options, "disambiguation", ["compatible", "earlier", "later", "reject"], "compatible");
}
function ToTemporalRoundingMode(options, fallback) {
  return GetOption(options, "roundingMode", ["ceil", "floor", "trunc", "halfExpand"], fallback);
}
function NegateTemporalRoundingMode(roundingMode) {
  switch (roundingMode) {
    case "ceil":
      return "floor";
    case "floor":
      return "ceil";
    default:
      return roundingMode;
  }
}
function ToTemporalOffset(options, fallback) {
  return GetOption(options, "offset", ["prefer", "use", "ignore", "reject"], fallback);
}
function ToTemporalRoundingIncrement(options, dividend, inclusive) {
  let maximum = Infinity;
  if (dividend !== void 0) maximum = dividend;
  if (!inclusive && dividend !== void 0) maximum = dividend > 1 ? dividend - 1 : 1;
  const increment = GetNumberOption(options, "roundingIncrement", 1, maximum, 1);
  if (dividend !== void 0 && dividend % increment !== 0) {
    throw new RangeError(`Rounding increment must divide evenly into ${dividend}`);
  }
  return increment;
}
function ToTemporalDateTimeRoundingIncrement(options, smallestUnit) {
  const maximumIncrements = {
    year: void 0,
    month: void 0,
    week: void 0,
    day: void 0,
    hour: 24,
    minute: 60,
    second: 60,
    millisecond: 1e3
  };
  return ToTemporalRoundingIncrement(options, maximumIncrements[smallestUnit], false);
}
function ToLargestTemporalUnit(options, fallback, disallowedStrings = [], autoValue) {
  const singular = new Map(SINGULAR_PLURAL_UNITS.filter(([, sing]) => !disallowedStrings.includes(sing)));
  const allowed = new Set(ALLOWED_UNITS);
  for (const s of disallowedStrings) {
    allowed.delete(s);
  }
  const retval = GetOption(options, "largestUnit", ["auto", ...allowed, ...singular.keys()], fallback);
  if (retval === "auto" && autoValue !== void 0) return autoValue;
  if (singular.has(retval)) return singular.get(retval);
  return retval;
}
function ToSmallestTemporalUnit(options, fallback, disallowedStrings = []) {
  const singular = new Map(SINGULAR_PLURAL_UNITS.filter(([, sing]) => !disallowedStrings.includes(sing)));
  const allowed = new Set(ALLOWED_UNITS);
  for (const s of disallowedStrings) {
    allowed.delete(s);
  }
  const value = GetOption(options, "smallestUnit", [...allowed, ...singular.keys()], fallback);
  if (singular.has(value)) return singular.get(value);
  return value;
}
function ToTemporalDurationTotalUnit(options) {
  const singular = new Map(SINGULAR_PLURAL_UNITS);
  const value = GetOption(options, "unit", [...singular.values(), ...singular.keys()], void 0);
  if (singular.has(value)) return singular.get(value);
  return value;
}
function ToRelativeTemporalObject(options) {
  const relativeTo = options.relativeTo;
  if (relativeTo === void 0) return relativeTo;
  let offsetBehaviour = "option";
  let year, month, day, hour, minute, second, millisecond, timeZone, offset2;
  if (IsTemporalZonedDateTime(relativeTo) || IsTemporalDateTime(relativeTo)) return relativeTo;
  if (IsTemporalDate(relativeTo)) {
    const { year: ISO_YEAR, month: ISO_MONTH, day: ISO_DAY } = GetDateSlots(relativeTo);
    return CreateTemporalDateTime(ISO_YEAR, ISO_MONTH, ISO_DAY, 0, 0, 0, 0);
  }
  if (IsObject(relativeTo)) {
    const fields = ToTemporalDateTimeFields(relativeTo);
    const dateOptions = ObjectCreate(null);
    dateOptions.overflow = "constrain";
    ({ year, month, day, hour, minute, second, millisecond } = InterpretTemporalDateTimeFields(fields, dateOptions));
    offset2 = relativeTo.offset;
    if (offset2 === void 0) offsetBehaviour = "wall";
    timeZone = relativeTo.timeZone;
  } else {
    let ianaName, z;
    ({ year, month, day, hour, minute, second, millisecond, ianaName, offset: offset2, z } = ParseISODateTime(ToString(relativeTo), {
      zoneRequired: false
    }));
    if (ianaName) timeZone = ianaName;
    if (z) {
      offsetBehaviour = "exact";
    } else if (!offset2) {
      offsetBehaviour = "wall";
    }
  }
  if (timeZone) {
    timeZone = ToTemporalTimeZone(timeZone);
    let offsetMs = 0;
    if (offsetBehaviour === "option") offsetMs = ParseOffsetString(ToString(offset2));
    const epochMilliseconds = InterpretISODateTimeOffset(
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond,
      offsetBehaviour,
      offsetMs,
      timeZone,
      "compatible",
      "reject"
    );
    return CreateTemporalZonedDateTime(epochMilliseconds, timeZone);
  }
  return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
}
function ValidateTemporalUnitRange(largestUnit, smallestUnit) {
  if (ALLOWED_UNITS.indexOf(largestUnit) > ALLOWED_UNITS.indexOf(smallestUnit)) {
    throw new RangeError(`largestUnit ${largestUnit} cannot be smaller than smallestUnit ${smallestUnit}`);
  }
}
function DefaultTemporalLargestUnit(years, months, weeks, days, hours, minutes, seconds, milliseconds) {
  const singular = new Map(SINGULAR_PLURAL_UNITS);
  for (const [prop, v] of [
    ["years", years],
    ["months", months],
    ["weeks", weeks],
    ["days", days],
    ["hours", hours],
    ["minutes", minutes],
    ["seconds", seconds],
    ["milliseconds", milliseconds]
  ]) {
    if (v !== 0) return singular.get(prop);
  }
  return "millisecond";
}
function LargerOfTwoTemporalUnits(unit1, unit2) {
  if (ALLOWED_UNITS.indexOf(unit1) > ALLOWED_UNITS.indexOf(unit2)) return unit2;
  return unit1;
}
function ToPartialRecord(bag, fields, callerCast) {
  if (!IsObject(bag)) return false;
  let any;
  for (const property of fields) {
    const value = bag[property];
    if (value !== void 0) {
      any = any || {};
      if (callerCast === void 0 && BUILTIN_CASTS.has(property)) {
        const caster = BUILTIN_CASTS.get(property);
        any[property] = caster && caster(value);
      } else if (callerCast !== void 0) {
        any[property] = callerCast(value);
      } else {
        any[property] = value;
      }
    }
  }
  return any ? any : false;
}
function PrepareTemporalFields(bag, fields) {
  if (!IsObject(bag)) throw new TypeError();
  const result = {};
  let any = false;
  for (const fieldRecord of fields) {
    const [property, defaultValue] = fieldRecord;
    let value = bag[property];
    if (value === void 0) {
      if (fieldRecord.length === 1) {
        throw new TypeError(`required property '${property}' missing or undefined`);
      }
      value = defaultValue;
    } else {
      any = true;
      if (BUILTIN_CASTS.has(property)) {
        const caster = BUILTIN_CASTS.get(property);
        value = caster && caster(value);
      }
    }
    result[property] = value;
  }
  if (!any) {
    throw new TypeError("no supported properties found");
  }
  if (result["era"] === void 0 !== (result["eraYear"] === void 0)) {
    throw new RangeError("properties 'era' and 'eraYear' must be provided together");
  }
  return result;
}
function ToTemporalDateFields(bag) {
  return PrepareTemporalFields(bag, [
    ["day", void 0],
    ["month", void 0],
    ["year", void 0]
  ]);
}
function ToTemporalDateTimeFields(bag) {
  return PrepareTemporalFields(bag, [
    ["day", void 0],
    ["hour", 0],
    ["millisecond", 0],
    ["minute", 0],
    ["month", void 0],
    ["second", 0],
    ["year", void 0]
  ]);
}
function ToTemporalMonthDayFields(bag) {
  return PrepareTemporalFields(bag, [
    ["day", void 0],
    ["month", void 0],
    ["year", void 0]
  ]);
}
function ToTemporalTimeRecord(bag) {
  return PrepareTemporalFields(bag, [
    ["hour", 0],
    ["millisecond", 0],
    ["minute", 0],
    ["second", 0]
  ]);
}
function ToTemporalYearMonthFields(bag) {
  return PrepareTemporalFields(bag, [
    ["month", void 0],
    ["year", void 0]
  ]);
}
function ToTemporalZonedDateTimeFields(bag) {
  return PrepareTemporalFields(bag, [
    ["day", void 0],
    ["hour", 0],
    ["millisecond", 0],
    ["minute", 0],
    ["month", void 0],
    ["second", 0],
    ["year", void 0],
    ["offset", void 0],
    ["timeZone"]
  ]);
}
function ToTemporalDate(item, options = ObjectCreate(null)) {
  if (IsTemporalDate(item)) return item;
  if (IsTemporalZonedDateTime(item)) {
    const { epochMilliseconds, timeZone } = GetZonedDateTimeSlots(item);
    item = BuiltinTimeZoneGetPlainDateTimeFor(timeZone, epochMilliseconds);
  }
  if (IsTemporalDateTime(item)) {
    const { year: year2, month: month2, day: day2 } = GetDateTimeSlots(item);
    return CreateTemporalDate(year2, month2, day2);
  }
  if (IsObject(item)) {
    const fields = ToTemporalDateFields(item);
    return DateFromFields(fields, options);
  }
  ToTemporalOverflow(options);
  const { year, month, day } = ParseTemporalDateString(ToString(item));
  return CreateTemporalDate(year, month, day);
}
function InterpretTemporalDateTimeFields(fields, options) {
  let { hour, minute, second, millisecond } = ToTemporalTimeRecord(fields);
  const overflow = ToTemporalOverflow(options);
  const date = DateFromFields(fields, options);
  const { year, month, day } = GetSlots(date);
  ({ hour, minute, second, millisecond } = RegulateTime(hour, minute, second, millisecond, overflow));
  return { year, month, day, hour, minute, second, millisecond };
}
function ToTemporalDateTime(item, options = ObjectCreate(null)) {
  let year, month, day, hour, minute, second, millisecond;
  if (IsTemporalDateTime(item)) return item;
  if (IsTemporalZonedDateTime(item)) {
    const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(item);
    return BuiltinTimeZoneGetPlainDateTimeFor(timeZone, epochMilliseconds);
  }
  if (IsTemporalDate(item)) {
    const slots = GetDateSlots(item);
    return CreateTemporalDateTime(slots.year, slots.month, slots.day, 0, 0, 0, 0);
  }
  if (IsObject(item)) {
    const fields = ToTemporalDateTimeFields(item);
    ({ year, month, day, hour, minute, second, millisecond } = InterpretTemporalDateTimeFields(fields, options));
  } else {
    ToTemporalOverflow(options);
    ({ year, month, day, hour, minute, second, millisecond } = ParseTemporalDateTimeString(ToString(item)));
    RejectDateTime(year, month, day, hour, minute, second, millisecond);
  }
  return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
}
function ToTemporalDuration(item) {
  let years, months, weeks, days, hours, minutes, seconds, milliseconds;
  if (IsTemporalDuration(item)) return item;
  if (IsObject(item)) {
    ;
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = ToTemporalDurationRecord(item));
  } else {
    ;
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = ParseTemporalDurationString(ToString(item)));
  }
  return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
}
function ToTemporalInstant(item) {
  if (IsTemporalInstant(item)) return item;
  if (IsTemporalZonedDateTime(item)) {
    const { epochMilliseconds } = GetZonedDateTimeSlots(item);
    return CreateTemporalInstant(epochMilliseconds);
  }
  const ms = ParseTemporalInstant(ToString(item));
  return CreateTemporalInstant(ms);
}
function ToTemporalMonthDay(item, options = ObjectCreate(null)) {
  if (IsTemporalMonthDay(item)) return item;
  if (IsObject(item)) {
    const fields = ToTemporalMonthDayFields(item);
    if (fields.month !== void 0 && fields.year === void 0) {
      fields.year = 1972;
    }
    return MonthDayFromFields(fields, options);
  }
  ToTemporalOverflow(options);
  let { month, day, referenceISOYear } = ParseTemporalMonthDayString(ToString(item));
  if (referenceISOYear === void 0) {
    RejectISODate(1972, month, day);
    return CreateTemporalMonthDay(month, day);
  }
  return CreateTemporalMonthDay(month, day, referenceISOYear);
}
function ToTemporalTime(item, overflow = "constrain") {
  let hour, minute, second, millisecond;
  if (IsTemporalTime(item)) return item;
  if (IsTemporalZonedDateTime(item)) {
    const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(item);
    item = BuiltinTimeZoneGetPlainDateTimeFor(timeZone, epochMilliseconds);
  }
  if (IsTemporalDateTime(item)) {
    const slots = GetDateTimeSlots(item);
    return CreateTemporalTime(slots.hour, slots.minute, slots.second, slots.millisecond);
  }
  if (IsObject(item)) {
    ;
    ({ hour, minute, second, millisecond } = ToTemporalTimeRecord(item));
    ({ hour, minute, second, millisecond } = RegulateTime(hour, minute, second, millisecond, overflow));
  } else {
    ;
    ({ hour, minute, second, millisecond } = ParseTemporalTimeString(ToString(item)));
    RejectTime(hour, minute, second, millisecond);
  }
  return CreateTemporalTime(hour, minute, second, millisecond);
}
function ToTemporalYearMonth(item, options = ObjectCreate(null)) {
  if (IsTemporalYearMonth(item)) return item;
  if (IsObject(item)) {
    const fields = ToTemporalYearMonthFields(item);
    return YearMonthFromFields(fields, options);
  }
  ToTemporalOverflow(options);
  let { year, month, referenceISODay } = ParseTemporalYearMonthString(ToString(item));
  if (referenceISODay === void 0) {
    RejectISODate(year, month, 1);
    return CreateTemporalYearMonth(year, month);
  }
  return CreateTemporalYearMonth(year, month, referenceISODay);
}
function InterpretISODateTimeOffset(year, month, day, hour, minute, second, millisecond, offsetBehaviour, offsetMs, timeZone, disambiguation, offsetOpt) {
  const dt = CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  if (offsetBehaviour === "wall" || offsetOpt === "ignore") {
    const offsetMs2 = BuiltinTimeZoneGetInstantFor(timeZone, dt, disambiguation);
    return offsetMs2;
  }
  if (offsetBehaviour === "exact" || offsetOpt === "use") {
    const epochMs = GetEpochFromISOParts(year, month, day, hour, minute, second, millisecond);
    if (epochMs === null) throw new RangeError("ZonedDateTime outside of supported range");
    return epochMs - offsetMs;
  }
  const possibleInstants = GetPossibleInstantsFor(timeZone, dt);
  for (const candidate of possibleInstants) {
    const candidateOffset = GetOffsetMillisecondsFor(timeZone, candidate);
    if (candidateOffset === offsetMs) return candidate;
  }
  if (offsetOpt === "reject") {
    const offsetStr = FormatTimeZoneOffsetString(offsetMs);
    throw new RangeError(`Offset ${offsetStr} is invalid for ${dt.toString()} in ${timeZone}`);
  }
  const epochMilliseconds = DisambiguatePossibleInstants(possibleInstants, timeZone, dt, disambiguation);
  return epochMilliseconds;
}
function ToTemporalZonedDateTime(item, options = ObjectCreate(null)) {
  let year, month, day, hour, minute, second, millisecond, timeZone, offset2;
  let offsetBehaviour = "option";
  if (IsTemporalZonedDateTime(item)) return item;
  if (IsObject(item)) {
    const fields = ToTemporalZonedDateTimeFields(item);
    ({ year, month, day, hour, minute, second, millisecond } = InterpretTemporalDateTimeFields(fields, options));
    timeZone = ToTemporalTimeZone(fields.timeZone);
    offset2 = fields.offset;
    if (offset2 === void 0) {
      offsetBehaviour = "wall";
    } else {
      offset2 = ToString(offset2);
    }
  } else {
    ToTemporalOverflow(options);
    let ianaName, z;
    ({ year, month, day, hour, minute, second, millisecond, ianaName, offset: offset2, z } = ParseTemporalZonedDateTimeString(
      ToString(item)
    ));
    if (!ianaName) throw new RangeError("time zone ID required in brackets");
    if (z) {
      offsetBehaviour = "exact";
    } else if (!offset2) {
      offsetBehaviour = "wall";
    }
    timeZone = ianaName;
  }
  let offsetMs = 0;
  if (offsetBehaviour === "option") offsetMs = ParseOffsetString(offset2);
  const disambiguation = ToTemporalDisambiguation(options);
  const offsetOpt = ToTemporalOffset(options, "reject");
  const epochMilliseconds = InterpretISODateTimeOffset(
    year,
    month,
    day,
    hour,
    minute,
    second,
    millisecond,
    offsetBehaviour,
    offsetMs,
    timeZone,
    disambiguation,
    offsetOpt
  );
  return CreateTemporalZonedDateTime(epochMilliseconds, timeZone);
}
function CreateTemporalInstant(epochMilliseconds) {
  ValidateEpochMilliseconds(epochMilliseconds);
  return new Date(epochMilliseconds).toISOString();
}
var BigMath = {
  abs(x) {
    return x < BigInt(0) ? -x : x;
  }
};
function CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds) {
  years = ToIntegerThrowOnInfinity(years);
  months = ToIntegerThrowOnInfinity(months);
  weeks = ToIntegerThrowOnInfinity(weeks);
  days = ToIntegerThrowOnInfinity(days);
  hours = ToIntegerThrowOnInfinity(hours);
  minutes = ToIntegerThrowOnInfinity(minutes);
  seconds = ToIntegerThrowOnInfinity(seconds);
  milliseconds = ToIntegerThrowOnInfinity(milliseconds);
  const sign = DurationSign(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  for (const prop of [years, months, weeks, days, hours, minutes, seconds, milliseconds]) {
    if (!Number.isFinite(prop)) throw new RangeError("infinite values not allowed as duration fields");
    const propSign = Math.sign(prop);
    if (propSign !== 0 && propSign !== sign) throw new RangeError("mixed-sign values not allowed as duration fields");
  }
  function formatNumber(num) {
    if (num <= NumberMaxSafeInteger) return num.toString(10);
    return BigInt(num).toString();
  }
  const dateParts = [];
  if (years) dateParts.push(`${formatNumber(MathAbs(years))}Y`);
  if (months) dateParts.push(`${formatNumber(MathAbs(months))}M`);
  if (weeks) dateParts.push(`${formatNumber(MathAbs(weeks))}W`);
  if (days) dateParts.push(`${formatNumber(MathAbs(days))}D`);
  const timeParts = [];
  if (hours) timeParts.push(`${formatNumber(MathAbs(hours))}H`);
  if (minutes) timeParts.push(`${formatNumber(MathAbs(minutes))}M`);
  const secondParts = [];
  let total = TotalDurationMillisecondsBigInt(0, 0, 0, seconds, milliseconds, 0);
  const bigSeconds = total / BigInt(1e3);
  milliseconds = Number(total % BigInt(1e3));
  const fraction2 = MathAbs(milliseconds);
  let decimalPart = `${fraction2}`.padStart(3, "0");
  while (decimalPart[decimalPart.length - 1] === "0") {
    decimalPart = decimalPart.slice(0, -1);
  }
  if (decimalPart) secondParts.unshift(".", decimalPart);
  if (bigSeconds !== BigInt(0) || secondParts.length) secondParts.unshift(formatNumber(BigMath.abs(bigSeconds)));
  if (secondParts.length) timeParts.push(`${secondParts.join("")}S`);
  if (timeParts.length) timeParts.unshift("T");
  if (!dateParts.length && !timeParts.length) return "PT0S";
  return `${sign < 0 ? "-" : ""}P${dateParts.join("")}${timeParts.join("")}`;
}
function CreateTemporalDate(year, month, day) {
  RejectISODate(year, month, day);
  RejectDateRange(year, month, day);
  return `${ISOYearString(year)}-${ISODateTimePartString(month)}-${ISODateTimePartString(day)}`;
}
function CreateTemporalTime(hour, minute, second, millisecond, options) {
  RejectTime(hour, minute, second, millisecond);
  const seconds = FormatSecondsStringPart(second, millisecond, options);
  return `${ISODateTimePartString(hour)}:${ISODateTimePartString(minute)}${seconds}`;
}
function CreateTemporalDateTime(year, month, day, h, min, s, ms, options) {
  RejectDateTime(year, month, day, h, min, s, ms);
  RejectDateTimeRange(year, month, day, h, min, s, ms);
  const seconds = FormatSecondsStringPart(s, ms, options);
  return `${ISOYearString(year)}-${ISODateTimePartString(month)}-${ISODateTimePartString(day)}T${ISODateTimePartString(
    h
  )}:${ISODateTimePartString(min)}${seconds}`;
}
function CreateTemporalMonthDay(month, day, referenceISOYear = 1972) {
  RejectISODate(referenceISOYear, month, day);
  RejectDateRange(referenceISOYear, month, day);
  return `--${ISODateTimePartString(month)}-${ISODateTimePartString(day)}`;
}
function CreateTemporalYearMonth(year, month, referenceISODay = 1) {
  RejectISODate(year, month, referenceISODay);
  RejectYearMonthRange(year, month);
  return `${year}-${ISODateTimePartString(month)}`;
}
function CreateTemporalZonedDateTime(epochMilliseconds, timeZone, options) {
  ValidateEpochMilliseconds(epochMilliseconds);
  if (!IsTemporalTimeZone(timeZone)) throw new TypeError(`${timeZone} is not a valid timeZone`);
  const dateTime2 = BuiltinTimeZoneGetPlainDateTimeFor(timeZone, epochMilliseconds);
  const slots = GetDateTimeSlots(dateTime2);
  const year = ISOYearString(slots.year);
  const month = ISODateTimePartString(slots.month);
  const day = ISODateTimePartString(slots.day);
  const hour = ISODateTimePartString(slots.hour);
  const minute = ISODateTimePartString(slots.minute);
  const seconds = FormatSecondsStringPart(slots.second, slots.millisecond, options);
  let result = `${year}-${month}-${day}T${hour}:${minute}${seconds}`;
  result += BuiltinTimeZoneGetOffsetStringFor(timeZone, epochMilliseconds);
  result += `[${timeZone}]`;
  return result;
}
function CalendarMergeFields(fields, additionalFields) {
  const merged = {};
  for (const nextKey of ObjectKeys(fields)) {
    merged[nextKey] = fields[nextKey];
  }
  const newKeys = ObjectKeys(additionalFields);
  for (const nextKey of newKeys) {
    merged[nextKey] = additionalFields[nextKey];
  }
  return merged;
}
function CalendarDateAdd(date, duration2, options) {
  options = GetOptionsObject(options);
  const overflow = ToTemporalOverflow(options);
  const durationSlots = GetDurationSlots(ToTemporalDuration(duration2));
  const dateSlots = GetDateSlots(ToTemporalDate(date));
  const { days } = BalanceDuration(
    durationSlots.days,
    durationSlots.hours,
    durationSlots.minutes,
    durationSlots.seconds,
    durationSlots.milliseconds,
    "day"
  );
  const { year, month, day } = AddISODate(
    dateSlots.year,
    dateSlots.month,
    dateSlots.day,
    durationSlots.years,
    durationSlots.months,
    durationSlots.weeks,
    days,
    overflow
  );
  const result = CreateTemporalDate(year, month, day);
  return result;
}
function CalendarDateUntil(date, otherDate, options) {
  const one = ToTemporalDate(date);
  const two = ToTemporalDate(otherDate);
  options = GetOptionsObject(options);
  const largestUnit = ToLargestTemporalUnit(options, "auto", ["hour", "minute", "second", "millisecond"], "day");
  const oneSlots = GetDateSlots(one);
  const twoSlots = GetDateSlots(two);
  const { years, months, weeks, days } = DifferenceISODate(
    oneSlots.year,
    oneSlots.month,
    oneSlots.day,
    twoSlots.year,
    twoSlots.month,
    twoSlots.day,
    largestUnit
  );
  return CreateTemporalDuration(years, months, weeks, days, 0, 0, 0, 0);
}
function CalendarYear(dateLike) {
  if (!IsTemporalYearMonth(dateLike)) dateLike = ToTemporalDate(dateLike);
  const result = GetSlots(dateLike).year;
  if (result === void 0) {
    throw new RangeError("calendar year result must be an integer");
  }
  return ToIntegerThrowOnInfinity(result);
}
function CalendarMonth(dateLike) {
  if (!IsTemporalYearMonth(dateLike)) dateLike = ToTemporalDate(dateLike);
  const result = GetSlots(dateLike).month;
  if (result === void 0) {
    throw new RangeError("calendar month result must be a positive integer");
  }
  return ToPositiveInteger(result);
}
function CalendarDay(dateLike) {
  if (!IsTemporalMonthDay(dateLike)) dateLike = ToTemporalDate(dateLike);
  const slots = GetSlots(dateLike);
  const result = slots.day;
  if (result === void 0) {
    throw new RangeError("calendar day result must be a positive integer");
  }
  return ToPositiveInteger(result);
}
function CalendarDayOfWeek(dateLike) {
  const date = ToTemporalDate(dateLike);
  const slots = GetDateSlots(date);
  return DayOfWeek(slots.year, slots.month, slots.day);
}
function CalendarDayOfYear(dateLike) {
  const date = ToTemporalDate(dateLike);
  const slots = GetDateSlots(date);
  return DayOfYear(slots.year, slots.month, slots.day);
}
function CalendarWeekOfYear(dateLike) {
  const date = ToTemporalDate(dateLike);
  const slots = GetDateSlots(date);
  return WeekOfYear(slots.year, slots.month, slots.day);
}
function CalendarDaysInMonth(dateLike) {
  if (!IsTemporalYearMonth(dateLike)) dateLike = ToTemporalDate(dateLike);
  const slots = GetSlots(dateLike);
  return ISODaysInMonth(slots.year, slots.month);
}
function CalendarDaysInYear(dateLike) {
  if (!IsTemporalYearMonth(dateLike)) dateLike = ToTemporalDate(dateLike);
  const slots = GetSlots(dateLike);
  return LeapYear(slots.year) ? 366 : 365;
}
function CalendarInLeapYear(dateLike) {
  if (!IsTemporalYearMonth(dateLike)) dateLike = ToTemporalDate(dateLike);
  const slots = GetSlots(dateLike);
  return LeapYear(slots.year);
}
function DateFromFields(fields, options) {
  if (typeof fields !== "object") throw new TypeError("invalid fields");
  options = GetOptionsObject(options);
  const overflow = ToTemporalOverflow(options);
  const preparedFields = PrepareTemporalFields(fields, [["day"], ["month"], ["year"]]);
  let { year, month, day } = preparedFields;
  ({ year, month, day } = RegulateISODate(year, month, day, overflow));
  return CreateTemporalDate(year, month, day);
}
function YearMonthFromFields(fields, options) {
  if (typeof fields !== "object") throw new TypeError("invalid fields");
  options = GetOptionsObject(options);
  const overflow = ToTemporalOverflow(options);
  fields = PrepareTemporalFields(fields, [["month"], ["year"]]);
  let { year, month } = fields;
  ({ year, month } = RegulateISOYearMonth(year, month, overflow));
  return CreateTemporalYearMonth(
    year,
    month,
    /* referenceISODay = */
    1
  );
}
function MonthDayFromFields(fields, options) {
  if (typeof fields !== "object") throw new TypeError("invalid fields");
  options = GetOptionsObject(options);
  const overflow = ToTemporalOverflow(options);
  fields = PrepareTemporalFields(fields, [["day"], ["month"]]);
  const referenceISOYear = 1972;
  let { month, day } = fields;
  ({ month, day } = RegulateISODate(referenceISOYear, month, day, overflow));
  return CreateTemporalMonthDay(month, day, referenceISOYear);
}
function ToTemporalTimeZone(temporalTimeZoneLike) {
  if (IsTemporalZonedDateTime(temporalTimeZoneLike)) return GetZonedDateTimeSlots(temporalTimeZoneLike).timeZone;
  const identifier = ToString(temporalTimeZoneLike);
  const timeZone = TemporalTimeZoneFromString(identifier);
  return timeZone;
}
function TimeZoneEquals(one, two) {
  if (one === two) return true;
  const tz1 = ToString(one);
  const tz2 = ToString(two);
  return tz1 === tz2;
}
function TemporalDateTimeToDate(dateTime2) {
  const slots = GetDateTimeSlots(dateTime2);
  return CreateTemporalDate(slots.year, slots.month, slots.day);
}
function TemporalDateTimeToTime(dateTime2) {
  const slots = GetDateTimeSlots(dateTime2);
  return CreateTemporalTime(slots.hour, slots.minute, slots.second, slots.millisecond);
}
function GetOffsetMillisecondsFor(timeZone, epochMilliseconds) {
  if (!IsTemporalTimeZone(timeZone)) throw new TypeError("invalid receiver");
  ValidateEpochMilliseconds(epochMilliseconds);
  let offsetMs = ParseOffsetString(timeZone);
  if (offsetMs !== null) return offsetMs;
  offsetMs = GetIANATimeZoneOffsetMilliseconds(epochMilliseconds, timeZone);
  if (typeof offsetMs !== "number") {
    throw new TypeError("bad return from GetOffsetMillisecondsFor");
  }
  if (!IsInteger(offsetMs) || MathAbs(offsetMs) > 864e5) {
    throw new RangeError("out-of-range return from GetOffsetMillisecondsFor");
  }
  return offsetMs;
}
function BuiltinTimeZoneGetOffsetStringFor(timeZone, epochMilliseconds) {
  const offsetMs = GetOffsetMillisecondsFor(timeZone, epochMilliseconds);
  return FormatTimeZoneOffsetString(offsetMs);
}
function BuiltinTimeZoneGetPlainDateTimeFor(timeZone, epochMilliseconds) {
  const offsetMs = GetOffsetMillisecondsFor(timeZone, epochMilliseconds);
  let { year, month, day, hour, minute, second, millisecond } = GetISOPartsFromEpoch(epochMilliseconds);
  ({ year, month, day, hour, minute, second, millisecond } = BalanceISODateTime(
    year,
    month,
    day,
    hour,
    minute,
    second,
    millisecond + offsetMs
  ));
  return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
}
function BuiltinTimeZoneGetInstantFor(timeZone, dateTime2, disambiguation) {
  const possibleInstants = GetPossibleInstantsFor(timeZone, dateTime2);
  return DisambiguatePossibleInstants(possibleInstants, timeZone, dateTime2, disambiguation);
}
function DisambiguatePossibleInstants(possibleInstants, timeZone, dateTime2, disambiguation) {
  const numInstants = possibleInstants.length;
  if (numInstants === 1) return possibleInstants[0];
  if (numInstants) {
    switch (disambiguation) {
      case "compatible":
      case "earlier":
        return possibleInstants[0];
      case "later":
        return possibleInstants[numInstants - 1];
      case "reject": {
        throw new RangeError("multiple instants found");
      }
    }
  }
  const slots = GetSlots(dateTime2);
  const utcms = GetEpochFromISOParts(
    slots.year,
    slots.month,
    slots.day,
    slots.hour,
    slots.minute,
    slots.second,
    slots.millisecond
  );
  if (utcms === null) throw new RangeError("DateTime outside of supported range");
  const dayBefore = utcms - 864e5;
  const dayAfter = utcms + 864e5;
  const offsetBefore = GetOffsetMillisecondsFor(timeZone, dayBefore);
  const offsetAfter = GetOffsetMillisecondsFor(timeZone, dayAfter);
  const milliseconds = offsetAfter - offsetBefore;
  switch (disambiguation) {
    case "earlier": {
      const earlier = AddDateTime(
        slots.year,
        slots.month,
        slots.day,
        slots.hour,
        slots.minute,
        slots.second,
        slots.millisecond,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -milliseconds,
        void 0
      );
      const earlierPlainDateTime = CreateTemporalDateTime(
        earlier.year,
        earlier.month,
        earlier.day,
        earlier.hour,
        earlier.minute,
        earlier.second,
        earlier.millisecond
      );
      return GetPossibleInstantsFor(timeZone, earlierPlainDateTime)[0];
    }
    case "compatible":
    case "later": {
      const later = AddDateTime(
        slots.year,
        slots.month,
        slots.day,
        slots.hour,
        slots.minute,
        slots.second,
        slots.millisecond,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        milliseconds,
        void 0
      );
      const laterPlainDateTime = CreateTemporalDateTime(
        later.year,
        later.month,
        later.day,
        later.hour,
        later.minute,
        later.second,
        later.millisecond
      );
      const possible = GetPossibleInstantsFor(timeZone, laterPlainDateTime);
      return possible[possible.length - 1];
    }
    case "reject": {
      throw new RangeError("no such instant found");
    }
  }
}
function ISOYearString(year) {
  let yearString;
  if (year < 1e3 || year > 9999) {
    const sign = year < 0 ? "-" : "+";
    const yearNumber = MathAbs(year);
    yearString = sign + `000000${yearNumber}`.slice(-6);
  } else {
    yearString = `${year}`;
  }
  return yearString;
}
function ISODateTimePartString(part) {
  return `00${part}`.slice(-2);
}
function GetTimePrecision(time2) {
  if (time2.length === 5) return "minute";
  else if (time2.length === 8) return "second";
  else if (time2.length === 10) return "ms100";
  else if (time2.length === 11) return "ms10";
  else if (time2.length === 12) return "ms1";
  else return "auto";
}
function FormatSecondsStringPart(second, millisecond, options) {
  function maxPrecision(precision1, precision2) {
    const precisions = ["auto", "minute", "second", "ms100", "ms10", "ms1"];
    return precisions.indexOf(precision1) > precisions.indexOf(precision2) ? precision1 : precision2;
  }
  function inferPrecision() {
    if (millisecond % 10 !== 0) return "ms1";
    else if (millisecond % 100 !== 0) return "ms10";
    else if (millisecond !== 0) return "ms100";
    else if (second !== 0) return "second";
    else return "minute";
  }
  const precision = maxPrecision((options == null ? void 0 : options.precision) || "auto", inferPrecision());
  const secs = `:${ISODateTimePartString(second)}`;
  if (precision === "minute") {
    return "";
  } else if (precision === "second") {
    return secs;
  } else {
    const fractionLength = precision === "ms1" ? 3 : precision === "ms10" ? 2 : precision === "ms100" ? 1 : 0;
    const fraction2 = `${millisecond}`.padStart(3, "0").slice(0, fractionLength);
    return `${secs}.${fraction2}`;
  }
}
function ParseOffsetString(string) {
  const match = OFFSET.exec(String(string));
  if (!match) return null;
  const sign = match[1] === "-" || match[1] === "\u2212" ? -1 : 1;
  const hours = +match[2];
  const minutes = +(match[3] || 0);
  const seconds = +(match[4] || 0);
  const milliseconds = +((match[5] || 0) + "000").slice(0, 3);
  return sign * (((hours * 60 + minutes) * 60 + seconds) * 1e3 + milliseconds);
}
function GetCanonicalTimeZoneIdentifier(timeZoneIdentifier) {
  const offsetMs = ParseOffsetString(timeZoneIdentifier);
  if (offsetMs !== null) return FormatTimeZoneOffsetString(offsetMs);
  const formatter = getIntlDateTimeFormatEnUsForTimeZone(String(timeZoneIdentifier));
  return formatter.resolvedOptions().timeZone;
}
function GetIANATimeZoneOffsetMilliseconds(epochMilliseconds, timeZone) {
  const { year, month, day, hour, minute, second, millisecond } = GetIANATimeZoneDateTimeParts(epochMilliseconds, timeZone);
  const utc = GetEpochFromISOParts(year, month, day, hour, minute, second, millisecond);
  if (utc === null) throw new RangeError("Date outside of supported range");
  return +utc - epochMilliseconds;
}
function FormatTimeZoneOffsetString(offsetMilliseconds) {
  const sign = offsetMilliseconds < 0 ? "-" : "+";
  offsetMilliseconds = MathAbs(offsetMilliseconds);
  const milliseconds = offsetMilliseconds % 1e3;
  const seconds = MathFloor(offsetMilliseconds / 1e3) % 60;
  const minutes = MathFloor(offsetMilliseconds / 6e4) % 60;
  const hours = MathFloor(offsetMilliseconds / 36e5);
  const hourString = ISODateTimePartString(hours);
  const minuteString = ISODateTimePartString(minutes);
  const secondString = ISODateTimePartString(seconds);
  let post = "";
  if (milliseconds) {
    let fraction2 = `${milliseconds}`.padStart(3, "0");
    while (fraction2[fraction2.length - 1] === "0") fraction2 = fraction2.slice(0, -1);
    post = `:${secondString}.${fraction2}`;
  } else if (seconds) {
    post = `:${secondString}`;
  }
  return `${sign}${hourString}:${minuteString}${post}`;
}
function GetEpochFromISOParts(year, month, day, hour, minute, second, millisecond) {
  const legacyDate = /* @__PURE__ */ new Date();
  legacyDate.setUTCHours(hour, minute, second, millisecond);
  legacyDate.setUTCFullYear(year, month - 1, day);
  const ms = legacyDate.getTime();
  if (NumberIsNaN(ms)) return null;
  if (ms < MS_MIN || ms > MS_MAX) return null;
  return ms;
}
function GetISOPartsFromEpoch(epochMilliseconds) {
  const item = new Date(epochMilliseconds);
  const year = item.getUTCFullYear();
  const month = item.getUTCMonth() + 1;
  const day = item.getUTCDate();
  const hour = item.getUTCHours();
  const minute = item.getUTCMinutes();
  const second = item.getUTCSeconds();
  const millisecond = item.getUTCMilliseconds();
  return { epochMilliseconds, year, month, day, hour, minute, second, millisecond };
}
function GetIANATimeZoneDateTimeParts(epochMilliseconds, timeZone) {
  const { millisecond } = GetISOPartsFromEpoch(epochMilliseconds);
  const { year, month, day, hour, minute, second } = GetFormatterParts(timeZone, epochMilliseconds);
  return BalanceISODateTime(year, month, day, hour, minute, second, millisecond);
}
function GetFormatterParts(timeZone, epochMilliseconds) {
  const formatter = getIntlDateTimeFormatEnUsForTimeZone(timeZone);
  const datetime2 = formatter.format(new Date(epochMilliseconds));
  const [month, day, year, era, hour, minute, second] = datetime2.split(/[^\w]+/);
  return {
    year: era.toUpperCase().startsWith("B") ? -year + 1 : +year,
    month: +month,
    day: +day,
    hour: hour === "24" ? 0 : +hour,
    // bugs.chromium.org/p/chromium/issues/detail?id=1045791
    minute: +minute,
    second: +second
  };
}
function GetIANATimeZoneEpochValue(timeZone, year, month, day, hour, minute, second, millisecond) {
  const ms = GetEpochFromISOParts(year, month, day, hour, minute, second, millisecond);
  if (ms === null) throw new RangeError("DateTime outside of supported range");
  let msEarlier = ms - DAY_MILLIS;
  if (msEarlier < MS_MIN) msEarlier = ms;
  let msLater = ms + DAY_MILLIS;
  if (msLater > MS_MAX) msLater = ms;
  const earliest = GetIANATimeZoneOffsetMilliseconds(msEarlier, timeZone);
  const latest = GetIANATimeZoneOffsetMilliseconds(msLater, timeZone);
  const found = earliest === latest ? [earliest] : [earliest, latest];
  return found.map((offsetMilliseconds) => {
    const epochMilliseconds = ms - offsetMilliseconds;
    const parts = GetIANATimeZoneDateTimeParts(epochMilliseconds, timeZone);
    if (year !== parts.year || month !== parts.month || day !== parts.day || hour !== parts.hour || minute !== parts.minute || second !== parts.second || millisecond !== parts.millisecond) {
      return void 0;
    }
    return epochMilliseconds;
  }).filter((x) => x !== void 0);
}
function LeapYear(year) {
  if (void 0 === year) return false;
  const isDiv4 = year % 4 === 0;
  const isDiv100 = year % 100 === 0;
  const isDiv400 = year % 400 === 0;
  return isDiv4 && (!isDiv100 || isDiv400);
}
function ISODaysInMonth(year, month) {
  const DoM = {
    standard: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    leapyear: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  };
  return DoM[LeapYear(year) ? "leapyear" : "standard"][month - 1];
}
function DayOfWeek(year, month, day) {
  const m = month + (month < 3 ? 10 : -2);
  const Y = year - (month < 3 ? 1 : 0);
  const c = MathFloor(Y / 100);
  const y = Y - c * 100;
  const d = day;
  const pD = d;
  const pM = MathFloor(2.6 * m - 0.2);
  const pY = y + MathFloor(y / 4);
  const pC = MathFloor(c / 4) - 2 * c;
  const dow = (pD + pM + pY + pC) % 7;
  return dow + (dow <= 0 ? 7 : 0);
}
function DayOfYear(year, month, day) {
  let days = day;
  for (let m = month - 1; m > 0; m--) {
    days += ISODaysInMonth(year, m);
  }
  return days;
}
function WeekOfYear(year, month, day) {
  const doy = DayOfYear(year, month, day);
  const dow = DayOfWeek(year, month, day) || 7;
  const doj = DayOfWeek(year, 1, 1);
  const week = MathFloor((doy - dow + 10) / 7);
  if (week < 1) {
    if (doj === 5 || doj === 6 && LeapYear(year - 1)) {
      return 53;
    } else {
      return 52;
    }
  }
  if (week === 53) {
    if ((LeapYear(year) ? 366 : 365) - doy < 4 - dow) {
      return 1;
    }
  }
  return week;
}
function DurationSign(y, mon, w, d, h, min, s, ms) {
  for (const prop of [y, mon, w, d, h, min, s, ms]) {
    if (prop !== 0) return prop < 0 ? -1 : 1;
  }
  return 0;
}
function BalanceISOYearMonth(year, month) {
  if (!NumberIsFinite(year) || !NumberIsFinite(month)) throw new RangeError("infinity is out of range");
  month -= 1;
  year += MathFloor(month / 12);
  month %= 12;
  if (month < 0) month += 12;
  month += 1;
  return { year, month };
}
function BalanceISODate(year, month, day) {
  if (!NumberIsFinite(day)) throw new RangeError("infinity is out of range");
  ({ year, month } = BalanceISOYearMonth(year, month));
  let daysInYear = 0;
  let testYear = month > 2 ? year : year - 1;
  while (daysInYear = LeapYear(testYear) ? 366 : 365, day < -daysInYear) {
    year -= 1;
    testYear -= 1;
    day += daysInYear;
  }
  testYear += 1;
  while (daysInYear = LeapYear(testYear) ? 366 : 365, day > daysInYear) {
    year += 1;
    testYear += 1;
    day -= daysInYear;
  }
  while (day < 1) {
    ;
    ({ year, month } = BalanceISOYearMonth(year, month - 1));
    day += ISODaysInMonth(year, month);
  }
  while (day > ISODaysInMonth(year, month)) {
    day -= ISODaysInMonth(year, month);
    ({ year, month } = BalanceISOYearMonth(year, month + 1));
  }
  return { year, month, day };
}
function BalanceISODateTime(year, month, day, hour, minute, second, millisecond) {
  let deltaDays;
  ({ deltaDays, hour, minute, second, millisecond } = BalanceTime(hour, minute, second, millisecond));
  ({ year, month, day } = BalanceISODate(year, month, day + deltaDays));
  return { year, month, day, hour, minute, second, millisecond };
}
function BalanceTime(hour, minute, second, millisecond) {
  if (!NumberIsFinite(hour) || !NumberIsFinite(minute) || !NumberIsFinite(second) || !NumberIsFinite(millisecond)) {
    throw new RangeError("infinity is out of range");
  }
  second += MathFloor(millisecond / 1e3);
  millisecond = NonNegativeModulo(millisecond, 1e3);
  minute += MathFloor(second / 60);
  second = NonNegativeModulo(second, 60);
  hour += MathFloor(minute / 60);
  minute = NonNegativeModulo(minute, 60);
  const deltaDays = MathFloor(hour / 24);
  hour = NonNegativeModulo(hour, 24);
  return { deltaDays, hour, minute, second, millisecond };
}
function TotalDurationMilliseconds(days, hours, minutes, seconds, milliseconds, offsetShift) {
  if (days !== 0) milliseconds = milliseconds - offsetShift;
  hours = hours + days * 24;
  minutes = minutes + hours * 60;
  seconds = seconds + minutes * 60;
  milliseconds = milliseconds + seconds * 1e3;
  return milliseconds;
}
function TotalDurationMillisecondsBigInt(days, hours, minutes, seconds, milliseconds, offsetShift) {
  if (days !== 0) milliseconds = milliseconds - offsetShift;
  const bigHours = BigInt(hours) + BigInt(days) * BigInt(24);
  const bigMinutes = BigInt(minutes) + BigInt(bigHours) * BigInt(60);
  const bigSeconds = BigInt(seconds) + BigInt(bigMinutes) * BigInt(60);
  return BigInt(milliseconds) + BigInt(bigSeconds) * BigInt(1e3);
}
function MillisecondsToDays(milliseconds, relativeTo) {
  const sign = MathSign(milliseconds);
  let dayLengthMs = 864e5;
  if (sign === 0) return { days: 0, milliseconds: 0, dayLengthMs };
  if (!IsTemporalZonedDateTime(relativeTo)) {
    const days = divmod(milliseconds, dayLengthMs).quotient;
    milliseconds = milliseconds % dayLengthMs;
    return { days, milliseconds, dayLengthMs };
  } else {
    const slots = GetSlots(relativeTo);
    const startMs = slots.epochMilliseconds;
    const endMs = startMs + milliseconds;
    const timeZone = slots.timeZone;
    const dtStart = GetDateTimeSlots(BuiltinTimeZoneGetPlainDateTimeFor(timeZone, startMs));
    const dtEnd = GetDateTimeSlots(BuiltinTimeZoneGetPlainDateTimeFor(timeZone, endMs));
    let { days } = DifferenceISODateTime(
      dtStart.year,
      dtStart.month,
      dtStart.day,
      dtStart.hour,
      dtStart.minute,
      dtStart.second,
      dtStart.millisecond,
      dtEnd.year,
      dtEnd.month,
      dtEnd.day,
      dtEnd.hour,
      dtEnd.minute,
      dtEnd.second,
      dtEnd.millisecond,
      "day"
    );
    let intermediateMs = AddZonedDateTime(startMs, timeZone, 0, 0, 0, days, 0, 0, 0, 0);
    if (sign === 1) {
      while (days > 0 && intermediateMs > endMs) {
        --days;
        intermediateMs = AddZonedDateTime(startMs, timeZone, 0, 0, 0, days, 0, 0, 0, 0);
      }
    }
    milliseconds = endMs - intermediateMs;
    let isOverflow = false;
    let relativeInstant = CreateTemporalInstant(intermediateMs);
    do {
      const oneDayFartherMs = AddZonedDateTime(intermediateMs, timeZone, 0, 0, 0, sign, 0, 0, 0, 0);
      const relativeMs = intermediateMs;
      dayLengthMs = oneDayFartherMs - relativeMs;
      isOverflow = (milliseconds - dayLengthMs) * sign >= 0;
      if (isOverflow) {
        milliseconds = milliseconds - dayLengthMs;
        relativeInstant = CreateTemporalInstant(oneDayFartherMs);
        days += sign;
      }
    } while (isOverflow);
    return { days, milliseconds, dayLengthMs: MathAbs(dayLengthMs) };
  }
}
function BalanceDuration(days, hours, minutes, seconds, milliseconds, largestUnit, relativeTo = void 0) {
  if (IsTemporalZonedDateTime(relativeTo)) {
    const slots = GetZonedDateTimeSlots(relativeTo);
    const endMs = AddZonedDateTime(
      slots.epochMilliseconds,
      slots.timeZone,
      0,
      0,
      0,
      days,
      hours,
      minutes,
      seconds,
      milliseconds
    );
    const startMs = slots.epochMilliseconds;
    milliseconds = endMs - startMs;
  } else {
    milliseconds = TotalDurationMilliseconds(days, hours, minutes, seconds, milliseconds, 0);
  }
  if (largestUnit === "year" || largestUnit === "month" || largestUnit === "week" || largestUnit === "day") {
    ;
    ({ days, milliseconds } = MillisecondsToDays(milliseconds, relativeTo));
  } else {
    days = 0;
  }
  const sign = milliseconds < 0 ? -1 : 1;
  milliseconds = MathAbs(milliseconds);
  switch (largestUnit) {
    case "year":
    case "month":
    case "week":
    case "day":
    case "hour":
      ;
      ({ quotient: seconds, remainder: milliseconds } = divmod(milliseconds, 1e3));
      ({ quotient: minutes, remainder: seconds } = divmod(seconds, 60));
      ({ quotient: hours, remainder: minutes } = divmod(minutes, 60));
      break;
    case "minute":
      hours = 0;
      ({ quotient: seconds, remainder: milliseconds } = divmod(milliseconds, 1e3));
      ({ quotient: minutes, remainder: seconds } = divmod(seconds, 60));
      break;
    case "second":
      minutes = 0;
      hours = 0;
      ({ quotient: seconds, remainder: milliseconds } = divmod(milliseconds, 1e3));
      break;
    case "millisecond":
      break;
    default:
      throw new Error("assert not reached");
  }
  hours = hours * sign;
  minutes = minutes * sign;
  seconds = seconds * sign;
  milliseconds = milliseconds * sign;
  return { days, hours, minutes, seconds, milliseconds };
}
function UnbalanceDurationRelative(years, months, weeks, days, largestUnit, relativeTo) {
  const sign = DurationSign(years, months, weeks, days, 0, 0, 0, 0);
  if (relativeTo) {
    relativeTo = ToTemporalDateTime(relativeTo);
  }
  const oneYear = CreateTemporalDuration(sign, 0, 0, 0, 0, 0, 0, 0);
  const oneMonth = CreateTemporalDuration(0, sign, 0, 0, 0, 0, 0, 0);
  const oneWeek = CreateTemporalDuration(0, 0, sign, 0, 0, 0, 0, 0);
  switch (largestUnit) {
    case "year":
      break;
    case "month":
      {
        while (MathAbs(years) > 0) {
          const addOptions = ObjectCreate(null);
          const newRelativeTo = CalendarDateAdd(relativeTo, oneYear, addOptions);
          const untilOptions = ObjectCreate(null);
          untilOptions.largestUnit = "month";
          const untilResult = CalendarDateUntil(relativeTo, newRelativeTo, untilOptions);
          const oneYearMonths = GetSlots(untilResult).months;
          relativeTo = newRelativeTo;
          months += oneYearMonths;
          years -= sign;
        }
      }
      break;
    case "week":
      while (MathAbs(years) > 0) {
        let oneYearDays;
        ({ relativeTo, days: oneYearDays } = MoveRelativeDate(relativeTo, oneYear));
        days += oneYearDays;
        years -= sign;
      }
      while (MathAbs(months) > 0) {
        let oneMonthDays;
        ({ relativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
        days += oneMonthDays;
        months -= sign;
      }
      break;
    default:
      while (MathAbs(years) > 0) {
        let oneYearDays;
        ({ relativeTo, days: oneYearDays } = MoveRelativeDate(relativeTo, oneYear));
        days += oneYearDays;
        years -= sign;
      }
      while (MathAbs(months) > 0) {
        let oneMonthDays;
        ({ relativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
        days += oneMonthDays;
        months -= sign;
      }
      while (MathAbs(weeks) > 0) {
        let oneWeekDays;
        ({ relativeTo, days: oneWeekDays } = MoveRelativeDate(relativeTo, oneWeek));
        days += oneWeekDays;
        weeks -= sign;
      }
      break;
  }
  return { years, months, weeks, days };
}
function BalanceDurationRelative(years, months, weeks, days, largestUnit, relativeTo) {
  const sign = DurationSign(years, months, weeks, days, 0, 0, 0, 0);
  if (sign === 0) return { years, months, weeks, days };
  if (relativeTo) {
    relativeTo = ToTemporalDateTime(relativeTo);
  }
  const oneYear = CreateTemporalDuration(sign, 0, 0, 0, 0, 0, 0, 0);
  const oneMonth = CreateTemporalDuration(0, sign, 0, 0, 0, 0, 0, 0);
  const oneWeek = CreateTemporalDuration(0, 0, sign, 0, 0, 0, 0, 0);
  switch (largestUnit) {
    case "year": {
      let newRelativeTo, oneYearDays;
      ({ relativeTo: newRelativeTo, days: oneYearDays } = MoveRelativeDate(relativeTo, oneYear));
      while (MathAbs(days) >= MathAbs(oneYearDays)) {
        days -= oneYearDays;
        years += sign;
        relativeTo = newRelativeTo;
        ({ relativeTo: newRelativeTo, days: oneYearDays } = MoveRelativeDate(relativeTo, oneYear));
      }
      let oneMonthDays;
      ({ relativeTo: newRelativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
      while (MathAbs(days) >= MathAbs(oneMonthDays)) {
        days -= oneMonthDays;
        months += sign;
        relativeTo = newRelativeTo;
        ({ relativeTo: newRelativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
      }
      const addOptions = ObjectCreate(null);
      newRelativeTo = CalendarDateAdd(relativeTo, oneYear, addOptions);
      const untilOptions = ObjectCreate(null);
      untilOptions.largestUnit = "month";
      let untilResult = CalendarDateUntil(relativeTo, newRelativeTo, untilOptions);
      let oneYearMonths = GetSlots(untilResult).months;
      while (MathAbs(months) >= MathAbs(oneYearMonths)) {
        months -= oneYearMonths;
        years += sign;
        relativeTo = newRelativeTo;
        const addOptions2 = ObjectCreate(null);
        newRelativeTo = CalendarDateAdd(relativeTo, oneYear, addOptions2);
        const untilOptions2 = ObjectCreate(null);
        untilOptions2.largestUnit = "month";
        untilResult = CalendarDateUntil(relativeTo, newRelativeTo, untilOptions2);
        oneYearMonths = GetSlots(untilResult).months;
      }
      break;
    }
    case "month": {
      let newRelativeTo, oneMonthDays;
      ({ relativeTo: newRelativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
      while (MathAbs(days) >= MathAbs(oneMonthDays)) {
        days -= oneMonthDays;
        months += sign;
        relativeTo = newRelativeTo;
        ({ relativeTo: newRelativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
      }
      break;
    }
    case "week": {
      let newRelativeTo, oneWeekDays;
      ({ relativeTo: newRelativeTo, days: oneWeekDays } = MoveRelativeDate(relativeTo, oneWeek));
      while (MathAbs(days) >= MathAbs(oneWeekDays)) {
        days -= oneWeekDays;
        weeks += sign;
        relativeTo = newRelativeTo;
        ({ relativeTo: newRelativeTo, days: oneWeekDays } = MoveRelativeDate(relativeTo, oneWeek));
      }
      break;
    }
    default:
      break;
  }
  return { years, months, weeks, days };
}
function CalculateOffsetShift(relativeTo, y, mon, w, d, h, min, s, ms) {
  if (IsTemporalZonedDateTime(relativeTo)) {
    const { epochMilliseconds, timeZone } = GetZonedDateTimeSlots(relativeTo);
    const offsetBefore = GetOffsetMillisecondsFor(timeZone, epochMilliseconds);
    const after = AddZonedDateTime(epochMilliseconds, timeZone, y, mon, w, d, h, min, s, ms);
    const offsetAfter = GetOffsetMillisecondsFor(timeZone, after);
    return offsetAfter - offsetBefore;
  }
  return 0;
}
function CreateNegatedTemporalDuration(duration2) {
  const slots = GetDurationSlots(duration2);
  return CreateTemporalDuration(
    -slots.years,
    -slots.months,
    -slots.weeks,
    -slots.days,
    -slots.hours,
    -slots.minutes,
    -slots.seconds,
    -slots.milliseconds
  );
}
function ConstrainToRange(value, min, max) {
  return MathMin(max, MathMax(min, value));
}
function ConstrainISODate(year, month, day) {
  month = ConstrainToRange(month, 1, 12);
  day = ConstrainToRange(day, 1, ISODaysInMonth(year, month));
  return { year, month, day };
}
function ConstrainTime(hour, minute, second, millisecond) {
  hour = ConstrainToRange(hour, 0, 23);
  minute = ConstrainToRange(minute, 0, 59);
  second = ConstrainToRange(second, 0, 59);
  millisecond = ConstrainToRange(millisecond, 0, 999);
  return { hour, minute, second, millisecond };
}
function RejectToRange(value, min, max) {
  if (value < min || value > max) throw new RangeError(`value out of range: ${min} <= ${value} <= ${max}`);
}
function RejectISODate(year, month, day) {
  RejectToRange(month, 1, 12);
  RejectToRange(day, 1, ISODaysInMonth(year, month));
}
function RejectDateRange(year, month, day) {
  RejectDateTimeRange(year, month, day, 12, 0, 0, 0);
}
function RejectTime(hour, minute, second, millisecond) {
  RejectToRange(hour, 0, 23);
  RejectToRange(minute, 0, 59);
  RejectToRange(second, 0, 59);
  RejectToRange(millisecond, 0, 999);
}
function RejectDateTime(year, month, day, hour, minute, second, millisecond) {
  RejectISODate(year, month, day);
  RejectTime(hour, minute, second, millisecond);
}
function RejectDateTimeRange(year, month, day, hour, minute, second, millisecond) {
  RejectToRange(year, YEAR_MIN, YEAR_MAX);
  if (year === YEAR_MIN && null == GetEpochFromISOParts(year, month, day + 1, hour, minute, second, millisecond - 1) || year === YEAR_MAX && null == GetEpochFromISOParts(year, month, day - 1, hour, minute, second, millisecond + 1)) {
    throw new RangeError("DateTime outside of supported range");
  }
}
function ValidateEpochMilliseconds(epochMilliseconds) {
  if (epochMilliseconds < MS_MIN || epochMilliseconds > MS_MAX) {
    throw new RangeError("Instant outside of supported range");
  }
}
function RejectYearMonthRange(year, month) {
  RejectToRange(year, YEAR_MIN, YEAR_MAX);
  if (year === YEAR_MIN) {
    RejectToRange(month, 4, 12);
  } else if (year === YEAR_MAX) {
    RejectToRange(month, 1, 9);
  }
}
function RejectDuration(y, mon, w, d, h, min, s, ms) {
  const sign = DurationSign(y, mon, w, d, h, min, s, ms);
  for (const prop of [y, mon, w, d, h, min, s, ms]) {
    if (!NumberIsFinite(prop)) throw new RangeError("infinite values not allowed as duration fields");
    const propSign = MathSign(prop);
    if (propSign !== 0 && propSign !== sign) throw new RangeError("mixed-sign values not allowed as duration fields");
  }
}
function DifferenceISODate(y1, m1, d1, y2, m2, d2, largestUnit = "day") {
  switch (largestUnit) {
    case "year":
    case "month": {
      const sign = -CompareISODate(y1, m1, d1, y2, m2, d2);
      if (sign === 0) return { years: 0, months: 0, weeks: 0, days: 0 };
      const start = { year: y1, month: m1, day: d1 };
      const end = { year: y2, month: m2, day: d2 };
      let years = end.year - start.year;
      let mid = AddISODate(y1, m1, d1, years, 0, 0, 0, "constrain");
      let midSign = -CompareISODate(mid.year, mid.month, mid.day, y2, m2, d2);
      if (midSign === 0) {
        return largestUnit === "year" ? { years, months: 0, weeks: 0, days: 0 } : { years: 0, months: years * 12, weeks: 0, days: 0 };
      }
      let months = end.month - start.month;
      if (midSign !== sign) {
        years -= sign;
        months += sign * 12;
      }
      mid = AddISODate(y1, m1, d1, years, months, 0, 0, "constrain");
      midSign = -CompareISODate(mid.year, mid.month, mid.day, y2, m2, d2);
      if (midSign === 0) {
        return largestUnit === "year" ? { years, months, weeks: 0, days: 0 } : { years: 0, months: months + years * 12, weeks: 0, days: 0 };
      }
      if (midSign !== sign) {
        months -= sign;
        if (months === -sign) {
          years -= sign;
          months = 11 * sign;
        }
        mid = AddISODate(y1, m1, d1, years, months, 0, 0, "constrain");
        midSign = -CompareISODate(y1, m1, d1, mid.year, mid.month, mid.day);
      }
      let days = 0;
      if (mid.month === end.month) {
        days = end.day - mid.day;
      } else if (sign < 0) {
        days = -mid.day - (ISODaysInMonth(end.year, end.month) - end.day);
      } else {
        days = end.day + (ISODaysInMonth(mid.year, mid.month) - mid.day);
      }
      if (largestUnit === "month") {
        months += years * 12;
        years = 0;
      }
      return { years, months, weeks: 0, days };
    }
    case "week":
    case "day": {
      let larger, smaller, sign;
      if (CompareISODate(y1, m1, d1, y2, m2, d2) < 0) {
        smaller = { year: y1, month: m1, day: d1 };
        larger = { year: y2, month: m2, day: d2 };
        sign = 1;
      } else {
        smaller = { year: y2, month: m2, day: d2 };
        larger = { year: y1, month: m1, day: d1 };
        sign = -1;
      }
      let days = DayOfYear(larger.year, larger.month, larger.day) - DayOfYear(smaller.year, smaller.month, smaller.day);
      for (let year = smaller.year; year < larger.year; ++year) {
        days += LeapYear(year) ? 366 : 365;
      }
      let weeks = 0;
      if (largestUnit === "week") {
        weeks = MathFloor(days / 7);
        days %= 7;
      }
      weeks *= sign;
      days *= sign;
      return { years: 0, months: 0, weeks, days };
    }
    default:
      throw new Error("assert not reached");
  }
}
function DifferenceTime(h1, min1, s1, ms1, h2, min2, s2, ms2) {
  let hours = h2 - h1;
  let minutes = min2 - min1;
  let seconds = s2 - s1;
  let milliseconds = ms2 - ms1;
  const sign = DurationSign(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
  hours *= sign;
  minutes *= sign;
  seconds *= sign;
  milliseconds *= sign;
  let deltaDays = 0;
  ({
    deltaDays,
    hour: hours,
    minute: minutes,
    second: seconds,
    millisecond: milliseconds
  } = BalanceTime(hours, minutes, seconds, milliseconds));
  deltaDays *= sign;
  hours *= sign;
  minutes *= sign;
  seconds *= sign;
  milliseconds *= sign;
  return { deltaDays, hours, minutes, seconds, milliseconds };
}
function DifferenceInstant(ms1, ms2, increment, unit, roundingMode) {
  const diff = ms2 - ms1;
  const remainder = diff % 864e5;
  const wholeDays = diff - remainder;
  const roundedRemainder = RoundNumberToIncrement(remainder, msPerTimeUnit[unit] * increment, roundingMode);
  const roundedDiff = wholeDays + roundedRemainder;
  const milliseconds = +roundedDiff % 1e3;
  const seconds = +MathTrunc(roundedDiff / 1e3);
  return { seconds, milliseconds };
}
function DifferenceISODateTime(y1, mon1, d1, h1, min1, s1, ms1, y2, mon2, d2, h2, min2, s2, ms2, largestUnit, options = ObjectCreate(null)) {
  let { deltaDays, hours, minutes, seconds, milliseconds } = DifferenceTime(h1, min1, s1, ms1, h2, min2, s2, ms2);
  const timeSign = DurationSign(0, 0, 0, deltaDays, hours, minutes, seconds, milliseconds);
  ({ year: y1, month: mon1, day: d1 } = BalanceISODate(y1, mon1, d1 + deltaDays));
  const dateSign = CompareISODate(y2, mon2, d2, y1, mon1, d1);
  if (dateSign === -timeSign) {
    ;
    ({ year: y1, month: mon1, day: d1 } = BalanceISODate(y1, mon1, d1 - timeSign));
    ({ hours, minutes, seconds, milliseconds } = BalanceDuration(
      -timeSign,
      hours,
      minutes,
      seconds,
      milliseconds,
      largestUnit
    ));
  }
  const date1 = CreateTemporalDate(y1, mon1, d1);
  const date2 = CreateTemporalDate(y2, mon2, d2);
  const dateLargestUnit = LargerOfTwoTemporalUnits("day", largestUnit);
  const untilOptions = __spreadProps(__spreadValues({}, options), { largestUnit: dateLargestUnit });
  let { years, months, weeks, days } = GetDurationSlots(CalendarDateUntil(date1, date2, untilOptions));
  ({ days, hours, minutes, seconds, milliseconds } = BalanceDuration(
    days,
    hours,
    minutes,
    seconds,
    milliseconds,
    largestUnit
  ));
  return { years, months, weeks, days, hours, minutes, seconds, milliseconds };
}
function DifferenceZonedDateTime(ms1, ms2, timeZone, largestUnit, options) {
  const nsDiff = ms2 - ms1;
  if (nsDiff === 0) {
    return {
      years: 0,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    };
  }
  const dtStart = GetDateTimeSlots(BuiltinTimeZoneGetPlainDateTimeFor(timeZone, ms1));
  const dtEnd = GetDateTimeSlots(BuiltinTimeZoneGetPlainDateTimeFor(timeZone, ms2));
  let { years, months, weeks, days } = DifferenceISODateTime(
    dtStart.year,
    dtStart.month,
    dtStart.day,
    dtStart.hour,
    dtStart.minute,
    dtStart.second,
    dtStart.millisecond,
    dtEnd.year,
    dtEnd.month,
    dtEnd.day,
    dtEnd.hour,
    dtEnd.minute,
    dtEnd.second,
    dtEnd.millisecond,
    largestUnit,
    options
  );
  const intermediateMs = AddZonedDateTime(ms1, timeZone, years, months, weeks, 0, 0, 0, 0, 0);
  let timeRemainderMs = ms2 - intermediateMs;
  const intermediate = CreateTemporalZonedDateTime(intermediateMs, timeZone);
  ({ milliseconds: timeRemainderMs, days } = MillisecondsToDays(timeRemainderMs, intermediate));
  const { hours, minutes, seconds, milliseconds } = BalanceDuration(0, 0, 0, 0, timeRemainderMs, "hour");
  return { years, months, weeks, days, hours, minutes, seconds, milliseconds };
}
function AddISODate(year, month, day, years, months, weeks, days, overflow) {
  year += years;
  month += months;
  ({ year, month } = BalanceISOYearMonth(year, month));
  ({ year, month, day } = RegulateISODate(year, month, day, overflow));
  days += 7 * weeks;
  day += days;
  ({ year, month, day } = BalanceISODate(year, month, day));
  return { year, month, day };
}
function AddTime(hour, minute, second, millisecond, hours, minutes, seconds, milliseconds) {
  hour += hours;
  minute += minutes;
  second += seconds;
  millisecond += milliseconds;
  let deltaDays = 0;
  ({ deltaDays, hour, minute, second, millisecond } = BalanceTime(hour, minute, second, millisecond));
  return { deltaDays, hour, minute, second, millisecond };
}
function AddDuration(y1, mon1, w1, d1, h1, min1, s1, ms1, y2, mon2, w2, d2, h2, min2, s2, ms2, relativeTo) {
  const largestUnit1 = DefaultTemporalLargestUnit(y1, mon1, w1, d1, h1, min1, s1, ms1);
  const largestUnit2 = DefaultTemporalLargestUnit(y2, mon2, w2, d2, h2, min2, s2, ms2);
  const largestUnit = LargerOfTwoTemporalUnits(largestUnit1, largestUnit2);
  let years, months, weeks, days, hours, minutes, seconds, milliseconds;
  if (!relativeTo) {
    if (largestUnit === "year" || largestUnit === "month" || largestUnit === "week") {
      throw new RangeError("relativeTo is required for years, months, or weeks arithmetic");
    }
    years = months = weeks = 0;
    ({ days, hours, minutes, seconds, milliseconds } = BalanceDuration(
      d1 + d2,
      h1 + h2,
      min1 + min2,
      s1 + s2,
      ms1 + ms2,
      largestUnit
    ));
  } else if (IsTemporalDateTime(relativeTo)) {
    const slots = GetDateTimeSlots(relativeTo);
    const datePart = CreateTemporalDate(slots.year, slots.month, slots.day);
    const dateDuration1 = CreateTemporalDuration(y1, mon1, w1, d1, 0, 0, 0, 0);
    const dateDuration2 = CreateTemporalDuration(y2, mon2, w2, d2, 0, 0, 0, 0);
    const firstAddOptions = ObjectCreate(null);
    const intermediate = CalendarDateAdd(datePart, dateDuration1, firstAddOptions);
    const secondAddOptions = ObjectCreate(null);
    const end = CalendarDateAdd(intermediate, dateDuration2, secondAddOptions);
    const dateLargestUnit = LargerOfTwoTemporalUnits("day", largestUnit);
    const differenceOptions = ObjectCreate(null);
    differenceOptions.largestUnit = dateLargestUnit;
    ({ years, months, weeks, days } = GetDurationSlots(CalendarDateUntil(datePart, end, differenceOptions)));
    ({ days, hours, minutes, seconds, milliseconds } = BalanceDuration(
      days,
      h1 + h2,
      min1 + min2,
      s1 + s2,
      ms1 + ms2,
      largestUnit
    ));
  } else {
    const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(relativeTo);
    const intermediateMs = AddZonedDateTime(epochMilliseconds, timeZone, y1, mon1, w1, d1, h1, min1, s1, ms1);
    const endMs = AddZonedDateTime(intermediateMs, timeZone, y2, mon2, w2, d2, h2, min2, s2, ms2);
    if (largestUnit !== "year" && largestUnit !== "month" && largestUnit !== "week" && largestUnit !== "day") {
      years = 0;
      months = 0;
      weeks = 0;
      days = 0;
      ({ seconds, milliseconds } = DifferenceInstant(epochMilliseconds, endMs, 1, "millisecond", "halfExpand"));
      ({ hours, minutes, seconds, milliseconds } = BalanceDuration(
        0,
        0,
        0,
        seconds,
        milliseconds,
        largestUnit
      ));
    } else {
      ;
      ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = DifferenceZonedDateTime(
        epochMilliseconds,
        endMs,
        timeZone,
        largestUnit
      ));
    }
  }
  RejectDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  return { years, months, weeks, days, hours, minutes, seconds, milliseconds };
}
function AddInstant(epochMilliseconds, h, min, s, ms) {
  let sum = 0;
  sum = sum + ms * 1;
  sum = sum + s * 1e3;
  sum = sum + min * 60 * 1e3;
  sum = sum + h * 60 * 60 * 1e3;
  const result = epochMilliseconds + sum;
  ValidateEpochMilliseconds(result);
  return result;
}
function AddDateTime(year, month, day, hour, minute, second, millisecond, years, months, weeks, days, hours, minutes, seconds, milliseconds, options) {
  let deltaDays = 0;
  ({ deltaDays, hour, minute, second, millisecond } = AddTime(
    hour,
    minute,
    second,
    millisecond,
    hours,
    minutes,
    seconds,
    milliseconds
  ));
  days += deltaDays;
  const datePart = CreateTemporalDate(year, month, day);
  const dateDuration = CreateTemporalDuration(years, months, weeks, days, 0, 0, 0, 0);
  const addedDate = CalendarDateAdd(datePart, dateDuration, options);
  const dateSlots = GetDateSlots(addedDate);
  return {
    year: dateSlots.year,
    month: dateSlots.month,
    day: dateSlots.day,
    hour,
    minute,
    second,
    millisecond
  };
}
function AddZonedDateTime(epochMilliseconds, timeZone, years, months, weeks, days, h, min, s, ms, options) {
  if (DurationSign(years, months, weeks, days, 0, 0, 0, 0) === 0) {
    return AddInstant(epochMilliseconds, h, min, s, ms);
  }
  const dt = GetDateTimeSlots(BuiltinTimeZoneGetPlainDateTimeFor(timeZone, epochMilliseconds));
  const datePart = CreateTemporalDate(dt.year, dt.month, dt.day);
  const dateDuration = CreateTemporalDuration(years, months, weeks, days, 0, 0, 0, 0);
  const addedDate = CalendarDateAdd(datePart, dateDuration, options);
  const dateSlots = GetDateSlots(addedDate);
  const dtIntermediate = CreateTemporalDateTime(
    dateSlots.year,
    dateSlots.month,
    dateSlots.day,
    dt.hour,
    dt.minute,
    dt.second,
    dt.millisecond
  );
  const instantIntermediate = BuiltinTimeZoneGetInstantFor(timeZone, dtIntermediate, "compatible");
  return AddInstant(instantIntermediate, h, min, s, ms);
}
function RoundNumberToIncrement(quantity, increment, mode) {
  if (increment === 1) return quantity;
  let quotient = MathTrunc(quantity / increment);
  let remainder = quantity % increment;
  if (remainder === 0) return quantity;
  const sign = remainder < 0 ? -1 : 1;
  switch (mode) {
    case "ceil":
      if (sign > 0) quotient = quotient + sign;
      break;
    case "floor":
      if (sign < 0) quotient = quotient + sign;
      break;
    case "trunc":
      break;
    case "halfExpand":
      if (MathAbs(remainder * 2) >= increment) quotient = quotient + sign;
      break;
  }
  return quotient * increment;
}
function RoundInstant(epochMs, increment, unit, roundingMode) {
  let remainder = epochMs % 864e5;
  if (remainder < 0) remainder = remainder + 864e5;
  const wholeDays = epochMs - remainder;
  const roundedRemainder = RoundNumberToIncrement(remainder, msPerTimeUnit[unit] * increment, roundingMode);
  return wholeDays + roundedRemainder;
}
function RoundISODateTime(year, month, day, hour, minute, second, millisecond, increment, unit, roundingMode, dayLengthMs = 864e5) {
  let deltaDays = 0;
  ({ deltaDays, hour, minute, second, millisecond } = RoundTime(
    hour,
    minute,
    second,
    millisecond,
    increment,
    unit,
    roundingMode,
    dayLengthMs
  ));
  ({ year, month, day } = BalanceISODate(year, month, day + deltaDays));
  return { year, month, day, hour, minute, second, millisecond };
}
function RoundTime(hour, minute, second, millisecond, increment, unit, roundingMode, dayLengthMs = 864e5) {
  let quantity = 0;
  switch (unit) {
    case "day":
    case "hour":
      quantity = hour;
    case "minute":
      quantity = quantity * 60 + minute;
    case "second":
      quantity = quantity * 60 + second;
    case "millisecond":
      quantity = quantity * 1e3 + millisecond;
  }
  const msPerUnit = unit === "day" ? dayLengthMs : msPerTimeUnit[unit];
  const rounded = RoundNumberToIncrement(quantity, msPerUnit * increment, roundingMode);
  const result = MathTrunc(rounded / msPerUnit);
  switch (unit) {
    case "day":
      return { deltaDays: result, hour: 0, minute: 0, second: 0, millisecond: 0 };
    case "hour":
      return BalanceTime(result, 0, 0, 0);
    case "minute":
      return BalanceTime(hour, result, 0, 0);
    case "second":
      return BalanceTime(hour, minute, result, 0);
    case "millisecond":
      return BalanceTime(hour, minute, second, result);
    default:
      throw new Error(`Invalid unit ${unit}`);
  }
}
function DaysUntil(earlier, later) {
  const earlierSlots = GetSlots(earlier);
  const laterSlots = GetSlots(later);
  return DifferenceISODate(
    earlierSlots.year,
    earlierSlots.month,
    earlierSlots.day,
    laterSlots.year,
    laterSlots.month,
    laterSlots.day,
    "day"
  ).days;
}
function MoveRelativeDate(relativeTo, duration2) {
  const options = ObjectCreate(null);
  const later = CalendarDateAdd(relativeTo, duration2, options);
  const days = DaysUntil(relativeTo, later);
  const laterSlots = GetDateSlots(later);
  const relativeSlots = GetSlots(relativeTo);
  relativeTo = CreateTemporalDateTime(
    laterSlots.year,
    laterSlots.month,
    laterSlots.day,
    relativeSlots["hour"] || 0,
    relativeSlots["minute"] || 0,
    relativeSlots["second"] || 0,
    relativeSlots["millisecond"] || 0
  );
  return { relativeTo, days };
}
function MoveRelativeZonedDateTime(relativeTo, years, months, weeks, days) {
  const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(relativeTo);
  const intermediateMs = AddZonedDateTime(epochMilliseconds, timeZone, years, months, weeks, days, 0, 0, 0, 0);
  return CreateTemporalZonedDateTime(intermediateMs, timeZone);
}
function AdjustRoundedDurationDays(years, months, weeks, days, hours, minutes, seconds, milliseconds, increment, unit, roundingMode, relativeTo) {
  if (!IsTemporalZonedDateTime(relativeTo) || unit === "year" || unit === "month" || unit === "week" || unit === "day" || unit === "millisecond" && increment === 1) {
    return { years, months, weeks, days, hours, minutes, seconds, milliseconds };
  }
  let timeRemainderMs = TotalDurationMilliseconds(0, hours, minutes, seconds, milliseconds, 0);
  const direction = MathSign(timeRemainderMs);
  const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(relativeTo);
  const dayStart = AddZonedDateTime(epochMilliseconds, timeZone, years, months, weeks, days, 0, 0, 0, 0);
  const dayEnd = AddZonedDateTime(dayStart, timeZone, 0, 0, 0, direction, 0, 0, 0, 0);
  const dayLengthMs = dayEnd - dayStart;
  if ((timeRemainderMs - dayLengthMs) * direction >= 0) {
    ;
    ({ years, months, weeks, days } = AddDuration(
      years,
      months,
      weeks,
      days,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      direction,
      0,
      0,
      0,
      0,
      relativeTo
    ));
    timeRemainderMs = RoundInstant(
      timeRemainderMs - dayLengthMs,
      increment,
      unit,
      roundingMode
    );
    ({ hours, minutes, seconds, milliseconds } = BalanceDuration(0, 0, 0, 0, timeRemainderMs, "hour"));
  }
  return { years, months, weeks, days, hours, minutes, seconds, milliseconds };
}
function RoundDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds, increment, unit, roundingMode, relativeTo = void 0) {
  let zdtRelative;
  if (relativeTo) {
    if (IsTemporalZonedDateTime(relativeTo)) {
      zdtRelative = relativeTo;
      const { epochMilliseconds, timeZone } = GetZonedDateTimeSlots(relativeTo);
      relativeTo = BuiltinTimeZoneGetPlainDateTimeFor(timeZone, epochMilliseconds);
    } else if (!IsTemporalDateTime(relativeTo)) {
      throw new TypeError("starting point must be PlainDateTime or ZonedDateTime");
    }
  }
  let dayLengthMs;
  if (unit === "year" || unit === "month" || unit === "week" || unit === "day") {
    milliseconds = TotalDurationMilliseconds(0, hours, minutes, seconds, milliseconds, 0);
    let intermediate;
    if (zdtRelative) {
      intermediate = MoveRelativeZonedDateTime(zdtRelative, years, months, weeks, days);
    }
    let deltaDays;
    ({ days: deltaDays, milliseconds, dayLengthMs } = MillisecondsToDays(milliseconds, intermediate));
    days += deltaDays;
    hours = minutes = seconds = 0;
  }
  let total;
  switch (unit) {
    case "year": {
      const yearsDuration = CreateTemporalDuration(years, 0, 0, 0, 0, 0, 0, 0);
      const firstAddOptions = ObjectCreate(null);
      const yearsLater = CalendarDateAdd(relativeTo, yearsDuration, firstAddOptions);
      const yearsMonthsWeeks = CreateTemporalDuration(years, months, weeks, 0, 0, 0, 0, 0);
      const secondAddOptions = ObjectCreate(null);
      const yearsMonthsWeeksLater = CalendarDateAdd(relativeTo, yearsMonthsWeeks, secondAddOptions);
      const monthsWeeksInDays = DaysUntil(yearsLater, yearsMonthsWeeksLater);
      relativeTo = yearsLater;
      days += monthsWeeksInDays;
      const thirdAddOptions = ObjectCreate(null);
      const daysLater = CalendarDateAdd(relativeTo, { days }, thirdAddOptions);
      const untilOptions = ObjectCreate(null);
      untilOptions.largestUnit = "year";
      const yearsPassed = GetDurationSlots(CalendarDateUntil(relativeTo, daysLater, untilOptions)).years;
      years += yearsPassed;
      const oldRelativeTo = relativeTo;
      const fourthAddOptions = ObjectCreate(null);
      relativeTo = CalendarDateAdd(relativeTo, { years: yearsPassed }, fourthAddOptions);
      const daysPassed = DaysUntil(oldRelativeTo, relativeTo);
      days -= daysPassed;
      const oneYear = CreateTemporalDuration(days < 0 ? -1 : 1, 0, 0, 0, 0, 0, 0, 0);
      let { days: oneYearDays } = MoveRelativeDate(relativeTo, oneYear);
      oneYearDays = MathAbs(oneYearDays);
      const divisor = oneYearDays * dayLengthMs;
      milliseconds = divisor * years + days * dayLengthMs + milliseconds;
      const rounded = RoundNumberToIncrement(milliseconds, divisor * increment, roundingMode);
      total = milliseconds / divisor;
      years = Math.trunc(rounded / divisor);
      milliseconds = months = weeks = days = 0;
      break;
    }
    case "month": {
      const yearsMonths = CreateTemporalDuration(years, months, 0, 0, 0, 0, 0, 0);
      const firstAddOptions = ObjectCreate(null);
      const yearsMonthsLater = CalendarDateAdd(relativeTo, yearsMonths, firstAddOptions);
      const yearsMonthsWeeks = CreateTemporalDuration(years, months, weeks, 0, 0, 0, 0, 0);
      const secondAddOptions = ObjectCreate(null);
      const yearsMonthsWeeksLater = CalendarDateAdd(relativeTo, yearsMonthsWeeks, secondAddOptions);
      const weeksInDays = DaysUntil(yearsMonthsLater, yearsMonthsWeeksLater);
      relativeTo = yearsMonthsLater;
      days += weeksInDays;
      const sign = MathSign(days);
      const oneMonth = CreateTemporalDuration(0, days < 0 ? -1 : 1, 0, 0, 0, 0, 0, 0);
      let oneMonthDays;
      ({ relativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
      while (MathAbs(days) >= MathAbs(oneMonthDays)) {
        months += sign;
        days -= oneMonthDays;
        ({ relativeTo, days: oneMonthDays } = MoveRelativeDate(relativeTo, oneMonth));
      }
      oneMonthDays = MathAbs(oneMonthDays);
      const divisor = oneMonthDays * dayLengthMs;
      milliseconds = divisor * months + days * dayLengthMs + milliseconds;
      const rounded = RoundNumberToIncrement(milliseconds, divisor * increment, roundingMode);
      total = milliseconds / divisor;
      months = MathTrunc(rounded / divisor);
      milliseconds = weeks = days = 0;
      break;
    }
    case "week": {
      const sign = MathSign(days);
      const oneWeek = CreateTemporalDuration(0, 0, days < 0 ? -1 : 1, 0, 0, 0, 0, 0);
      let oneWeekDays;
      ({ relativeTo, days: oneWeekDays } = MoveRelativeDate(relativeTo, oneWeek));
      while (MathAbs(days) >= MathAbs(oneWeekDays)) {
        weeks += sign;
        days -= oneWeekDays;
        ({ relativeTo, days: oneWeekDays } = MoveRelativeDate(relativeTo, oneWeek));
      }
      oneWeekDays = MathAbs(oneWeekDays);
      const divisor = oneWeekDays * dayLengthMs;
      milliseconds = divisor * weeks + days * dayLengthMs + milliseconds;
      const rounded = RoundNumberToIncrement(milliseconds, divisor * increment, roundingMode);
      total = milliseconds / divisor;
      weeks = MathTrunc(rounded / divisor);
      milliseconds = days = 0;
      break;
    }
    case "day": {
      const divisor = dayLengthMs;
      milliseconds = divisor * days + milliseconds;
      const rounded = RoundNumberToIncrement(milliseconds, divisor * increment, roundingMode);
      total = milliseconds / divisor;
      days = Math.trunc(rounded / divisor);
      milliseconds = 0;
      break;
    }
    case "hour": {
      const divisor = 36e5;
      milliseconds = hours * 36e5 + minutes * 6e4 + seconds * 1e3 + milliseconds;
      total = milliseconds / divisor;
      const rounded = RoundNumberToIncrement(milliseconds, divisor * increment, roundingMode);
      hours = Math.trunc(rounded / divisor);
      minutes = seconds = milliseconds = 0;
      break;
    }
    case "minute": {
      const divisor = 6e4;
      milliseconds = minutes * 6e4 + seconds * 1e3 + milliseconds;
      total = milliseconds / divisor;
      const rounded = RoundNumberToIncrement(milliseconds, divisor * increment, roundingMode);
      minutes = Math.trunc(rounded / divisor);
      seconds = milliseconds = 0;
      break;
    }
    case "second": {
      const divisor = 1e3;
      milliseconds = seconds * 1e3 + milliseconds;
      total = milliseconds / divisor;
      const rounded = RoundNumberToIncrement(milliseconds, divisor * increment, roundingMode);
      seconds = MathTrunc(rounded / divisor);
      milliseconds = 0;
      break;
    }
    case "millisecond": {
      total = milliseconds;
      milliseconds = RoundNumberToIncrement(milliseconds, increment, roundingMode);
      break;
    }
  }
  return {
    years,
    months,
    weeks,
    days,
    hours,
    minutes,
    seconds,
    milliseconds,
    // @ts-ignore
    total
  };
}
function CompareISODate(y1, m1, d1, y2, m2, d2) {
  for (const [x, y] of [
    [y1, y2],
    [m1, m2],
    [d1, d2]
  ]) {
    if (x !== y) return ComparisonResult(x - y);
  }
  return 0;
}
function NonNegativeModulo(x, y) {
  let result = x % y;
  if (ObjectIs(result, -0)) return 0;
  if (result < 0) result += y;
  return result;
}
function SystemUTCEpochMilliSeconds() {
  return Date.now();
}
function DefaultTimeZone() {
  return new Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function ComparisonResult(value) {
  return value < 0 ? -1 : value > 0 ? 1 : value;
}
function GetOptionsObject(options) {
  if (options === void 0) return ObjectCreate(null);
  if (IsObject(options)) return options;
  throw new TypeError(`Options parameter must be an object, not ${options === null ? "null" : `a ${typeof options}`}`);
}
function GetOption(options, property, allowedValues, fallback) {
  let value = options[property];
  if (value !== void 0) {
    value = ToString(value);
    if (!allowedValues.includes(value)) {
      throw new RangeError(`${property} must be one of ${allowedValues.join(", ")}, not ${value}`);
    }
    return value;
  }
  return fallback;
}
function GetNumberOption(options, property, minimum, maximum, fallback) {
  let value = options[property];
  if (value === void 0) return fallback;
  value = ToNumber(value);
  if (NumberIsNaN(value) || value < minimum || value > maximum) {
    throw new RangeError(`${property} must be between ${minimum} and ${maximum}, not ${value}`);
  }
  return MathFloor(value);
}
var OFFSET = new RegExp(`^${offset.source}$`);
function GetPossibleInstantsFor(timeZone, dateTime2) {
  if (!IsTemporalTimeZone(timeZone)) throw new TypeError("invalid receiver");
  dateTime2 = ToTemporalDateTime(dateTime2);
  const slots = GetDateTimeSlots(dateTime2);
  const offsetMs = ParseOffsetString(timeZone);
  if (offsetMs !== null) {
    const epochMs = GetEpochFromISOParts(
      slots.year,
      slots.month,
      slots.day,
      slots.hour,
      slots.minute,
      slots.second,
      slots.millisecond
    );
    if (epochMs === null) throw new RangeError("DateTime outside of supported range");
    return [epochMs - offsetMs];
  }
  const possibleEpochMs = GetIANATimeZoneEpochValue(
    timeZone,
    slots.year,
    slots.month,
    slots.day,
    slots.hour,
    slots.minute,
    slots.second,
    slots.millisecond
  );
  return possibleEpochMs;
}
var msPerTimeUnit = {
  hour: 36e5,
  minute: 6e4,
  second: 1e3,
  millisecond: 1
};
function GetSlots(input) {
  if (IsTemporalInstant(input)) {
    return GetInstantSlots(input);
  } else if (IsTemporalZonedDateTime(input)) {
    return GetZonedDateTimeSlots(input);
  } else if (IsTemporalDateTime(input)) {
    return GetDateTimeSlots(input);
  } else if (IsTemporalDate(input)) {
    return GetDateSlots(input);
  } else if (IsTemporalTime(input)) {
    return GetTimeSlots(input);
  } else if (IsTemporalYearMonth(input)) {
    return GetYearMonthSlots(input);
  } else if (IsTemporalMonthDay(input)) {
    return GetMonthDaySlots(input);
  } else if (IsTemporalDuration(input)) {
    return GetDurationSlots(input);
  } else {
    throw new Error();
  }
}
function GetInstantSlots(input) {
  return {
    epochMilliseconds: new Date(input).getTime()
  };
}
function GetZonedDateTimeSlots(input) {
  const [dirtyDateTime, dirtyTimeZone] = input.split("[");
  const timeZone = dirtyTimeZone.replace("]", "");
  const offset2 = dirtyDateTime.substring(dirtyDateTime.length - 6, dirtyDateTime.length);
  const dateTime2 = dirtyDateTime.substring(0, dirtyDateTime.length - 6);
  const parsed = ParseTemporalDateTimeString(dateTime2);
  return {
    year: parsed.year,
    month: parsed.month,
    day: parsed.day,
    hour: parsed.hour,
    minute: parsed.minute,
    second: parsed.second,
    millisecond: parsed.millisecond,
    epochMilliseconds: (/* @__PURE__ */ new Date(`${dateTime2}${offset2}`)).getTime(),
    timeZone,
    offset: offset2
  };
}
function GetDateTimeSlots(input) {
  const parsed = ParseTemporalDateTimeString(input);
  return {
    year: parsed.year,
    month: parsed.month,
    day: parsed.day,
    hour: parsed.hour,
    minute: parsed.minute,
    second: parsed.second,
    millisecond: parsed.millisecond
  };
}
function GetDateSlots(input) {
  const parsed = ParseTemporalDateString(input);
  return {
    year: parsed.year,
    month: parsed.month,
    day: parsed.day
  };
}
function GetTimeSlots(input) {
  const parsed = ParseTemporalTimeString(input);
  return {
    hour: parsed.hour,
    minute: parsed.minute,
    second: parsed.second,
    millisecond: parsed.millisecond
  };
}
function GetYearMonthSlots(input) {
  const parsed = ParseTemporalYearMonthString(input);
  return {
    year: parsed.year,
    month: parsed.month
  };
}
function GetMonthDaySlots(input) {
  const parsed = ParseTemporalMonthDayString(input);
  return {
    month: parsed.month,
    day: parsed.day
  };
}
function GetDurationSlots(input) {
  const parsed = ParseTemporalDurationString(input);
  return parsed;
}
function divmod(x, divisor) {
  return {
    quotient: Math.trunc(x / divisor),
    remainder: x % divisor
  };
}

// src/fns/durationFns.ts
var durationFns = {
  fromNumbers(years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    years = ToIntegerThrowOnInfinity(years);
    months = ToIntegerThrowOnInfinity(months);
    weeks = ToIntegerThrowOnInfinity(weeks);
    days = ToIntegerThrowOnInfinity(days);
    hours = ToIntegerThrowOnInfinity(hours);
    minutes = ToIntegerThrowOnInfinity(minutes);
    seconds = ToIntegerThrowOnInfinity(seconds);
    milliseconds = ToIntegerThrowOnInfinity(milliseconds);
    const sign = DurationSign(years, months, weeks, days, hours, minutes, seconds, milliseconds);
    for (const prop of [years, months, weeks, days, hours, minutes, seconds, milliseconds]) {
      if (!Number.isFinite(prop)) throw new RangeError("infinite values not allowed as duration fields");
      const propSign = Math.sign(prop);
      if (propSign !== 0 && propSign !== sign) throw new RangeError("mixed-sign values not allowed as duration fields");
    }
    return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  },
  isValid(duration2) {
    return IsTemporalDuration(duration2);
  },
  assertIsValid(duration2) {
    AssertIsDuration(duration2);
  },
  getYears(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).years;
  },
  getMonths(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).months;
  },
  getWeeks(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).weeks;
  },
  getDays(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).days;
  },
  getHours(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).hours;
  },
  getMinutes(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).minutes;
  },
  getSeconds(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).seconds;
  },
  getMilliseconds(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2).milliseconds;
  },
  getSign(duration2) {
    AssertIsDuration(duration2);
    const slots = GetDurationSlots(duration2);
    return DurationSign(
      slots.years,
      slots.months,
      slots.weeks,
      slots.days,
      slots.hours,
      slots.minutes,
      slots.seconds,
      slots.milliseconds
    );
  },
  isBlank(duration2) {
    AssertIsDuration(duration2);
    const slots = GetDurationSlots(duration2);
    return DurationSign(
      slots.years,
      slots.months,
      slots.weeks,
      slots.days,
      slots.hours,
      slots.minutes,
      slots.seconds,
      slots.milliseconds
    ) === 0;
  },
  with(duration2, durationLike) {
    AssertIsDuration(duration2);
    const props = ToPartialRecord(durationLike, [
      "days",
      "hours",
      "milliseconds",
      "minutes",
      "months",
      "seconds",
      "weeks",
      "years"
    ]);
    if (!props) {
      throw new TypeError("invalid duration-like");
    }
    const slots = GetDurationSlots(duration2);
    let {
      years = slots.years,
      months = slots.months,
      weeks = slots.weeks,
      days = slots.days,
      hours = slots.hours,
      minutes = slots.minutes,
      seconds = slots.seconds,
      milliseconds = slots.milliseconds
    } = props;
    return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  },
  negated(duration2) {
    AssertIsDuration(duration2);
    return CreateNegatedTemporalDuration(duration2);
  },
  abs(duration2) {
    AssertIsDuration(duration2);
    const slots = GetDurationSlots(duration2);
    return CreateTemporalDuration(
      Math.abs(slots.years),
      Math.abs(slots.months),
      Math.abs(slots.weeks),
      Math.abs(slots.days),
      Math.abs(slots.hours),
      Math.abs(slots.minutes),
      Math.abs(slots.seconds),
      Math.abs(slots.milliseconds)
    );
  },
  add(duration2, other, options = void 0) {
    AssertIsDuration(duration2);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = ToLimitedTemporalDuration(other);
    options = GetOptionsObject(options);
    const relativeTo = ToRelativeTemporalObject(options);
    const thisSlots = GetDurationSlots(duration2);
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = AddDuration(
      thisSlots.years,
      thisSlots.months,
      thisSlots.weeks,
      thisSlots.days,
      thisSlots.hours,
      thisSlots.minutes,
      thisSlots.seconds,
      thisSlots.milliseconds,
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      relativeTo
    ));
    return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  },
  subtract(duration2, other, options = void 0) {
    AssertIsDuration(duration2);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = ToLimitedTemporalDuration(other);
    options = GetOptionsObject(options);
    const relativeTo = ToRelativeTemporalObject(options);
    const thisSlots = GetDurationSlots(duration2);
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = AddDuration(
      thisSlots.years,
      thisSlots.months,
      thisSlots.weeks,
      thisSlots.days,
      thisSlots.hours,
      thisSlots.minutes,
      thisSlots.seconds,
      thisSlots.milliseconds,
      -years,
      -months,
      -weeks,
      -days,
      -hours,
      -minutes,
      -seconds,
      -milliseconds,
      relativeTo
    ));
    return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  },
  round(duration2, options) {
    AssertIsDuration(duration2);
    if (options === void 0) throw new TypeError("options parameter is required");
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = GetDurationSlots(duration2);
    let defaultLargestUnit = DefaultTemporalLargestUnit(years, months, weeks, days, hours, minutes, seconds, milliseconds);
    options = GetOptionsObject(options);
    let smallestUnit = ToSmallestTemporalUnit(options, void 0);
    let smallestUnitPresent = true;
    if (!smallestUnit) {
      smallestUnitPresent = false;
      smallestUnit = "millisecond";
    }
    defaultLargestUnit = LargerOfTwoTemporalUnits(defaultLargestUnit, smallestUnit);
    let largestUnit = ToLargestTemporalUnit(options, void 0);
    let largestUnitPresent = true;
    if (!largestUnit) {
      largestUnitPresent = false;
      largestUnit = defaultLargestUnit;
    }
    if (largestUnit === "auto") largestUnit = defaultLargestUnit;
    if (!smallestUnitPresent && !largestUnitPresent) {
      throw new RangeError("at least one of smallestUnit or largestUnit is required");
    }
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "halfExpand");
    const roundingIncrement = ToTemporalDateTimeRoundingIncrement(options, smallestUnit);
    let relativeTo = ToRelativeTemporalObject(options);
    ({ years, months, weeks, days } = UnbalanceDurationRelative(years, months, weeks, days, largestUnit, relativeTo));
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = RoundDuration(
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      roundingIncrement,
      smallestUnit,
      roundingMode,
      relativeTo
    ));
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = AdjustRoundedDurationDays(
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      roundingIncrement,
      smallestUnit,
      roundingMode,
      relativeTo
    ));
    ({ years, months, weeks, days } = BalanceDurationRelative(years, months, weeks, days, largestUnit, relativeTo));
    if (IsTemporalZonedDateTime(relativeTo)) {
      relativeTo = MoveRelativeZonedDateTime(relativeTo, years, months, weeks, 0);
    }
    ;
    ({ days, hours, minutes, seconds, milliseconds } = BalanceDuration(
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      largestUnit,
      relativeTo
    ));
    return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  },
  total(duration2, options) {
    AssertIsDuration(duration2);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = GetDurationSlots(duration2);
    if (options === void 0) throw new TypeError("options argument is required");
    options = GetOptionsObject(options);
    const unit = ToTemporalDurationTotalUnit(options);
    if (unit === void 0) throw new RangeError("unit option is required");
    const relativeTo = ToRelativeTemporalObject(options);
    ({ years, months, weeks, days } = UnbalanceDurationRelative(years, months, weeks, days, unit, relativeTo));
    let intermediate;
    if (IsTemporalZonedDateTime(relativeTo)) {
      intermediate = MoveRelativeZonedDateTime(relativeTo, years, months, weeks, 0);
    }
    ;
    ({ days, hours, minutes, seconds, milliseconds } = BalanceDuration(
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      unit,
      intermediate
    ));
    const { total } = RoundDuration(
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      1,
      unit,
      "trunc",
      relativeTo
    );
    return total;
  },
  getFields(duration2) {
    AssertIsDuration(duration2);
    return GetDurationSlots(duration2);
  },
  from(item) {
    if (IsTemporalDuration(item)) {
      const slots = GetDurationSlots(item);
      return CreateTemporalDuration(
        slots.years,
        slots.months,
        slots.weeks,
        slots.days,
        slots.hours,
        slots.minutes,
        slots.seconds,
        slots.milliseconds
      );
    }
    return ToTemporalDuration(item);
  },
  compare(one, two, options = void 0) {
    one = ToTemporalDuration(one);
    two = ToTemporalDuration(two);
    options = GetOptionsObject(options);
    const relativeTo = ToRelativeTemporalObject(options);
    let {
      years: y1,
      months: mon1,
      weeks: w1,
      days: d1,
      hours: h1,
      minutes: min1,
      seconds: s1,
      milliseconds: ms1
    } = GetDurationSlots(one);
    let {
      years: y2,
      months: mon2,
      weeks: w2,
      days: d2,
      hours: h2,
      minutes: min2,
      seconds: s2,
      milliseconds: ms2
    } = GetDurationSlots(two);
    const shift1 = CalculateOffsetShift(relativeTo, y1, mon1, w1, d1, h1, min1, s1, ms1);
    const shift2 = CalculateOffsetShift(relativeTo, y2, mon2, w2, d2, h2, min2, s2, ms2);
    if (y1 !== 0 || y2 !== 0 || mon1 !== 0 || mon2 !== 0 || w1 !== 0 || w2 !== 0) {
      ;
      ({ days: d1 } = UnbalanceDurationRelative(y1, mon1, w1, d1, "day", relativeTo));
      ({ days: d2 } = UnbalanceDurationRelative(y2, mon2, w2, d2, "day", relativeTo));
    }
    ms1 = TotalDurationMilliseconds(d1, h1, min1, s1, ms1, shift1);
    ms2 = TotalDurationMilliseconds(d2, h2, min2, s2, ms2, shift2);
    return ComparisonResult(ms1 - ms2);
  },
  chain: buildDurationChain
};
function buildDurationChain(duration2) {
  return {
    value() {
      return duration2;
    },
    getYears() {
      return buildChain(durationFns.getYears(duration2));
    },
    getMonths() {
      return buildChain(durationFns.getMonths(duration2));
    },
    getWeeks() {
      return buildChain(durationFns.getWeeks(duration2));
    },
    getDays() {
      return buildChain(durationFns.getDays(duration2));
    },
    getHours() {
      return buildChain(durationFns.getHours(duration2));
    },
    getMinutes() {
      return buildChain(durationFns.getMinutes(duration2));
    },
    getSeconds() {
      return buildChain(durationFns.getSeconds(duration2));
    },
    getMilliseconds() {
      return buildChain(durationFns.getMilliseconds(duration2));
    },
    getSign() {
      return buildChain(durationFns.getSign(duration2));
    },
    isBlank() {
      return buildChain(durationFns.isBlank(duration2));
    },
    with(durationLike) {
      return buildDurationChain(durationFns.with(duration2, durationLike));
    },
    negated() {
      return buildDurationChain(durationFns.negated(duration2));
    },
    abs() {
      return buildDurationChain(durationFns.abs(duration2));
    },
    add(other, options) {
      return buildDurationChain(durationFns.add(duration2, other, options));
    },
    subtract(other, options) {
      return buildDurationChain(durationFns.subtract(duration2, other, options));
    },
    round(options) {
      return buildDurationChain(durationFns.round(duration2, options));
    },
    total(options) {
      return buildChain(durationFns.total(duration2, options));
    },
    getFields() {
      return buildChain(durationFns.getFields(duration2));
    }
  };
}

// src/fns/instantFns.ts
var DISALLOWED_UNITS = ["year", "month", "week", "day"];
var MAX_DIFFERENCE_INCREMENTS = {
  hour: 24,
  minute: 60,
  second: 60,
  millisecond: 1e3,
  microsecond: 1e3,
  nanosecond: 1e3
};
var instantFns = {
  now() {
    return CreateTemporalInstant(SystemUTCEpochMilliSeconds());
  },
  fromEpochMilliseconds(epochMilliseconds) {
    if (arguments.length < 1) {
      throw new TypeError("missing argument: epochNanoseconds is required");
    }
    const ms = epochMilliseconds;
    ValidateEpochMilliseconds(ms);
    return CreateTemporalInstant(ms);
  },
  isValid(instant2) {
    return IsTemporalInstant(instant2);
  },
  assertIsValid(instant2) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
  },
  getEpochSeconds(instant2) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    const value = GetInstantSlots(instant2).epochMilliseconds;
    return Math.floor(value / 1e3);
  },
  getEpochMilliseconds(instant2) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    const value = GetInstantSlots(instant2).epochMilliseconds;
    return value;
  },
  add(instant2, temporalDurationLike) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    const { hours, minutes, seconds, milliseconds } = ToLimitedTemporalDuration(temporalDurationLike, [
      "years",
      "months",
      "weeks",
      "days"
    ]);
    const ms = AddInstant(GetInstantSlots(instant2).epochMilliseconds, hours, minutes, seconds, milliseconds);
    return CreateTemporalInstant(ms);
  },
  subtract(instant2, temporalDurationLike) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    const { hours, minutes, seconds, milliseconds } = ToLimitedTemporalDuration(temporalDurationLike, [
      "years",
      "months",
      "weeks",
      "days"
    ]);
    const ns = AddInstant(GetInstantSlots(instant2).epochMilliseconds, -hours, -minutes, -seconds, -milliseconds);
    return CreateTemporalInstant(ns);
  },
  until(from, until, options = {}) {
    if (!IsTemporalInstant(from)) throw new TypeError("invalid receiver");
    until = ToTemporalInstant(until);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond", DISALLOWED_UNITS);
    const defaultLargestUnit = LargerOfTwoTemporalUnits("second", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(
      options,
      "auto",
      DISALLOWED_UNITS,
      defaultLargestUnit
    );
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, MAX_DIFFERENCE_INCREMENTS[smallestUnit], false);
    const oneMs = GetInstantSlots(from).epochMilliseconds;
    const twoMs = GetInstantSlots(until).epochMilliseconds;
    let { seconds, milliseconds } = DifferenceInstant(oneMs, twoMs, roundingIncrement, smallestUnit, roundingMode);
    let hours, minutes;
    ({ hours, minutes, seconds, milliseconds } = BalanceDuration(0, 0, 0, seconds, milliseconds, largestUnit));
    return CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
  },
  since(to, since, options = {}) {
    if (!IsTemporalInstant(to)) throw new TypeError("invalid receiver");
    since = ToTemporalInstant(since);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond", DISALLOWED_UNITS);
    const defaultLargestUnit = LargerOfTwoTemporalUnits("second", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(
      options,
      "auto",
      DISALLOWED_UNITS,
      defaultLargestUnit
    );
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, MAX_DIFFERENCE_INCREMENTS[smallestUnit], false);
    const oneMs = GetInstantSlots(to).epochMilliseconds;
    const twoMs = GetInstantSlots(since).epochMilliseconds;
    let { seconds, milliseconds } = DifferenceInstant(oneMs, twoMs, roundingIncrement, smallestUnit, roundingMode);
    let hours, minutes;
    ({ hours, minutes, seconds, milliseconds } = BalanceDuration(0, 0, 0, seconds, milliseconds, largestUnit));
    return CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
  },
  round(instant2, options) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    if (options === void 0) throw new TypeError("options parameter is required");
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, void 0, DISALLOWED_UNITS);
    if (smallestUnit === void 0) throw new RangeError("smallestUnit is required");
    const roundingMode = ToTemporalRoundingMode(options, "halfExpand");
    const maximumIncrements = {
      hour: 24,
      minute: 1440,
      second: 86400,
      millisecond: 864e5,
      microsecond: 864e8,
      nanosecond: 864e11
    };
    const roundingIncrement = ToTemporalRoundingIncrement(options, maximumIncrements[smallestUnit], true);
    const ms = GetInstantSlots(instant2).epochMilliseconds;
    const roundedNs = RoundInstant(ms, roundingIncrement, smallestUnit, roundingMode);
    return CreateTemporalInstant(roundedNs);
  },
  equals(instant2, other) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    if (!IsTemporalInstant(other)) throw new TypeError("invalid receiver");
    const one = GetInstantSlots(instant2).epochMilliseconds;
    const two = GetInstantSlots(other).epochMilliseconds;
    return one === two;
  },
  isEqual(instant2, other) {
    return instantFns.equals(instant2, other);
  },
  isBefore(instant2, other) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    if (!IsTemporalInstant(other)) throw new TypeError("invalid receiver");
    const one = GetInstantSlots(instant2).epochMilliseconds;
    const two = GetInstantSlots(other).epochMilliseconds;
    return one < two;
  },
  isAfter(instant2, other) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    if (!IsTemporalInstant(other)) throw new TypeError("invalid receiver");
    const one = GetInstantSlots(instant2).epochMilliseconds;
    const two = GetInstantSlots(other).epochMilliseconds;
    return one > two;
  },
  isEqualOrBefore(instant2, other) {
    return instantFns.isEqual(instant2, other) || instantFns.isBefore(instant2, other);
  },
  isEqualOrAfter(instant2, other) {
    return instantFns.isEqual(instant2, other) || instantFns.isAfter(instant2, other);
  },
  toZonedDateTime(instant2, timeZone) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    timeZone = ToTemporalTimeZone(timeZone);
    return CreateTemporalZonedDateTime(GetInstantSlots(instant2).epochMilliseconds, timeZone);
  },
  formatISO9075(instant2) {
    if (!IsTemporalInstant(instant2)) throw new TypeError("invalid receiver");
    return instant2.slice(0, -1).replace("T", " ");
  },
  toJsDate(instant2) {
    return new Date(instant2);
  },
  fromEpochSeconds(epochSeconds) {
    epochSeconds = ToNumber(epochSeconds);
    const epochNanoseconds = epochSeconds * 1e3;
    ValidateEpochMilliseconds(epochNanoseconds);
    return CreateTemporalInstant(epochNanoseconds);
  },
  from(item) {
    if (IsTemporalInstant(item)) {
      return CreateTemporalInstant(GetInstantSlots(item).epochMilliseconds);
    }
    return ToTemporalInstant(item);
  },
  compare(one, two) {
    if (!IsTemporalInstant(one)) throw new TypeError("invalid receiver");
    if (!IsTemporalInstant(two)) throw new TypeError("invalid receiver");
    const oneMs = GetInstantSlots(one).epochMilliseconds;
    const twoMs = GetInstantSlots(two).epochMilliseconds;
    if (oneMs < twoMs) return -1;
    if (oneMs > twoMs) return 1;
    return 0;
  },
  chain: buildInstantChain
};
function buildInstantChain(instant2) {
  return {
    value() {
      return instant2;
    },
    getEpochSeconds() {
      return buildChain(instantFns.getEpochSeconds(instant2));
    },
    getEpochMilliseconds() {
      return buildChain(instantFns.getEpochMilliseconds(instant2));
    },
    add(temporalDurationLike) {
      return buildInstantChain(instantFns.add(instant2, temporalDurationLike));
    },
    subtract(temporalDurationLike) {
      return buildInstantChain(instantFns.subtract(instant2, temporalDurationLike));
    },
    until(until, options) {
      return buildDurationChain(instantFns.until(instant2, until, options));
    },
    since(since, options) {
      return buildDurationChain(instantFns.since(instant2, since, options));
    },
    round(options) {
      return buildInstantChain(instantFns.round(instant2, options));
    },
    equals(other) {
      return buildChain(instantFns.equals(instant2, other));
    },
    isEqual(other) {
      return buildChain(instantFns.isEqual(instant2, other));
    },
    isBefore(other) {
      return buildChain(instantFns.isBefore(instant2, other));
    },
    isAfter(other) {
      return buildChain(instantFns.isAfter(instant2, other));
    },
    isEqualOrBefore(other) {
      return buildChain(instantFns.isEqualOrBefore(instant2, other));
    },
    isEqualOrAfter(other) {
      return buildChain(instantFns.isEqualOrAfter(instant2, other));
    },
    toZonedDateTime(timeZone) {
      return buildZonedDateTimeChain(instantFns.toZonedDateTime(instant2, timeZone));
    },
    toJsDate() {
      return buildChain(new Date(instant2));
    }
  };
}

// src/format/buildLocalizeFunction.ts
function buildLocalizeFn(args) {
  return (dirtyIndex, dirtyOptions) => {
    const options = dirtyOptions || {};
    const context = options.context ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

// src/format/buildFormatLongFn.ts
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}

// src/format/en-us-locale.ts
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var dateFormats = {
  full: "iiii, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var en_us_locale_default = {
  formatLong,
  code: "en-US",
  localize,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

// src/format/addLeadingZeros.ts
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  let output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}

// src/format/lightFormatters.ts
var formatters = {
  // Year
  y(date, token) {
    const signedYear = date.year;
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month = date.month;
    return token === "M" ? String(month) : addLeadingZeros(month, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.day, token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.hour / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.hour % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.hour, token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros(date.minute, token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros(date.second, token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const fractionalSeconds = Math.floor(date.millisecond * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var lightFormatters_default = formatters;

// src/format/formatters.ts
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters2 = {
  // Era
  G(date, token, localize2) {
    const era = date.year > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y(date, token, localize2) {
    if (token === "yo") {
      var signedYear = date.year;
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters_default.y(date, token);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u(date, token) {
    return addLeadingZeros(date.year, token.length);
  },
  // Quarter
  Q(date, token, localize2) {
    const quarter = Math.ceil(date.month / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Month
  M(date, token, localize2) {
    const month = date.month - 1;
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters_default.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, { width: "narrow", context: "formatting" });
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // ISO week of year
  I(date, token, localize2) {
    const isoWeek = WeekOfYear(date.year, date.month, date.day);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.day, { unit: "date" });
    }
    return lightFormatters_default.d(date, token);
  },
  // Day of week
  E(date, token, localize2) {
    const dayOfWeek = DayOfWeek(date.year, date.month, date.day);
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, { width: "wide", context: "formatting" });
    }
  },
  // ISO day of week
  i(date, token, localize2) {
    const dayOfWeek = DayOfWeek(date.year, date.month, date.day);
    const isoDayOfWeek = dayOfWeek === 7 ? 0 : dayOfWeek;
    switch (token) {
      case "i":
        return String(dayOfWeek);
      case "ii":
        return addLeadingZeros(dayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(dayOfWeek, { unit: "day" });
      case "iii":
        return localize2.day(isoDayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(isoDayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(isoDayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(isoDayOfWeek, { width: "wide", context: "formatting" });
    }
  },
  // AM or PM
  a(date, token, localize2) {
    const hours = date.hour;
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b(date, token, localize2) {
    const hours = date.hour;
    const dayPeriodEnumValue = hours === 12 ? dayPeriodEnum.noon : hours === 0 ? dayPeriodEnum.midnight : hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B(date, token, localize2) {
    const hours = date.hour;
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h(date, token, localize2) {
    if (token === "ho") {
      var hours = date.hour % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters_default.h(date, token);
  },
  // Hour [0-23]
  H(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.hour, { unit: "hour" });
    }
    return lightFormatters_default.H(date, token);
  },
  // Hour [0-11]
  K(date, token, localize2) {
    var hours = date.hour % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k(date, token, localize2) {
    var hours = date.hour;
    if (hours === 0) hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.minute, { unit: "minute" });
    }
    return lightFormatters_default.m(date, token);
  },
  // Second
  s(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.second, { unit: "second" });
    }
    return lightFormatters_default.s(date, token);
  },
  // Fraction of second
  S(date, token) {
    return lightFormatters_default.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X(date, token) {
    const timezoneOffset = ParseOffsetString(date.offset);
    if (timezoneOffset === null) {
      throw new Error("Invalid timezone offset supplied");
    }
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x(date, token) {
    const timezoneOffset = ParseOffsetString(date.offset);
    if (timezoneOffset === null) {
      throw new Error("Invalid timezone offset supplied");
    }
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O(date, token) {
    const timezoneOffset = ParseOffsetString(date.offset);
    if (timezoneOffset === null) {
      throw new Error("Invalid timezone offset supplied");
    }
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z(date, token) {
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return GetTimeZoneAbbreviation(date.timeZone, date.epochMilliseconds);
      case "zzzz":
      default:
        return GetTimeZoneName(date.timeZone, date.epochMilliseconds);
    }
  }
};
function formatTimezoneShort(offset2, delimiter) {
  var sign = offset2 < 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var offsetMinutes = Math.floor(absOffset / 6e4);
  var hours = Math.floor(offsetMinutes / 60);
  var minutes = offsetMinutes % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  var offsetMinutes = Math.floor(offset2 / 6e4);
  if (offsetMinutes % 60 === 0) {
    var sign = offsetMinutes < 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offsetMinutes) / 60, 2);
  }
  return formatTimezone(offset2, dirtyDelimiter);
}
function formatTimezone(offset2, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset2 < 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var offsetMinutes = Math.floor(absOffset / 6e4);
  var hours = addLeadingZeros(Math.floor(offsetMinutes / 60), 2);
  var minutes = addLeadingZeros(offsetMinutes % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters_default = formatters2;

// src/format/longFormatters.ts
function dateLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
}
function timeLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
}
function dateTimeLongFormatter(pattern, formatLong2) {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters_default = longFormatters;

// src/format/format.ts
var formattingTokensRegExp = /[yQMIdDihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
var formatterMap = {
  a: ["hour"],
  b: ["hour"],
  B: ["hour"],
  d: ["day"],
  G: ["year"],
  h: ["hour"],
  H: ["hour"],
  i: ["year", "month", "day"],
  I: ["year", "month", "day"],
  k: ["hour"],
  K: ["hour"],
  m: ["minute"],
  M: ["month"],
  O: ["offset"],
  p: ["hour", "minute", "second", "millisecond"],
  P: ["year", "month", "day"],
  Q: ["month"],
  s: ["second"],
  S: ["millisecond"],
  u: ["year"],
  x: ["offset"],
  X: ["offset"],
  y: ["year"],
  z: ["timeZone", "epochMilliseconds"]
};
function getFormattersBySlots(slots) {
  const formatters3 = Object.keys(formatterMap);
  const result = formatters3.filter((f) => formatterMap[f].every((s) => slots.includes(s)));
  return result;
}
function pick(object, keys) {
  return keys.reduce((obj, key) => {
    if (object && object.hasOwnProperty(key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
}
function format(date, formatStr) {
  var _a, _b;
  formatStr = String(formatStr);
  if (arguments.length < 2) {
    throw new TypeError("format requires 2 arguments");
  }
  const locale = en_us_locale_default;
  const allowedFormatters = getFormattersBySlots(Object.keys(date));
  const longFormatters2 = pick(longFormatters_default, allowedFormatters);
  const formatters3 = pick(formatters_default, allowedFormatters);
  const longResult = (_a = formatStr.match(longFormattingTokensRegExp)) == null ? void 0 : _a.map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters2[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("");
  const result = (_b = longResult.match(formattingTokensRegExp)) == null ? void 0 : _b.map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    const formatter = formatters3[firstCharacter];
    if (formatter) {
      return formatter(date, substring, locale.localize);
    } else if (Object.keys(formatterMap).includes(firstCharacter)) {
      const needed = formatterMap[firstCharacter];
      const missing = needed.find((n) => !Object.keys(date).includes(n));
      throw new RangeError(
        `Cannot format this type with formatter '${firstCharacter}'. Missing required field '${missing}'`
      );
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

// src/format/index.ts
var format_default = format;

// src/fns/timeFns.ts
var ObjectAssign = Object.assign;
var DISALLOWED_UNITS2 = ["year", "month", "week", "day"];
var MAX_INCREMENTS = {
  hour: 24,
  minute: 60,
  second: 60,
  millisecond: 1e3
};
var timeFns = {
  now(timeZone = DefaultTimeZone()) {
    timeZone = ToTemporalTimeZone(timeZone);
    return TemporalDateTimeToTime(BuiltinTimeZoneGetPlainDateTimeFor(timeZone, SystemUTCEpochMilliSeconds()));
  },
  fromNumbers(hour = 0, minute = 0, second = 0, millisecond = 0) {
    hour = ToIntegerThrowOnInfinity(hour);
    minute = ToIntegerThrowOnInfinity(minute);
    second = ToIntegerThrowOnInfinity(second);
    millisecond = ToIntegerThrowOnInfinity(millisecond);
    RejectTime(hour, minute, second, millisecond);
    return CreateTemporalTime(hour, minute, second, millisecond);
  },
  isValid(time2) {
    return IsTemporalTime(time2);
  },
  assertIsValid(time2) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
  },
  getHour(time2) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    return GetTimeSlots(time2).hour;
  },
  getMinute(time2) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    return GetTimeSlots(time2).minute;
  },
  getSecond(time2) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    return GetTimeSlots(time2).second;
  },
  getMillisecond(time2) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    return GetTimeSlots(time2).millisecond;
  },
  with(time2, temporalTimeLike, options = void 0) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    if (typeof temporalTimeLike !== "object") {
      throw new TypeError("invalid argument");
    }
    if (temporalTimeLike.timeZone !== void 0) {
      throw new TypeError("with() does not support a timeZone property");
    }
    options = GetOptionsObject(options);
    const overflow = ToTemporalOverflow(options);
    const props = ToPartialRecord(temporalTimeLike, [
      "hour",
      "microsecond",
      "millisecond",
      "minute",
      "nanosecond",
      "second"
    ]);
    if (!props) {
      throw new TypeError("invalid time-like");
    }
    const fields = ToTemporalTimeRecord(GetTimeSlots(time2));
    let { hour, minute, second, millisecond } = ObjectAssign(fields, props);
    ({ hour, minute, second, millisecond } = RegulateTime(hour, minute, second, millisecond, overflow));
    return CreateTemporalTime(hour, minute, second, millisecond);
  },
  add(time2, temporalDurationLike) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    const duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    const { hours, minutes, seconds, milliseconds } = duration2;
    let { hour, minute, second, millisecond } = GetTimeSlots(time2);
    ({ hour, minute, second, millisecond } = AddTime(
      hour,
      minute,
      second,
      millisecond,
      hours,
      minutes,
      seconds,
      milliseconds
    ));
    ({ hour, minute, second, millisecond } = RegulateTime(hour, minute, second, millisecond, "reject"));
    return CreateTemporalTime(hour, minute, second, millisecond);
  },
  subtract(time2, temporalDurationLike) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    let duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    const { hours, minutes, seconds, milliseconds } = duration2;
    let { hour, minute, second, millisecond } = GetTimeSlots(time2);
    ({ hour, minute, second, millisecond } = AddTime(
      hour,
      minute,
      second,
      millisecond,
      -hours,
      -minutes,
      -seconds,
      -milliseconds
    ));
    ({ hour, minute, second, millisecond } = RegulateTime(hour, minute, second, millisecond, "reject"));
    return CreateTemporalTime(hour, minute, second, millisecond);
  },
  until(time2, other, options = void 0) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    other = ToTemporalTime(other);
    options = GetOptionsObject(options);
    const largestUnit = ToLargestTemporalUnit(options, "auto", DISALLOWED_UNITS2, "hour");
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond", DISALLOWED_UNITS2);
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, MAX_INCREMENTS[smallestUnit], false);
    const timeSlots = GetTimeSlots(time2);
    const otherSlots = GetTimeSlots(other);
    let { hours, minutes, seconds, milliseconds } = DifferenceTime(
      timeSlots.hour,
      timeSlots.minute,
      timeSlots.second,
      timeSlots.millisecond,
      otherSlots.hour,
      otherSlots.minute,
      otherSlots.second,
      otherSlots.millisecond
    );
    ({ hours, minutes, seconds, milliseconds } = RoundDuration(
      0,
      0,
      0,
      0,
      hours,
      minutes,
      seconds,
      milliseconds,
      roundingIncrement,
      smallestUnit,
      roundingMode
    ));
    ({ hours, minutes, seconds, milliseconds } = BalanceDuration(0, hours, minutes, seconds, milliseconds, largestUnit));
    return CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
  },
  since(time2, other, options = void 0) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    other = ToTemporalTime(other);
    options = GetOptionsObject(options);
    const largestUnit = ToLargestTemporalUnit(options, "auto", DISALLOWED_UNITS2, "hour");
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond", DISALLOWED_UNITS2);
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, MAX_INCREMENTS[smallestUnit], false);
    const timeSlots = GetTimeSlots(time2);
    const otherSlots = GetTimeSlots(other);
    let { hours, minutes, seconds, milliseconds } = DifferenceTime(
      timeSlots.hour,
      timeSlots.minute,
      timeSlots.second,
      timeSlots.millisecond,
      otherSlots.hour,
      otherSlots.minute,
      otherSlots.second,
      otherSlots.millisecond
    );
    ({ hours, minutes, seconds, milliseconds } = RoundDuration(
      0,
      0,
      0,
      0,
      -hours,
      -minutes,
      -seconds,
      -milliseconds,
      roundingIncrement,
      smallestUnit,
      NegateTemporalRoundingMode(roundingMode)
    ));
    hours = -hours;
    minutes = -minutes;
    seconds = -seconds;
    milliseconds = -milliseconds;
    ({ hours, minutes, seconds, milliseconds } = BalanceDuration(0, hours, minutes, seconds, milliseconds, largestUnit));
    return CreateTemporalDuration(0, 0, 0, 0, hours, minutes, seconds, milliseconds);
  },
  round(time2, options) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    if (options === void 0) throw new TypeError("options parameter is required");
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, void 0, DISALLOWED_UNITS2);
    if (smallestUnit === void 0) throw new RangeError("smallestUnit is required");
    const roundingMode = ToTemporalRoundingMode(options, "halfExpand");
    const roundingIncrement = ToTemporalRoundingIncrement(options, MAX_INCREMENTS[smallestUnit], false);
    let { hour, minute, second, millisecond } = GetTimeSlots(time2);
    ({ hour, minute, second, millisecond } = RoundTime(
      hour,
      minute,
      second,
      millisecond,
      roundingIncrement,
      smallestUnit,
      roundingMode
    ));
    return CreateTemporalTime(hour, minute, second, millisecond);
  },
  equals(time2, other) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    if (!IsTemporalTime(other)) throw new TypeError("invalid receiver");
    const slots1 = GetTimeSlots(time2);
    const slots2 = GetTimeSlots(other);
    for (const slot of ["hour", "minute", "second", "millisecond"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 !== val2) return false;
    }
    return true;
  },
  toDateTime(time2, temporalDate) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    temporalDate = ToTemporalDate(temporalDate);
    let { year, month, day } = GetDateSlots(temporalDate);
    let { hour, minute, second, millisecond } = GetTimeSlots(time2);
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  toZonedDateTime(time2, item) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    if (typeof item !== "object") {
      throw new TypeError("invalid argument");
    }
    const dateLike = item.date;
    if (dateLike === void 0) {
      throw new TypeError("missing date property");
    }
    const temporalDate = ToTemporalDate(dateLike);
    const timeZoneLike = item.timeZone;
    if (timeZoneLike === void 0) {
      throw new TypeError("missing timeZone property");
    }
    const timeZone = ToTemporalTimeZone(timeZoneLike);
    const { year, month, day } = GetDateSlots(temporalDate);
    const { hour, minute, second, millisecond } = GetTimeSlots(time2);
    const dt = CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
    const instant2 = BuiltinTimeZoneGetInstantFor(timeZone, dt, "compatible");
    return CreateTemporalZonedDateTime(instant2, timeZone);
  },
  getFields(time2) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    return GetTimeSlots(time2);
  },
  from(item, options = void 0) {
    options = GetOptionsObject(options);
    const overflow = ToTemporalOverflow(options);
    if (IsTemporalTime(item)) {
      const slots = GetTimeSlots(item);
      return CreateTemporalTime(slots.hour, slots.minute, slots.second, slots.millisecond);
    }
    return ToTemporalTime(item, overflow);
  },
  compare(one, two) {
    one = ToTemporalTime(one);
    two = ToTemporalTime(two);
    const slots1 = GetTimeSlots(one);
    const slots2 = GetTimeSlots(two);
    for (const slot of ["hour", "minute", "second", "millisecond"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 !== val2) return ComparisonResult(val1 - val2);
    }
    return 0;
  },
  format(time2, formatString) {
    if (!IsTemporalTime(time2)) throw new TypeError("invalid receiver");
    return format_default(GetTimeSlots(time2), formatString);
  },
  chain: buildTimeChain
};
function buildTimeChain(time2) {
  return {
    value() {
      return time2;
    },
    getHour() {
      return buildChain(timeFns.getHour(time2));
    },
    getMinute() {
      return buildChain(timeFns.getMinute(time2));
    },
    getSecond() {
      return buildChain(timeFns.getSecond(time2));
    },
    getMillisecond() {
      return buildChain(timeFns.getMillisecond(time2));
    },
    with(timeLike, options) {
      return buildTimeChain(timeFns.with(time2, timeLike, options));
    },
    add(temporalDurationLike, options) {
      return buildTimeChain(timeFns.add(time2, temporalDurationLike, options));
    },
    subtract(temporalDurationLike, options) {
      return buildTimeChain(timeFns.subtract(time2, temporalDurationLike, options));
    },
    until(other, options) {
      return buildDurationChain(timeFns.until(time2, other, options));
    },
    since(other, options) {
      return buildDurationChain(timeFns.since(time2, other, options));
    },
    round(options) {
      return buildTimeChain(timeFns.round(time2, options));
    },
    equals(other) {
      return buildChain(timeFns.equals(time2, other));
    },
    toDateTime(date) {
      return buildDateTimeChain(timeFns.toDateTime(time2, date));
    },
    toZonedDateTime(item) {
      return buildZonedDateTimeChain(timeFns.toZonedDateTime(time2, item));
    },
    getFields() {
      return buildChain(timeFns.getFields(time2));
    },
    format(formatString) {
      return buildChain(timeFns.format(time2, formatString));
    }
  };
}

// src/fns/yearMonthFns.ts
var DISALLOWED_UNITS3 = ["week", "day", "hour", "minute", "second", "millisecond"];
var yearMonthFns = {
  fromNumbers(year, month) {
    year = ToIntegerThrowOnInfinity(year);
    month = ToIntegerThrowOnInfinity(month);
    if (arguments.length < 2) {
      throw new RangeError("missing argument: isoYear and isoMonth are required");
    }
    return CreateTemporalYearMonth(year, month);
  },
  isValid(yearMonth) {
    return IsTemporalYearMonth(yearMonth);
  },
  assertIsValid(yearMonth) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
  },
  getYear(yearMonth) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    return CalendarYear(yearMonth);
  },
  getMonth(yearMonth) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    return CalendarMonth(yearMonth);
  },
  getDaysInMonth(yearMonth) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    return CalendarDaysInMonth(yearMonth);
  },
  getDaysInYear(yearMonth) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    return CalendarDaysInYear(yearMonth);
  },
  inLeapYear(yearMonth) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    return CalendarInLeapYear(yearMonth);
  },
  with(yearMonth, temporalYearMonthLike, options = void 0) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    if (typeof temporalYearMonthLike !== "object") {
      throw new TypeError("invalid argument");
    }
    if (temporalYearMonthLike.timeZone !== void 0) {
      throw new TypeError("with() does not support a timeZone property");
    }
    const props = ToPartialRecord(temporalYearMonthLike, ["month", "year"]);
    if (!props) {
      throw new TypeError("invalid year-month-like");
    }
    let fields = ToTemporalYearMonthFields(GetYearMonthSlots(yearMonth));
    fields = CalendarMergeFields(fields, props);
    fields = ToTemporalYearMonthFields(fields);
    options = GetOptionsObject(options);
    return YearMonthFromFields(fields, options);
  },
  add(yearMonth, temporalDurationLike, options = void 0) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    const duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration2;
    ({ days } = BalanceDuration(days, hours, minutes, seconds, milliseconds, "day"));
    options = GetOptionsObject(options);
    const fields = ToTemporalYearMonthFields(GetYearMonthSlots(yearMonth));
    const sign = DurationSign(years, months, weeks, days, 0, 0, 0, 0);
    const day = sign < 0 ? ToPositiveInteger(CalendarDaysInMonth(yearMonth)) : 1;
    const startDate = DateFromFields(__spreadProps(__spreadValues({}, fields), { day }));
    const optionsCopy = __spreadValues({}, options);
    const addedDate = CalendarDateAdd(startDate, __spreadProps(__spreadValues({}, duration2), { days }), options);
    const addedDateFields = ToTemporalYearMonthFields(GetDateSlots(addedDate));
    return YearMonthFromFields(addedDateFields, optionsCopy);
  },
  subtract(yearMonth, temporalDurationLike, options = void 0) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    let duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    duration2 = {
      years: -duration2.years,
      months: -duration2.months,
      weeks: -duration2.weeks,
      days: -duration2.days,
      hours: -duration2.hours,
      minutes: -duration2.minutes,
      seconds: -duration2.seconds,
      milliseconds: -duration2.milliseconds
    };
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration2;
    ({ days } = BalanceDuration(days, hours, minutes, seconds, milliseconds, "day"));
    options = GetOptionsObject(options);
    const fields = ToTemporalYearMonthFields(GetYearMonthSlots(yearMonth));
    const sign = DurationSign(years, months, weeks, days, 0, 0, 0, 0);
    const day = sign < 0 ? ToPositiveInteger(CalendarDaysInMonth(yearMonth)) : 1;
    const startDate = DateFromFields(__spreadProps(__spreadValues({}, fields), { day }));
    const optionsCopy = __spreadValues({}, options);
    const addedDate = CalendarDateAdd(startDate, __spreadProps(__spreadValues({}, duration2), { days }), options);
    const addedDateFields = ToTemporalYearMonthFields(GetDateSlots(addedDate));
    return YearMonthFromFields(addedDateFields, optionsCopy);
  },
  until(yearMonth, other, options = void 0) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    other = ToTemporalYearMonth(other);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "month", DISALLOWED_UNITS3);
    const largestUnit = ToLargestTemporalUnit(options, "auto", DISALLOWED_UNITS3, "year");
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, void 0, false);
    const otherFields = ToTemporalYearMonthFields(GetYearMonthSlots(other));
    const thisFields = ToTemporalYearMonthFields(GetYearMonthSlots(yearMonth));
    const otherDate = DateFromFields(__spreadProps(__spreadValues({}, otherFields), { day: 1 }));
    const thisDate = DateFromFields(__spreadProps(__spreadValues({}, thisFields), { day: 1 }));
    const untilOptions = __spreadProps(__spreadValues({}, options), { largestUnit });
    const result = CalendarDateUntil(thisDate, otherDate, untilOptions);
    if (smallestUnit === "month" && roundingIncrement === 1) return result;
    let { years, months } = GetDurationSlots(result);
    const thisDateSlots = GetDateSlots(thisDate);
    const relativeTo = CreateTemporalDateTime(thisDateSlots.year, thisDateSlots.month, thisDateSlots.day, 0, 0, 0, 0);
    ({ years, months } = RoundDuration(
      years,
      months,
      0,
      0,
      0,
      0,
      0,
      0,
      roundingIncrement,
      smallestUnit,
      roundingMode,
      relativeTo
    ));
    return CreateTemporalDuration(years, months, 0, 0, 0, 0, 0, 0);
  },
  since(yearMonth, other, options = void 0) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    other = ToTemporalYearMonth(other);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "month", DISALLOWED_UNITS3);
    const largestUnit = ToLargestTemporalUnit(options, "auto", DISALLOWED_UNITS3, "year");
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, void 0, false);
    const otherFields = ToTemporalYearMonthFields(GetYearMonthSlots(other));
    const thisFields = ToTemporalYearMonthFields(GetYearMonthSlots(yearMonth));
    const otherDate = DateFromFields(__spreadProps(__spreadValues({}, otherFields), { day: 1 }));
    const thisDate = DateFromFields(__spreadProps(__spreadValues({}, thisFields), { day: 1 }));
    const untilOptions = __spreadProps(__spreadValues({}, options), { largestUnit });
    let { years, months } = GetDurationSlots(CalendarDateUntil(thisDate, otherDate, untilOptions));
    if (smallestUnit === "month" && roundingIncrement === 1) {
      return CreateTemporalDuration(-years, -months, 0, 0, 0, 0, 0, 0);
    }
    const thisDateSlots = GetDateSlots(thisDate);
    const relativeTo = CreateTemporalDateTime(thisDateSlots.year, thisDateSlots.month, thisDateSlots.day, 0, 0, 0, 0);
    ({ years, months } = RoundDuration(
      years,
      months,
      0,
      0,
      0,
      0,
      0,
      0,
      roundingIncrement,
      smallestUnit,
      NegateTemporalRoundingMode(roundingMode),
      relativeTo
    ));
    return CreateTemporalDuration(-years, -months, 0, 0, 0, 0, 0, 0);
  },
  equals(yearMonth, other) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    other = ToTemporalYearMonth(other);
    const slots1 = GetYearMonthSlots(yearMonth);
    const slots2 = GetYearMonthSlots(other);
    for (const slot of ["year", "month"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 !== val2) return false;
    }
    return true;
  },
  isEqual(yearMonth, other) {
    return yearMonthFns.equals(yearMonth, other);
  },
  isBefore(yearMonth, other) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    other = ToTemporalYearMonth(other);
    const slots1 = GetYearMonthSlots(yearMonth);
    const slots2 = GetYearMonthSlots(other);
    for (const slot of ["year", "month"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 < val2) return true;
      else if (val1 > val2) return false;
    }
    return false;
  },
  isAfter(yearMonth, other) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    other = ToTemporalYearMonth(other);
    const slots1 = GetYearMonthSlots(yearMonth);
    const slots2 = GetYearMonthSlots(other);
    for (const slot of ["year", "month"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 > val2) return true;
      else if (val1 < val2) return false;
    }
    return false;
  },
  isEqualOrBefore(yearMonth, other) {
    return yearMonthFns.isEqual(yearMonth, other) || yearMonthFns.isBefore(yearMonth, other);
  },
  isEqualOrAfter(yearMonth, other) {
    return yearMonthFns.isEqual(yearMonth, other) || yearMonthFns.isAfter(yearMonth, other);
  },
  toDate(yearMonth, day) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    if (typeof day !== "number") throw new TypeError("argument should be a number");
    return DateFromFields(
      __spreadProps(__spreadValues({}, GetYearMonthSlots(yearMonth)), {
        day
      }),
      { overflow: "reject" }
    );
  },
  getFields(yearMonth) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    return GetYearMonthSlots(yearMonth);
  },
  from(item, options = void 0) {
    options = GetOptionsObject(options);
    if (IsTemporalYearMonth(item)) {
      ToTemporalOverflow(options);
      const slots = GetYearMonthSlots(item);
      return CreateTemporalYearMonth(slots.year, slots.month);
    }
    return ToTemporalYearMonth(item, options);
  },
  compare(one, two) {
    one = ToTemporalYearMonth(one);
    two = ToTemporalYearMonth(two);
    const slots1 = GetYearMonthSlots(one);
    const slots2 = GetYearMonthSlots(two);
    return CompareISODate(slots1.year, slots1.month, 1, slots2.year, slots2.month, 1);
  },
  format(yearMonth, formatString) {
    if (!IsTemporalYearMonth(yearMonth)) throw new TypeError("invalid receiver");
    return format_default(GetYearMonthSlots(yearMonth), formatString);
  },
  chain: buildYearMonthChain
};
function buildYearMonthChain(yearMonth) {
  return {
    value() {
      return yearMonth;
    },
    getYear() {
      return buildChain(yearMonthFns.getYear(yearMonth));
    },
    getMonth() {
      return buildChain(yearMonthFns.getMonth(yearMonth));
    },
    getDaysInMonth() {
      return buildChain(yearMonthFns.getDaysInMonth(yearMonth));
    },
    getDaysInYear() {
      return buildChain(yearMonthFns.getDaysInYear(yearMonth));
    },
    inLeapYear() {
      return buildChain(yearMonthFns.inLeapYear(yearMonth));
    },
    with(yearMonthLike, options) {
      return buildYearMonthChain(yearMonthFns.with(yearMonth, yearMonthLike, options));
    },
    add(temporalDurationLike, options) {
      return buildYearMonthChain(yearMonthFns.add(yearMonth, temporalDurationLike, options));
    },
    subtract(temporalDurationLike, options) {
      return buildYearMonthChain(yearMonthFns.subtract(yearMonth, temporalDurationLike, options));
    },
    until(other, options) {
      return buildDurationChain(yearMonthFns.until(yearMonth, other, options));
    },
    since(other, options) {
      return buildDurationChain(yearMonthFns.since(yearMonth, other, options));
    },
    equals(other) {
      return buildChain(yearMonthFns.equals(yearMonth, other));
    },
    isEqual(other) {
      return buildChain(yearMonthFns.isEqual(yearMonth, other));
    },
    isBefore(other) {
      return buildChain(yearMonthFns.isBefore(yearMonth, other));
    },
    isAfter(other) {
      return buildChain(yearMonthFns.isAfter(yearMonth, other));
    },
    isEqualOrBefore(other) {
      return buildChain(yearMonthFns.isEqualOrBefore(yearMonth, other));
    },
    isEqualOrAfter(other) {
      return buildChain(yearMonthFns.isEqualOrAfter(yearMonth, other));
    },
    toDate(day) {
      return buildDateChain(yearMonthFns.toDate(yearMonth, day));
    },
    getFields() {
      return buildChain(yearMonthFns.getFields(yearMonth));
    },
    format(formatString) {
      return buildChain(yearMonthFns.format(yearMonth, formatString));
    }
  };
}

// src/fns/monthDayFns.ts
var monthDayFns = {
  fromNumbers(month, day) {
    month = ToIntegerThrowOnInfinity(month);
    day = ToIntegerThrowOnInfinity(day);
    if (arguments.length < 2) {
      throw new RangeError("missing argument: isoMonth and isoDay are required");
    }
    return CreateTemporalMonthDay(month, day);
  },
  isValid(monthDay) {
    return IsTemporalMonthDay(monthDay);
  },
  assertIsValid(monthDay) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
  },
  getDay(monthDay) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
    return CalendarDay(monthDay);
  },
  getMonth(monthDay) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
    return CalendarDay(monthDay);
  },
  with(monthDay, temporalMonthDayLike, options = void 0) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
    if (typeof temporalMonthDayLike !== "object") {
      throw new TypeError("invalid argument");
    }
    if (temporalMonthDayLike.timeZone !== void 0) {
      throw new TypeError("with() does not support a timeZone property");
    }
    const props = ToPartialRecord(temporalMonthDayLike, ["day", "month", "monthCode", "year"]);
    if (!props) {
      throw new TypeError("invalid month-day-like");
    }
    let fields = ToTemporalMonthDayFields(GetMonthDaySlots(monthDay));
    fields = CalendarMergeFields(fields, props);
    fields = ToTemporalMonthDayFields(fields);
    options = GetOptionsObject(options);
    return MonthDayFromFields(fields, options);
  },
  equals(monthDay, other) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
    other = ToTemporalMonthDay(other);
    const slots1 = GetMonthDaySlots(monthDay);
    const slots2 = GetMonthDaySlots(other);
    for (const slot of ["month", "day"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 !== val2) return false;
    }
    return true;
  },
  toDate(monthDay, year) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
    year = ToIntegerThrowOnInfinity(year);
    const { month, day } = GetMonthDaySlots(monthDay);
    RegulateISODate(year, month, day, "reject");
    return CreateTemporalDate(year, month, day);
  },
  getFields(monthDay) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
    return GetMonthDaySlots(monthDay);
  },
  from(item, options = void 0) {
    options = GetOptionsObject(options);
    if (IsTemporalMonthDay(item)) {
      ToTemporalOverflow(options);
      const slots = GetMonthDaySlots(item);
      return CreateTemporalMonthDay(slots.month, slots.day);
    }
    return ToTemporalMonthDay(item, options);
  },
  compare(one, two) {
    if (!IsTemporalMonthDay(one)) throw new TypeError("invalid receiver");
    if (!IsTemporalMonthDay(two)) throw new TypeError("invalid receiver");
    const oneSlots = GetMonthDaySlots(one);
    const twoSlots = GetMonthDaySlots(two);
    return CompareISODate(1972, oneSlots.month, oneSlots.day, 1972, twoSlots.month, twoSlots.day);
  },
  format(monthDay, formatString) {
    if (!IsTemporalMonthDay(monthDay)) throw new TypeError("invalid receiver");
    return format_default(GetMonthDaySlots(monthDay), formatString);
  },
  chain: buildMonthDayChain
};
function buildMonthDayChain(monthDay) {
  return {
    value() {
      return monthDay;
    },
    getDay() {
      return buildChain(monthDayFns.getDay(monthDay));
    },
    getMonth() {
      return buildChain(monthDayFns.getMonth(monthDay));
    },
    with(monthDayLike, options) {
      return buildMonthDayChain(monthDayFns.with(monthDay, monthDayLike, options));
    },
    equals(other) {
      return buildChain(monthDayFns.equals(monthDay, other));
    },
    toDate(year) {
      return buildDateChain(monthDayFns.toDate(monthDay, year));
    },
    getFields() {
      return buildChain(monthDayFns.getFields(monthDay));
    },
    format(formatString) {
      return buildChain(monthDayFns.format(monthDay, formatString));
    }
  };
}

// src/fns/zonedDateTimeFns.ts
var zonedDateTimeFns = {
  now(timeZone = DefaultTimeZone()) {
    timeZone = ToTemporalTimeZone(timeZone);
    return CreateTemporalZonedDateTime(SystemUTCEpochMilliSeconds(), timeZone);
  },
  currentTimeZone() {
    return DefaultTimeZone();
  },
  fromEpochMilliseconds(epochMilliseconds, timeZone) {
    if (arguments.length < 1) {
      throw new TypeError("missing argument: epochMilliseconds is required");
    }
    timeZone = ToTemporalTimeZone(timeZone);
    return CreateTemporalZonedDateTime(epochMilliseconds, timeZone);
  },
  isValid(zonedDateTime) {
    return IsTemporalZonedDateTime(zonedDateTime);
  },
  assertIsValid(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
  },
  getTimeZone(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return GetZonedDateTimeSlots(zonedDateTime).timeZone;
  },
  getYear(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarYear(dateTime(zonedDateTime));
  },
  getMonth(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarMonth(dateTime(zonedDateTime));
  },
  getDay(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarDay(dateTime(zonedDateTime));
  },
  getHour(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime(zonedDateTime)).hour;
  },
  getMinute(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime(zonedDateTime)).minute;
  },
  getSecond(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime(zonedDateTime)).second;
  },
  getMillisecond(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime(zonedDateTime)).millisecond;
  },
  getEpochSeconds(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const { epochMilliseconds } = GetZonedDateTimeSlots(zonedDateTime);
    return Math.floor(+epochMilliseconds / 1e3);
  },
  getEpochMilliseconds(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const { epochMilliseconds } = GetZonedDateTimeSlots(zonedDateTime);
    return epochMilliseconds;
  },
  getDayOfWeek(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarDayOfWeek(dateTime(zonedDateTime));
  },
  getDayOfYear(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarDayOfYear(dateTime(zonedDateTime));
  },
  getWeekOfYear(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarWeekOfYear(dateTime(zonedDateTime));
  },
  getHoursInDay(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const dt = dateTime(zonedDateTime);
    const { year, month, day } = GetDateTimeSlots(dt);
    const today = CreateTemporalDateTime(year, month, day, 0, 0, 0, 0);
    const tomorrowFields = AddISODate(year, month, day, 0, 0, 0, 1, "reject");
    const tomorrow = CreateTemporalDateTime(tomorrowFields.year, tomorrowFields.month, tomorrowFields.day, 0, 0, 0, 0);
    const timeZone = GetSlots(zonedDateTime).timeZone;
    const todayMs = BuiltinTimeZoneGetInstantFor(timeZone, today, "compatible");
    const tomorrowMs = BuiltinTimeZoneGetInstantFor(timeZone, tomorrow, "compatible");
    return (tomorrowMs - todayMs) / 36e5;
  },
  getDaysInMonth(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarDaysInMonth(dateTime(zonedDateTime));
  },
  getDaysInYear(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarDaysInYear(dateTime(zonedDateTime));
  },
  inLeapYear(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CalendarInLeapYear(dateTime(zonedDateTime));
  },
  getOffset(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const slots = GetZonedDateTimeSlots(zonedDateTime);
    return BuiltinTimeZoneGetOffsetStringFor(slots.timeZone, slots.epochMilliseconds);
  },
  getOffsetMilliseconds(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const slots = GetZonedDateTimeSlots(zonedDateTime);
    return GetOffsetMillisecondsFor(slots.timeZone, slots.epochMilliseconds);
  },
  with(zonedDateTime, zonedDateTimeLike, options = {}) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    if (typeof zonedDateTimeLike !== "object") {
      throw new TypeError("invalid zoned-date-time-like");
    }
    if (zonedDateTimeLike["timeZone"] !== void 0) {
      throw new TypeError("timeZone invalid for with(). use withTimeZone()");
    }
    options = GetOptionsObject(options);
    const disambiguation = ToTemporalDisambiguation(options);
    const offset2 = ToTemporalOffset(options, "prefer");
    const timeZone = GetZonedDateTimeSlots(zonedDateTime).timeZone;
    const props = ToPartialRecord(zonedDateTimeLike, [
      "day",
      "hour",
      "millisecond",
      "minute",
      "month",
      "second",
      "year",
      "offset"
    ]);
    if (!props) {
      throw new TypeError("invalid zoned-date-time-like");
    }
    let fields = ToTemporalZonedDateTimeFields(GetZonedDateTimeSlots(zonedDateTime));
    fields = CalendarMergeFields(fields, props);
    fields = ToTemporalZonedDateTimeFields(fields);
    let { year, month, day, hour, minute, second, millisecond } = InterpretTemporalDateTimeFields(fields, options);
    const offsetMs = ParseOffsetString(fields.offset);
    const epochNanoseconds = InterpretISODateTimeOffset(
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond,
      "option",
      offsetMs,
      timeZone,
      disambiguation,
      offset2
    );
    const result = CreateTemporalZonedDateTime(epochNanoseconds, timeZone);
    return result;
  },
  withDate(zonedDateTime, date) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    date = ToTemporalDate(date);
    const { year, month, day } = GetDateSlots(date);
    const thisDt = dateTime(zonedDateTime);
    const { hour, minute, second, millisecond } = GetDateTimeSlots(thisDt);
    const timeZone = GetZonedDateTimeSlots(zonedDateTime).timeZone;
    const dt = CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
    const instant2 = BuiltinTimeZoneGetInstantFor(timeZone, dt, "compatible");
    return CreateTemporalZonedDateTime(instant2, timeZone);
  },
  withTime(zonedDateTime, time2) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const isoTime = time2 == void 0 ? CreateTemporalTime(0, 0, 0, 0) : ToTemporalTime(time2);
    const thisDt = dateTime(zonedDateTime);
    const { year, month, day } = GetDateTimeSlots(thisDt);
    const { hour, minute, second, millisecond } = GetTimeSlots(isoTime);
    const timeZone = GetZonedDateTimeSlots(zonedDateTime).timeZone;
    const dt = CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
    const instant2 = BuiltinTimeZoneGetInstantFor(timeZone, dt, "compatible");
    return CreateTemporalZonedDateTime(instant2, timeZone);
  },
  withTimeZone(zonedDateTime, timeZone) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    timeZone = ToTemporalTimeZone(timeZone);
    const { epochMilliseconds } = GetZonedDateTimeSlots(zonedDateTime);
    return CreateTemporalZonedDateTime(epochMilliseconds, timeZone);
  },
  add(zonedDateTime, temporalDurationLike, options = {}) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    const { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration2;
    options = GetOptionsObject(options);
    const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(zonedDateTime);
    const ms = AddZonedDateTime(
      epochMilliseconds,
      timeZone,
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      options
    );
    return CreateTemporalZonedDateTime(ms, timeZone);
  },
  subtract(zonedDateTime, temporalDurationLike, options = {}) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    const { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration2;
    options = GetOptionsObject(options);
    const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(zonedDateTime);
    const epochNanoseconds = AddZonedDateTime(
      epochMilliseconds,
      timeZone,
      -years,
      -months,
      -weeks,
      -days,
      -hours,
      -minutes,
      -seconds,
      -milliseconds,
      options
    );
    return CreateTemporalZonedDateTime(epochNanoseconds, timeZone);
  },
  until(zonedDateTime, other, options = {}) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    other = ToTemporalZonedDateTime(other);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond");
    const defaultLargestUnit = LargerOfTwoTemporalUnits("hour", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(options, "auto", [], defaultLargestUnit);
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalDateTimeRoundingIncrement(options, smallestUnit);
    const { epochMilliseconds: ms1, timeZone } = GetZonedDateTimeSlots(zonedDateTime);
    const { epochMilliseconds: ms2, timeZone: otherTimeZone } = GetZonedDateTimeSlots(other);
    let years, months, weeks, days, hours, minutes, seconds, milliseconds;
    if (largestUnit !== "year" && largestUnit !== "month" && largestUnit !== "week" && largestUnit !== "day") {
      years = 0;
      months = 0;
      weeks = 0;
      days = 0;
      ({ seconds, milliseconds } = DifferenceInstant(ms1, ms2, roundingIncrement, smallestUnit, roundingMode));
      ({ hours, minutes, seconds, milliseconds } = BalanceDuration(0, 0, 0, seconds, milliseconds, largestUnit));
    } else {
      if (!TimeZoneEquals(timeZone, otherTimeZone)) {
        throw new RangeError(
          "When calculating difference between time zones, largestUnit must be 'hours' or smaller because day lengths can vary between time zones due to DST or time zone offset changes."
        );
      }
      const untilOptions = __spreadProps(__spreadValues({}, options), { largestUnit });
      ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = DifferenceZonedDateTime(
        ms1,
        ms2,
        timeZone,
        largestUnit,
        untilOptions
      ));
      ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = RoundDuration(
        years,
        months,
        weeks,
        days,
        hours,
        minutes,
        seconds,
        milliseconds,
        roundingIncrement,
        smallestUnit,
        roundingMode,
        zonedDateTime
      ));
      ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = AdjustRoundedDurationDays(
        years,
        months,
        weeks,
        days,
        hours,
        minutes,
        seconds,
        milliseconds,
        roundingIncrement,
        smallestUnit,
        roundingMode,
        zonedDateTime
      ));
    }
    return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  },
  since(zonedDateTime, other, options = {}) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    other = ToTemporalZonedDateTime(other);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond");
    const defaultLargestUnit = LargerOfTwoTemporalUnits("hour", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(options, "auto", [], defaultLargestUnit);
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    let roundingMode = ToTemporalRoundingMode(options, "trunc");
    roundingMode = NegateTemporalRoundingMode(roundingMode);
    const roundingIncrement = ToTemporalDateTimeRoundingIncrement(options, smallestUnit);
    const { epochMilliseconds: ms1, timeZone } = GetZonedDateTimeSlots(zonedDateTime);
    const { epochMilliseconds: ms2, timeZone: otherTimeZone } = GetZonedDateTimeSlots(other);
    let years, months, weeks, days, hours, minutes, seconds, milliseconds;
    if (largestUnit !== "year" && largestUnit !== "month" && largestUnit !== "week" && largestUnit !== "day") {
      years = 0;
      months = 0;
      weeks = 0;
      days = 0;
      ({ seconds, milliseconds } = DifferenceInstant(ms1, ms2, roundingIncrement, smallestUnit, roundingMode));
      ({ hours, minutes, seconds, milliseconds } = BalanceDuration(0, 0, 0, seconds, milliseconds, largestUnit));
    } else {
      if (!TimeZoneEquals(timeZone, otherTimeZone)) {
        throw new RangeError(
          "When calculating difference between time zones, largestUnit must be 'hours' or smaller because day lengths can vary between time zones due to DST or time zone offset changes."
        );
      }
      const untilOptions = __spreadProps(__spreadValues({}, options), { largestUnit });
      ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = DifferenceZonedDateTime(
        ms1,
        ms2,
        timeZone,
        largestUnit,
        untilOptions
      ));
      ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = RoundDuration(
        years,
        months,
        weeks,
        days,
        hours,
        minutes,
        seconds,
        milliseconds,
        roundingIncrement,
        smallestUnit,
        roundingMode,
        zonedDateTime
      ));
      ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = AdjustRoundedDurationDays(
        years,
        months,
        weeks,
        days,
        hours,
        minutes,
        seconds,
        milliseconds,
        roundingIncrement,
        smallestUnit,
        roundingMode,
        zonedDateTime
      ));
    }
    return CreateTemporalDuration(-years, -months, -weeks, -days, -hours, -minutes, -seconds, -milliseconds);
  },
  round(zonedDateTime, options) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    if (options === void 0) throw new TypeError("options parameter is required");
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, void 0, ["year", "month", "week"]);
    if (smallestUnit === void 0) throw new RangeError("smallestUnit is required");
    const roundingMode = ToTemporalRoundingMode(options, "halfExpand");
    const maximumIncrements = {
      day: 1,
      hour: 24,
      minute: 60,
      second: 60,
      millisecond: 1e3,
      microsecond: 1e3,
      nanosecond: 1e3
    };
    const roundingIncrement = ToTemporalRoundingIncrement(options, maximumIncrements[smallestUnit], false);
    const dt = dateTime(zonedDateTime);
    let { year, month, day, hour, minute, second, millisecond } = GetDateTimeSlots(dt);
    const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(zonedDateTime);
    const dtStart = CreateTemporalDateTime(year, month, day, 0, 0, 0, 0);
    const instantStart = BuiltinTimeZoneGetInstantFor(timeZone, dtStart, "compatible");
    const endMs = AddZonedDateTime(instantStart, timeZone, 0, 0, 0, 1, 0, 0, 0, 0);
    const dayLengthMs = endMs - instantStart;
    if (dayLengthMs === 0) {
      throw new RangeError("cannot round a ZonedDateTime in a calendar with zero-length days");
    }
    ;
    ({ year, month, day, hour, minute, second, millisecond } = RoundISODateTime(
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond,
      roundingIncrement,
      smallestUnit,
      roundingMode,
      dayLengthMs
    ));
    const offsetNs = GetOffsetMillisecondsFor(timeZone, epochMilliseconds);
    const epochNanoseconds = InterpretISODateTimeOffset(
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond,
      "option",
      offsetNs,
      timeZone,
      "compatible",
      "prefer"
    );
    return CreateTemporalZonedDateTime(epochNanoseconds, timeZone);
  },
  equals(zonedDateTime, other) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    if (!IsTemporalZonedDateTime(other)) throw new TypeError("invalid receiver");
    const one = GetZonedDateTimeSlots(zonedDateTime);
    const two = GetZonedDateTimeSlots(other);
    return one.epochMilliseconds === two.epochMilliseconds && TimeZoneEquals(one.timeZone, two.timeZone);
  },
  startOfDay(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const dt = GetDateTimeSlots(dateTime(zonedDateTime));
    const dtStart = CreateTemporalDateTime(dt.year, dt.month, dt.day, 0, 0, 0, 0);
    const { timeZone } = GetZonedDateTimeSlots(zonedDateTime);
    const instant2 = BuiltinTimeZoneGetInstantFor(timeZone, dtStart, "compatible");
    return CreateTemporalZonedDateTime(instant2, timeZone);
  },
  toInstant(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return CreateTemporalInstant(GetZonedDateTimeSlots(zonedDateTime).epochMilliseconds);
  },
  toDate(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return TemporalDateTimeToDate(dateTime(zonedDateTime));
  },
  toTime(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return TemporalDateTimeToTime(dateTime(zonedDateTime));
  },
  toDateTime(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return dateTime(zonedDateTime);
  },
  toYearMonth(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const fields = ToTemporalYearMonthFields(GetDateTimeSlots(dateTime(zonedDateTime)));
    return YearMonthFromFields(fields);
  },
  toMonthDay(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const fields = ToTemporalMonthDayFields(GetDateTimeSlots(dateTime(zonedDateTime)));
    return MonthDayFromFields(fields);
  },
  getFields(zonedDateTime) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    const dt = GetSlots(dateTime(zonedDateTime));
    const { timeZone, epochMilliseconds } = GetZonedDateTimeSlots(zonedDateTime);
    return {
      day: dt.day,
      hour: dt.hour,
      millisecond: dt.millisecond,
      minute: dt.minute,
      month: dt.month,
      second: dt.second,
      year: dt.year,
      offset: BuiltinTimeZoneGetOffsetStringFor(timeZone, epochMilliseconds),
      timeZone
    };
  },
  from(item, options = {}) {
    options = GetOptionsObject(options);
    if (IsTemporalZonedDateTime(item)) {
      ToTemporalOverflow(options);
      ToTemporalDisambiguation(options);
      ToTemporalOffset(options, "reject");
      const { epochMilliseconds, timeZone } = GetZonedDateTimeSlots(item);
      return CreateTemporalZonedDateTime(epochMilliseconds, timeZone);
    }
    return ToTemporalZonedDateTime(item, options);
  },
  compare(one, two) {
    if (!IsTemporalZonedDateTime(one)) throw new TypeError("invalid receiver");
    if (!IsTemporalZonedDateTime(two)) throw new TypeError("invalid receiver");
    const ms1 = GetZonedDateTimeSlots(one).epochMilliseconds;
    const ms2 = GetZonedDateTimeSlots(two).epochMilliseconds;
    if (ms1 < ms2) return -1;
    if (ms1 > ms2) return 1;
    return 0;
  },
  format(zonedDateTime, formatString) {
    if (!IsTemporalZonedDateTime(zonedDateTime)) throw new TypeError("invalid receiver");
    return format_default(GetZonedDateTimeSlots(zonedDateTime), formatString);
  },
  chain: buildZonedDateTimeChain
};
function dateTime(zdt) {
  const slots = GetZonedDateTimeSlots(zdt);
  return BuiltinTimeZoneGetPlainDateTimeFor(slots.timeZone, slots.epochMilliseconds);
}
function buildZonedDateTimeChain(zonedDateTime) {
  return {
    value() {
      return zonedDateTime;
    },
    getTimeZone() {
      return buildChain(zonedDateTimeFns.getTimeZone(zonedDateTime));
    },
    getYear() {
      return buildChain(zonedDateTimeFns.getYear(zonedDateTime));
    },
    getMonth() {
      return buildChain(zonedDateTimeFns.getMonth(zonedDateTime));
    },
    getDay() {
      return buildChain(zonedDateTimeFns.getDay(zonedDateTime));
    },
    getHour() {
      return buildChain(zonedDateTimeFns.getHour(zonedDateTime));
    },
    getMinute() {
      return buildChain(zonedDateTimeFns.getMinute(zonedDateTime));
    },
    getSecond() {
      return buildChain(zonedDateTimeFns.getSecond(zonedDateTime));
    },
    getMillisecond() {
      return buildChain(zonedDateTimeFns.getMillisecond(zonedDateTime));
    },
    getEpochSeconds() {
      return buildChain(zonedDateTimeFns.getEpochSeconds(zonedDateTime));
    },
    getEpochMilliseconds() {
      return buildChain(zonedDateTimeFns.getEpochMilliseconds(zonedDateTime));
    },
    getDayOfWeek() {
      return buildChain(zonedDateTimeFns.getDayOfWeek(zonedDateTime));
    },
    getDayOfYear() {
      return buildChain(zonedDateTimeFns.getDayOfYear(zonedDateTime));
    },
    getWeekOfYear() {
      return buildChain(zonedDateTimeFns.getWeekOfYear(zonedDateTime));
    },
    getHoursInDay() {
      return buildChain(zonedDateTimeFns.getHoursInDay(zonedDateTime));
    },
    getDaysInMonth() {
      return buildChain(zonedDateTimeFns.getDaysInMonth(zonedDateTime));
    },
    getDaysInYear() {
      return buildChain(zonedDateTimeFns.getDaysInYear(zonedDateTime));
    },
    inLeapYear() {
      return buildChain(zonedDateTimeFns.inLeapYear(zonedDateTime));
    },
    getOffset() {
      return buildChain(zonedDateTimeFns.getOffset(zonedDateTime));
    },
    getOffsetMilliseconds() {
      return buildChain(zonedDateTimeFns.getOffsetMilliseconds(zonedDateTime));
    },
    with(zonedDateTimeLike, options = {}) {
      return buildZonedDateTimeChain(zonedDateTimeFns.with(zonedDateTime, zonedDateTimeLike, options));
    },
    withDate(date) {
      return buildZonedDateTimeChain(zonedDateTimeFns.withDate(zonedDateTime, date));
    },
    withTime(time2) {
      return buildZonedDateTimeChain(zonedDateTimeFns.withTime(zonedDateTime, time2));
    },
    withTimeZone(timeZone) {
      return buildZonedDateTimeChain(zonedDateTimeFns.withTimeZone(zonedDateTime, timeZone));
    },
    add(temporalDurationLike, options) {
      return buildZonedDateTimeChain(zonedDateTimeFns.add(zonedDateTime, temporalDurationLike, options));
    },
    subtract(temporalDurationLike, options) {
      return buildZonedDateTimeChain(zonedDateTimeFns.subtract(zonedDateTime, temporalDurationLike, options));
    },
    until(other, options) {
      return buildDurationChain(zonedDateTimeFns.until(zonedDateTime, other, options));
    },
    since(other, options) {
      return buildDurationChain(zonedDateTimeFns.since(zonedDateTime, other, options));
    },
    round(options) {
      return buildZonedDateTimeChain(zonedDateTimeFns.round(zonedDateTime, options));
    },
    equals(other) {
      return buildChain(zonedDateTimeFns.equals(zonedDateTime, other));
    },
    startOfDay() {
      return buildZonedDateTimeChain(zonedDateTimeFns.startOfDay(zonedDateTime));
    },
    toInstant() {
      return buildInstantChain(zonedDateTimeFns.toInstant(zonedDateTime));
    },
    toDate() {
      return buildDateChain(zonedDateTimeFns.toDate(zonedDateTime));
    },
    toTime() {
      return buildTimeChain(zonedDateTimeFns.toTime(zonedDateTime));
    },
    toDateTime() {
      return buildDateTimeChain(zonedDateTimeFns.toDateTime(zonedDateTime));
    },
    toYearMonth() {
      return buildYearMonthChain(zonedDateTimeFns.toYearMonth(zonedDateTime));
    },
    toMonthDay() {
      return buildMonthDayChain(zonedDateTimeFns.toMonthDay(zonedDateTime));
    },
    getFields() {
      return buildChain(zonedDateTimeFns.getFields(zonedDateTime));
    },
    format(formatString) {
      return buildChain(zonedDateTimeFns.format(zonedDateTime, formatString));
    }
  };
}

// src/fns/dateTimeFns.ts
var dateTimeFns = {
  now(timeZone = DefaultTimeZone()) {
    timeZone = ToTemporalTimeZone(timeZone);
    return BuiltinTimeZoneGetPlainDateTimeFor(timeZone, SystemUTCEpochMilliSeconds());
  },
  fromNumbers(year, month, day, hour = 0, minute = 0, second = 0, millisecond = 0) {
    year = ToIntegerThrowOnInfinity(year);
    month = ToIntegerThrowOnInfinity(month);
    day = ToIntegerThrowOnInfinity(day);
    hour = ToIntegerThrowOnInfinity(hour);
    minute = ToIntegerThrowOnInfinity(minute);
    second = ToIntegerThrowOnInfinity(second);
    millisecond = ToIntegerThrowOnInfinity(millisecond);
    if (arguments.length < 3) {
      throw new RangeError("missing argument: isoYear, isoMonth and isoDay are required");
    }
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  isValid(dateTime2) {
    return IsTemporalDateTime(dateTime2);
  },
  assertIsValid(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
  },
  getYear(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarYear(dateTime2);
  },
  getMonth(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarMonth(dateTime2);
  },
  getDay(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarDay(dateTime2);
  },
  getHour(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime2).hour;
  },
  getMinute(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime2).minute;
  },
  getSecond(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime2).second;
  },
  getMillisecond(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime2).millisecond;
  },
  getDayOfWeek(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarDayOfWeek(dateTime2);
  },
  getDayOfYear(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarDayOfYear(dateTime2);
  },
  getWeekOfYear(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarWeekOfYear(dateTime2);
  },
  getDaysInYear(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarDaysInYear(dateTime2);
  },
  getDaysInMonth(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarDaysInMonth(dateTime2);
  },
  getInLeapYear(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return CalendarInLeapYear(dateTime2);
  },
  with(dateTime2, temporalDateTimeLike, options = {}) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    if (typeof temporalDateTimeLike !== "object") {
      throw new TypeError("invalid argument");
    }
    if (temporalDateTimeLike["timeZone"] !== void 0) {
      throw new TypeError("withFields() does not support a timeZone property");
    }
    options = GetOptionsObject(options);
    const props = ToPartialRecord(temporalDateTimeLike, [
      "day",
      "hour",
      "millisecond",
      "minute",
      "month",
      "second",
      "year"
    ]);
    if (!props) {
      throw new TypeError("invalid date-time-like");
    }
    let fields = ToTemporalDateTimeFields(GetDateTimeSlots(dateTime2));
    fields = CalendarMergeFields(fields, props);
    fields = ToTemporalDateTimeFields(fields);
    const { year, month, day, hour, minute, second, millisecond } = InterpretTemporalDateTimeFields(fields, options);
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  withTime(dateTime2, time2 = void 0) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    const { year, month, day } = GetDateTimeSlots(dateTime2);
    if (time2 === void 0) return CreateTemporalDateTime(year, month, day, 0, 0, 0, 0);
    time2 = ToTemporalTime(time2);
    const { hour, minute, second, millisecond } = GetTimeSlots(time2);
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  withDate(dateTime2, temporalDate) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    temporalDate = ToTemporalDate(temporalDate);
    const { year, month, day } = GetDateSlots(temporalDate);
    const { hour, minute, second, millisecond } = GetDateTimeSlots(dateTime2);
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  add(dateTime2, temporalDurationLike, options = {}) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    let duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration2;
    options = GetOptionsObject(options);
    const mySlots = GetDateTimeSlots(dateTime2);
    const { year, month, day, hour, minute, second, millisecond } = AddDateTime(
      mySlots.year,
      mySlots.month,
      mySlots.day,
      mySlots.hour,
      mySlots.minute,
      mySlots.second,
      mySlots.millisecond,
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      options
    );
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  subtract(dateTime2, temporalDurationLike, options = {}) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    let duration2 = ToLimitedTemporalDuration(temporalDurationLike);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration2;
    options = GetOptionsObject(options);
    const mySlots = GetDateTimeSlots(dateTime2);
    const { year, month, day, hour, minute, second, millisecond } = AddDateTime(
      mySlots.year,
      mySlots.month,
      mySlots.day,
      mySlots.hour,
      mySlots.minute,
      mySlots.second,
      mySlots.millisecond,
      -years,
      -months,
      -weeks,
      -days,
      -hours,
      -minutes,
      -seconds,
      -milliseconds,
      options
    );
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  until(from, until, options = {}) {
    if (!IsTemporalDateTime(from)) throw new TypeError("invalid receiver");
    until = ToTemporalDateTime(until);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond");
    const defaultLargestUnit = LargerOfTwoTemporalUnits("day", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(options, "auto", [], defaultLargestUnit);
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalDateTimeRoundingIncrement(options, smallestUnit);
    const thisSlots = GetDateTimeSlots(from);
    const untilSlots = GetDateTimeSlots(until);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = DifferenceISODateTime(
      thisSlots.year,
      thisSlots.month,
      thisSlots.day,
      thisSlots.hour,
      thisSlots.minute,
      thisSlots.second,
      thisSlots.millisecond,
      untilSlots.year,
      untilSlots.month,
      untilSlots.day,
      untilSlots.hour,
      untilSlots.minute,
      untilSlots.second,
      untilSlots.millisecond,
      largestUnit,
      options
    );
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = RoundDuration(
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      roundingIncrement,
      smallestUnit,
      roundingMode,
      from
    ));
    ({ days, hours, minutes, seconds, milliseconds } = BalanceDuration(
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      largestUnit
    ));
    return CreateTemporalDuration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
  },
  since(dateTime2, other, options = {}) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    other = ToTemporalDateTime(other);
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "millisecond");
    const defaultLargestUnit = LargerOfTwoTemporalUnits("day", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(options, "auto", [], defaultLargestUnit);
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalDateTimeRoundingIncrement(options, smallestUnit);
    const thisSlots = GetDateTimeSlots(dateTime2);
    const untilSlots = GetDateTimeSlots(other);
    let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = DifferenceISODateTime(
      thisSlots.year,
      thisSlots.month,
      thisSlots.day,
      thisSlots.hour,
      thisSlots.minute,
      thisSlots.second,
      thisSlots.millisecond,
      untilSlots.year,
      untilSlots.month,
      untilSlots.day,
      untilSlots.hour,
      untilSlots.minute,
      untilSlots.second,
      untilSlots.millisecond,
      largestUnit,
      options
    );
    ({ years, months, weeks, days, hours, minutes, seconds, milliseconds } = RoundDuration(
      years,
      months,
      weeks,
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      roundingIncrement,
      smallestUnit,
      NegateTemporalRoundingMode(roundingMode),
      dateTime2
    ));
    ({ days, hours, minutes, seconds, milliseconds } = BalanceDuration(
      days,
      hours,
      minutes,
      seconds,
      milliseconds,
      largestUnit
    ));
    return CreateTemporalDuration(-years, -months, -weeks, -days, -hours, -minutes, -seconds, -milliseconds);
  },
  round(dateTime2, options) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    if (options === void 0) throw new TypeError("options parameter is required");
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, void 0, ["year", "month", "week"]);
    if (smallestUnit === void 0) throw new RangeError("smallestUnit is required");
    const roundingMode = ToTemporalRoundingMode(options, "halfExpand");
    const maximumIncrements = {
      day: 1,
      hour: 24,
      minute: 60,
      second: 60,
      millisecond: 1e3
    };
    const roundingIncrement = ToTemporalRoundingIncrement(options, maximumIncrements[smallestUnit], false);
    let { year, month, day, hour, minute, second, millisecond } = GetDateTimeSlots(dateTime2);
    ({ year, month, day, hour, minute, second, millisecond } = RoundISODateTime(
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond,
      roundingIncrement,
      smallestUnit,
      roundingMode
    ));
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  equals(dateTime2, other) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    if (!IsTemporalDateTime(other)) throw new TypeError("invalid receiver");
    const slots1 = GetDateTimeSlots(dateTime2);
    const slots2 = GetDateTimeSlots(other);
    for (const slot of ["year", "month", "day", "hour", "minute", "second", "millisecond"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 !== val2) return false;
    }
    return true;
  },
  isEqual(dateTime2, other) {
    return dateTimeFns.equals(dateTime2, other);
  },
  isBefore(dateTime2, other) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    if (!IsTemporalDateTime(other)) throw new TypeError("invalid receiver");
    const slots1 = GetDateTimeSlots(dateTime2);
    const slots2 = GetDateTimeSlots(other);
    for (const slot of ["year", "month", "day", "hour", "minute", "second", "millisecond"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 < val2) return true;
      else if (val1 > val2) return false;
    }
    return false;
  },
  isAfter(dateTime2, other) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    if (!IsTemporalDateTime(other)) throw new TypeError("invalid receiver");
    const slots1 = GetDateTimeSlots(dateTime2);
    const slots2 = GetDateTimeSlots(other);
    for (const slot of ["year", "month", "day", "hour", "minute", "second", "millisecond"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 > val2) return true;
      else if (val1 < val2) return false;
    }
    return false;
  },
  isEqualOrBefore(dateTime2, other) {
    return dateTimeFns.isEqual(dateTime2, other) || dateTimeFns.isBefore(dateTime2, other);
  },
  isEqualOrAfter(dateTime2, other) {
    return dateTimeFns.isEqual(dateTime2, other) || dateTimeFns.isAfter(dateTime2, other);
  },
  toZonedDateTime(dateTime2, timeZone, options) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    timeZone = ToTemporalTimeZone(timeZone);
    options = GetOptionsObject(options);
    const disambiguation = ToTemporalDisambiguation(options);
    const instant2 = BuiltinTimeZoneGetInstantFor(timeZone, dateTime2, disambiguation);
    return CreateTemporalZonedDateTime(instant2, timeZone);
  },
  toDate(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return TemporalDateTimeToDate(dateTime2);
  },
  toYearMonth(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    const fields = ToTemporalYearMonthFields(GetDateTimeSlots(dateTime2));
    return YearMonthFromFields(fields);
  },
  toMonthDay(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    const fields = ToTemporalMonthDayFields(GetDateTimeSlots(dateTime2));
    return MonthDayFromFields(fields);
  },
  toTime(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return TemporalDateTimeToTime(dateTime2);
  },
  getFields(dateTime2) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return GetDateTimeSlots(dateTime2);
  },
  from(item, options) {
    options = GetOptionsObject(options);
    if (IsTemporalDateTime(item)) {
      ToTemporalOverflow(options);
      const slots = GetDateTimeSlots(item);
      return CreateTemporalDateTime(
        slots.year,
        slots.month,
        slots.day,
        slots.hour,
        slots.minute,
        slots.second,
        slots.millisecond
      );
    }
    return ToTemporalDateTime(item, options);
  },
  compare(one, two) {
    if (!IsTemporalDateTime(one)) throw new TypeError("invalid receiver");
    if (!IsTemporalDateTime(two)) throw new TypeError("invalid receiver");
    const slots1 = GetDateTimeSlots(one);
    const slots2 = GetDateTimeSlots(two);
    for (const slot of ["year", "month", "day", "hour", "minute", "second", "millisecond"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 !== val2) return ComparisonResult(val1 - val2);
    }
    return 0;
  },
  format(dateTime2, formatString) {
    if (!IsTemporalDateTime(dateTime2)) throw new TypeError("invalid receiver");
    return format_default(GetDateTimeSlots(dateTime2), formatString);
  },
  chain: buildDateTimeChain
};
function buildDateTimeChain(dateTime2) {
  return {
    value() {
      return dateTime2;
    },
    getYear() {
      return buildChain(dateTimeFns.getYear(dateTime2));
    },
    getMonth() {
      return buildChain(dateTimeFns.getMonth(dateTime2));
    },
    getDay() {
      return buildChain(dateTimeFns.getDay(dateTime2));
    },
    getHour() {
      return buildChain(dateTimeFns.getHour(dateTime2));
    },
    getMinute() {
      return buildChain(dateTimeFns.getMinute(dateTime2));
    },
    getSecond() {
      return buildChain(dateTimeFns.getSecond(dateTime2));
    },
    getMillisecond() {
      return buildChain(dateTimeFns.getMillisecond(dateTime2));
    },
    getDayOfWeek() {
      return buildChain(dateTimeFns.getDayOfWeek(dateTime2));
    },
    getDayOfYear() {
      return buildChain(dateTimeFns.getDayOfYear(dateTime2));
    },
    getWeekOfYear() {
      return buildChain(dateTimeFns.getWeekOfYear(dateTime2));
    },
    getDaysInYear() {
      return buildChain(dateTimeFns.getDaysInYear(dateTime2));
    },
    getDaysInMonth() {
      return buildChain(dateTimeFns.getDaysInMonth(dateTime2));
    },
    getInLeapYear() {
      return buildChain(dateTimeFns.getInLeapYear(dateTime2));
    },
    with(temporalDateTimeLike, options) {
      return buildDateTimeChain(dateTimeFns.with(dateTime2, temporalDateTimeLike, options));
    },
    withTime(time2) {
      return buildDateTimeChain(dateTimeFns.withTime(dateTime2, time2));
    },
    withDate(temporalDate) {
      return buildDateTimeChain(dateTimeFns.withDate(dateTime2, temporalDate));
    },
    add(temporalDurationLike, options) {
      return buildDateTimeChain(dateTimeFns.add(dateTime2, temporalDurationLike, options));
    },
    subtract(temporalDurationLike, options) {
      return buildDateTimeChain(dateTimeFns.subtract(dateTime2, temporalDurationLike, options));
    },
    until(until, options) {
      return buildDurationChain(dateTimeFns.until(dateTime2, until, options));
    },
    since(other, options) {
      return buildDurationChain(dateTimeFns.since(dateTime2, other, options));
    },
    round(options) {
      return buildDateTimeChain(dateTimeFns.round(dateTime2, options));
    },
    equals(other) {
      return buildChain(dateTimeFns.equals(dateTime2, other));
    },
    isEqual(other) {
      return buildChain(dateTimeFns.isEqual(dateTime2, other));
    },
    isBefore(other) {
      return buildChain(dateTimeFns.isBefore(dateTime2, other));
    },
    isAfter(other) {
      return buildChain(dateTimeFns.isBefore(dateTime2, other));
    },
    isEqualOrBefore(other) {
      return buildChain(dateTimeFns.isEqualOrBefore(dateTime2, other));
    },
    isEqualOrAfter(other) {
      return buildChain(dateTimeFns.isEqualOrAfter(dateTime2, other));
    },
    toZonedDateTime(timeZone, options) {
      return buildZonedDateTimeChain(dateTimeFns.toZonedDateTime(dateTime2, timeZone, options));
    },
    toDate() {
      return buildDateChain(dateTimeFns.toDate(dateTime2));
    },
    toYearMonth() {
      return buildYearMonthChain(dateTimeFns.toYearMonth(dateTime2));
    },
    toMonthDay() {
      return buildMonthDayChain(dateTimeFns.toMonthDay(dateTime2));
    },
    toTime() {
      return buildTimeChain(dateTimeFns.toTime(dateTime2));
    },
    getFields() {
      return buildChain(dateTimeFns.getFields(dateTime2));
    },
    format(formatString) {
      return buildChain(dateTimeFns.format(dateTime2, formatString));
    }
  };
}

// src/fns/dateFns.ts
var DISALLOWED_UNITS4 = ["hour", "minute", "second", "millisecond"];
var dateFns = {
  now(timeZone = DefaultTimeZone()) {
    timeZone = ToTemporalTimeZone(timeZone);
    return TemporalDateTimeToDate(BuiltinTimeZoneGetPlainDateTimeFor(timeZone, SystemUTCEpochMilliSeconds()));
  },
  fromNumbers(year, month, day) {
    year = ToIntegerThrowOnInfinity(year);
    month = ToIntegerThrowOnInfinity(month);
    day = ToIntegerThrowOnInfinity(day);
    if (arguments.length < 3) {
      throw new RangeError("missing argument: isoYear, isoMonth and isoDay are required");
    }
    return CreateTemporalDate(year, month, day);
  },
  isValid(date) {
    return IsTemporalDate(date);
  },
  assertIsValid(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
  },
  getYear(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarYear(date);
  },
  getMonth(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarMonth(date);
  },
  getDay(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarDay(date);
  },
  getDayOfWeek(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarDayOfWeek(date);
  },
  getDayOfYear(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarDayOfYear(date);
  },
  getWeekOfYear(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarWeekOfYear(date);
  },
  getDaysInMonth(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarDaysInMonth(date);
  },
  getDaysInYear(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarDaysInYear(date);
  },
  inLeapYear(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return CalendarInLeapYear(date);
  },
  with(date, temporalDateLike, options = void 0) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    if (typeof temporalDateLike !== "object") {
      throw new TypeError("invalid argument");
    }
    if (temporalDateLike.timeZone !== void 0) {
      throw new TypeError("with() does not support a timeZone property");
    }
    const props = ToPartialRecord(temporalDateLike, ["day", "month", "year"]);
    if (!props) {
      throw new TypeError("invalid date-like");
    }
    let fields = ToTemporalDateFields(GetDateSlots(date));
    fields = CalendarMergeFields(fields, props);
    fields = ToTemporalDateFields(fields);
    options = GetOptionsObject(options);
    return DateFromFields(fields, options);
  },
  add(date, temporalDurationLike, options = void 0) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    const duration2 = ToTemporalDuration(temporalDurationLike);
    options = GetOptionsObject(options);
    return CalendarDateAdd(date, duration2, options);
  },
  subtract(date, temporalDurationLike, options = void 0) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    const duration2 = CreateNegatedTemporalDuration(ToTemporalDuration(temporalDurationLike));
    options = GetOptionsObject(options);
    return CalendarDateAdd(date, duration2, options);
  },
  until(date, other, options = void 0) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    if (!IsTemporalDate(other)) throw new TypeError("invalid receiver");
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "day", DISALLOWED_UNITS4);
    const defaultLargestUnit = LargerOfTwoTemporalUnits("day", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(
      options,
      "auto",
      DISALLOWED_UNITS4,
      defaultLargestUnit
    );
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, void 0, false);
    const untilOptions = __spreadProps(__spreadValues({}, options), { largestUnit });
    const result = CalendarDateUntil(date, other, untilOptions);
    if (smallestUnit === "day" && roundingIncrement === 1) return result;
    let { years, months, weeks, days } = GetDurationSlots(result);
    const dateSlots = GetDateSlots(date);
    const relativeTo = CreateTemporalDateTime(dateSlots.year, dateSlots.month, dateSlots.day, 0, 0, 0, 0);
    ({ years, months, weeks, days } = RoundDuration(
      years,
      months,
      weeks,
      days,
      0,
      0,
      0,
      0,
      roundingIncrement,
      smallestUnit,
      roundingMode,
      relativeTo
    ));
    return CreateTemporalDuration(years, months, weeks, days, 0, 0, 0, 0);
  },
  since(date, other, options = void 0) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    if (!IsTemporalDate(other)) throw new TypeError("invalid receiver");
    options = GetOptionsObject(options);
    const smallestUnit = ToSmallestTemporalUnit(options, "day", DISALLOWED_UNITS4);
    const defaultLargestUnit = LargerOfTwoTemporalUnits("day", smallestUnit);
    const largestUnit = ToLargestTemporalUnit(
      options,
      "auto",
      DISALLOWED_UNITS4,
      defaultLargestUnit
    );
    ValidateTemporalUnitRange(largestUnit, smallestUnit);
    const roundingMode = ToTemporalRoundingMode(options, "trunc");
    const roundingIncrement = ToTemporalRoundingIncrement(options, void 0, false);
    const untilOptions = __spreadProps(__spreadValues({}, options), { largestUnit });
    let { years, months, weeks, days } = GetDurationSlots(CalendarDateUntil(date, other, untilOptions));
    if (smallestUnit === "day" && roundingIncrement === 1) {
      return CreateTemporalDuration(-years, -months, -weeks, -days, 0, 0, 0, 0);
    }
    const dateSlots = GetDateSlots(date);
    const relativeTo = CreateTemporalDateTime(dateSlots.year, dateSlots.month, dateSlots.day, 0, 0, 0, 0);
    ({ years, months, weeks, days } = RoundDuration(
      years,
      months,
      weeks,
      days,
      0,
      0,
      0,
      0,
      roundingIncrement,
      smallestUnit,
      NegateTemporalRoundingMode(roundingMode),
      relativeTo
    ));
    return CreateTemporalDuration(-years, -months, -weeks, -days, 0, 0, 0, 0);
  },
  equals(date, other) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    if (!IsTemporalDate(other)) throw new TypeError("invalid receiver");
    const slots1 = GetSlots(date);
    const slots2 = GetSlots(other);
    for (const slot of ["year", "month", "day"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 !== val2) return false;
    }
    return true;
  },
  isEqual(date, other) {
    return dateFns.equals(date, other);
  },
  isBefore(date, other) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    if (!IsTemporalDate(other)) throw new TypeError("invalid receiver");
    const slots1 = GetSlots(date);
    const slots2 = GetSlots(other);
    for (const slot of ["year", "month", "day"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 < val2) return true;
      else if (val1 > val2) return false;
    }
    return false;
  },
  isAfter(date, other) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    if (!IsTemporalDate(other)) throw new TypeError("invalid receiver");
    const slots1 = GetSlots(date);
    const slots2 = GetSlots(other);
    for (const slot of ["year", "month", "day"]) {
      const val1 = slots1[slot];
      const val2 = slots2[slot];
      if (val1 > val2) return true;
      else if (val1 < val2) return false;
    }
    return false;
  },
  isEqualOrBefore(date, other) {
    return dateFns.isEqual(date, other) || dateFns.isBefore(date, other);
  },
  isEqualOrAfter(date, other) {
    return dateFns.isEqual(date, other) || dateFns.isAfter(date, other);
  },
  toDateTime(date, time2 = void 0) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    const { year, month, day } = GetDateSlots(date);
    if (time2 === void 0) return CreateTemporalDateTime(year, month, day, 0, 0, 0, 0);
    time2 = ToTemporalTime(time2);
    const { hour, minute, second, millisecond } = GetTimeSlots(time2);
    return CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
  },
  toZonedDateTime(date, item) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    if (typeof item !== "object") throw new TypeError("invalid receiver");
    const timeZone = ToTemporalTimeZone(item.timeZone);
    if (!IsTemporalTimeZone(timeZone)) throw new TypeError("invalid receiver");
    const { year, month, day } = GetDateSlots(date);
    let hour = 0, minute = 0, second = 0, millisecond = 0, microsecond = 0, nanosecond = 0;
    if (item.time !== void 0) {
      const time2 = ToTemporalTime(item.time);
      ({ hour, minute, second, millisecond } = GetTimeSlots(time2));
    }
    const dt = CreateTemporalDateTime(year, month, day, hour, minute, second, millisecond);
    const instant2 = BuiltinTimeZoneGetInstantFor(timeZone, dt, "compatible");
    return CreateTemporalZonedDateTime(instant2, timeZone);
  },
  toYearMonth(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    const fields = ToTemporalYearMonthFields(GetDateSlots(date));
    return YearMonthFromFields(fields);
  },
  toMonthDay(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    const fields = ToTemporalMonthDayFields(GetDateSlots(date));
    return MonthDayFromFields(fields);
  },
  getFields(date) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return GetDateSlots(date);
  },
  from(item, options = void 0) {
    options = GetOptionsObject(options);
    if (IsTemporalDate(item)) {
      ToTemporalOverflow(options);
      const { year, month, day } = GetDateSlots(item);
      return CreateTemporalDate(year, month, day);
    }
    return ToTemporalDate(item, options);
  },
  compare(one, two) {
    if (!IsTemporalDate(one)) throw new TypeError("invalid receiver");
    if (!IsTemporalDate(two)) throw new TypeError("invalid receiver");
    const oneSlots = GetDateSlots(one);
    const twoSlots = GetDateSlots(two);
    return CompareISODate(oneSlots.year, oneSlots.month, oneSlots.day, twoSlots.year, twoSlots.month, twoSlots.day);
  },
  format(date, formatString) {
    if (!IsTemporalDate(date)) throw new TypeError("invalid receiver");
    return format_default(GetDateSlots(date), formatString);
  },
  chain: buildDateChain
};
function buildDateChain(date) {
  return {
    value() {
      return date;
    },
    getYear() {
      return buildChain(dateFns.getYear(date));
    },
    getMonth() {
      return buildChain(dateFns.getMonth(date));
    },
    getDay() {
      return buildChain(dateFns.getDay(date));
    },
    getDayOfWeek() {
      return buildChain(dateFns.getDayOfWeek(date));
    },
    getDayOfYear() {
      return buildChain(dateFns.getDayOfYear(date));
    },
    getWeekOfYear() {
      return buildChain(dateFns.getWeekOfYear(date));
    },
    getDaysInMonth() {
      return buildChain(dateFns.getDaysInMonth(date));
    },
    getDaysInYear() {
      return buildChain(dateFns.getDaysInYear(date));
    },
    inLeapYear() {
      return buildChain(dateFns.inLeapYear(date));
    },
    with(temporalDateLike, options) {
      return buildDateChain(dateFns.with(date, temporalDateLike, options));
    },
    add(temporalDurationLike, options) {
      return buildDateChain(dateFns.add(date, temporalDurationLike, options));
    },
    subtract(temporalDurationLike, options) {
      return buildDateChain(dateFns.subtract(date, temporalDurationLike, options));
    },
    until(other, options) {
      return buildDurationChain(dateFns.until(date, other, options));
    },
    since(other, options) {
      return buildDurationChain(dateFns.since(date, other, options));
    },
    equals(other) {
      return buildChain(dateFns.equals(date, other));
    },
    isEqual(other) {
      return buildChain(dateFns.isEqual(date, other));
    },
    isBefore(other) {
      return buildChain(dateFns.isBefore(date, other));
    },
    isAfter(other) {
      return buildChain(dateFns.isAfter(date, other));
    },
    isEqualOrBefore(other) {
      return buildChain(dateFns.isEqualOrBefore(date, other));
    },
    isEqualOrAfter(other) {
      return buildChain(dateFns.isEqualOrAfter(date, other));
    },
    toDateTime(time2) {
      return buildDateTimeChain(dateFns.toDateTime(date, time2));
    },
    toZonedDateTime(item) {
      return buildZonedDateTimeChain(dateFns.toZonedDateTime(date, item));
    },
    toYearMonth() {
      return buildYearMonthChain(dateFns.toYearMonth(date));
    },
    toMonthDay() {
      return buildMonthDayChain(dateFns.toMonthDay(date));
    },
    getFields() {
      return buildChain(dateFns.getFields(date));
    },
    format(formatString) {
      return buildChain(dateFns.format(date, formatString));
    }
  };
}
export {
  dateFns,
  dateTimeFns,
  durationFns,
  instantFns,
  monthDayFns,
  timeFns,
  yearMonthFns,
  zonedDateTimeFns
};
